'use strict';

import DetailTracker from '../MetricsTracker/detail/metrics';
import CategoryTracker from '../MetricsTracker/categories/metrics'
import FooterTracker from '../MetricsTracker/footer/metrics';
import { buildGridGallery } from '../utils/pricetravel/detail/helpers';
import { getHeaders } from '../utils/pricetravel/shared/tokenUtil';
import { matchFamilyRule, paxRateFamily } from '../utils/pricetravel/shared/utilsFamily';
import { RoomGrouper } from '../utils/pricetravel/detail/RoomGrouper';
import { formatDate, calculateDateDifference } from '../utils/constants/date';
import BookerTracker from '../MetricsTracker/booker/metrics';
import { getDepositBanks, getDepositAccountName, getDepositContactEmail } from '../utils/pricetravel/shared/bankUtils';
import { setPickerDates } from '../utils/constants/datePicker'
import LowPriceNotifierService from '../utils/pricetravel/shared/lowPriceNotifierService';
import GlobalUtil from '../utils/pricetravel/shared/globalUtil';

import FavsTracker from '../MetricsTracker/favorite/metrics';
import { StorageService } from '../vue/services/StorageService'
import { SearchHistory } from '../utils/pricetravel/shared/searchHistory';
import CampaignParser from '../utils/pricetravel/detail/CampaignParser';
import MealPlanNormalizer from '../utils/pricetravel/shared/MealPlanNormalizer';
import { GoogleMapDetail } from '../utils/maps/GoogleMapDetail';
import { featuredAmenitiesConfig } from '../utils/pricetravel/detail/featuredAmenities';

window.app.controller('DetailController', controller);

controller.$inject = ["$scope", "$http", "$filter", "$location", "$rootScope", "$timeout", "$compile", "$interval"];

function controller($scope, $http, $filter, $location, $rootScope, $timeout, $compile, $interval) {
    let config = window.__pt.settings.site;
    let vm = this;
    let fn = window.__pt.fn;
    let hotel = window.__pt.hotel || {};
    let settings = window.__pt.settings;
    let WidthDevice = window.innerWidth || document.documentElement.clientWidth;
    let _isBot = window.__pt.settings.rb || false;
    let box = window.__pt.box || {};
    let place = window.__pt.place || {};
    let placeContainer = window.__pt.placeContainer || {};
    let cultureData = window.__pt.cultureData || {};
    let ln = window.__pt.ln || {};
    let _user = window.__pt.user || null;
    let skillBase = {};
    let userLocation = window.__pt.userLocation;
    let providers = window.__pt.providers && window.__pt.providers.providersId ? window.__pt.providers.providersId.join(',') : '';
    let memorySlider = {};
    let _showMoreRooms = true;
    let _successSkillBase = "200 - OK";
    let _campaignToken = null;
    let _campaignId = null;
    let _globalUtil = new GlobalUtil();
    let _userKey = _globalUtil.getUserKey();
    let _userKeyFac = _globalUtil.getUserKeyFavorites();
    let _isLogin = !!_user;
    let promotionsBlackList = [' Special Price.', ' Precio Especial.', 'Precio especial'];
    let _paramQuery = fn.search();
    let _paxes = {};
    let trackerFooter = new FooterTracker();
    let tracker = null;
    let errorMessagesStatus = null;
    let isMobile = fn.mobileAndTabletCheck();
    let sharedGlobalKey = "";
    let sharedGlobalUrl = "";
    let params = {
        checkIn: box.checkIn,
        checkOut: box.checkOut
    }
    let trackerMetric = new BookerTracker();
    let trackerFavs = new FavsTracker();
    let trackCategory = new CategoryTracker();
    let paramsSkillBase = {
        checkInDate: null,
        checkOutDate: null,
        placeId: placeContainer.id,
        adultQuantity: 0,
        kidQuantity: 0,
        hotelId: hotel.hotelId,
        stepId: 3
    };
    vm.roomsTotal = _paramQuery.rooms || 0;
    let paramsRoomRates = {
        checkin: box.checkIn,
        checkout: box.checkOut,
        hotelid: hotel.hotelId,
        CampaignToken: _campaignToken,
        source: box.source ? box.source : "SPA-Hotel-List",
        ispackage: false,
        site: config.domain,
        culture: cultureData.internalCultureCode,
        rooms: 2,
        promotions: _paramQuery.promotions ? _paramQuery.promotions.split(',') : null,
        offer: _paramQuery.offer === 'true',
        placeId: placeContainer.id
    }
    let paramnsRevalidate = {
        checkin: box.checkIn,
        checkout: box.checkOut,
        hotelid: hotel.hotelId,
        ispackage: false,
        site: config.domain
    }
    let roomsLogin = [];
    vm.customLimit = 0;
    vm.RAPDObject = {
        totalSticky: 0,
        totalHasTaxSticky: false,
        totalImpSticky: 0,
        totalFeesIncludes: 0,
        paymentNow: false
    };
    vm.isDefaultPhone = false;
    vm.allImagesText = '@viewHelper.Localizer("all_images")';
    vm.isFilterMenuOpen = false;
    vm.selectedClasificationName = null;
    vm.galleryIndexIndex = null;
    vm.defaultHotel = settings.defaultHotel;
    vm.checkIn = box.checkIn;
    vm.checkOut = box.checkOut;
    vm._isLogin = _isLogin;
    vm.dateConfig = settings.formatDateSlash;
    vm.dateConfigbook = settings.formatDateSlashBook;
    vm.configPrefix = settings.site.sufix;
    vm.mealplans = MealPlanNormalizer.normalizeAll(ln.mealplans, config.siteName);
    vm.lnMessages = ln;
    vm.hotel = hotel;

    if (window.__pt && Array.isArray(window.__pt.campaings)) {
        window.__pt.campaings.forEach(campaign => {
            if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(hotel.hotelId || hotel.productId || hotel.id))) {
                const badgeNormalized = campaign.badgeType.trim().toLowerCase();
                let icon = '';
                if (badgeNormalized === 'hotsale' || badgeNormalized === 'ofertahot') {
                    icon = 'icon icons-flame1 font-oncolor';
                } else if (badgeNormalized === 'blackdays') {
                    icon = 'icon icons-moon';
                } else if (badgeNormalized === 'blackfriday') {
                    icon = 'icon icons-tag';
                }

                let text = campaign.badgeType;
                if (campaign.badgeText && typeof campaign.badgeText === 'string' && campaign.badgeText.trim() !== '') {
                    text = campaign.badgeText.trim();
                } else if (window.__pt && window.__pt.ln) {
                    if (window.__pt.ln.campaigns && window.__pt.ln.campaigns[badgeNormalized]) {
                        text = window.__pt.ln.campaigns[badgeNormalized];
                    }
                }

                const processedCampaign = Object.assign({}, campaign, {
                    badgeType: badgeNormalized,
                    icon: icon,
                    text: text,
                    badgeIcon: campaign.badgeIcon || '',
                    hasIcon: campaign.hasIcon || false,
                    hasBankPromotion: campaign.hasBankPromotion || false,
                    bgClass: 'bg-' + badgeNormalized
                });

                hotel.campaignObj = processedCampaign;
                vm.campaignObj = processedCampaign;
            }
        });
    }

    vm.rooms = [];
    vm.availableRooms = [];
    vm.unavailableRooms = [];
    vm.selectedMealPlanFilter = null;
    vm.filteredRooms = [];
    vm.filteredRoomsBase = [];
    vm.mealPlanClasifications = [];
    vm.selectedMealPlanClasificationName = null;
    vm.hasFreeCancellationOption = false;
    vm.freeCancellationFilterActive = false;
    vm.reviewsLoadingModal = true;
    vm.gallery = [];
    vm.grid = [];
    vm.isTrivagoModal = false;
    vm.modalRapdCurrentData = null;
    vm.getRecomedationLabelSticky = "";
    vm.getRecomedationDateSticky = "";
    vm.stayDatesLabel = "";
    vm.currentRoom = null;
    vm.activeDetailSection = 'amenities';
    vm.cheaperRoomRate = {
        messages: "",
        disabled: true,
        loading: true
    };
    vm.topRecentShort = [];
    vm.topRecentShortOriginal = [];
    vm.clasifications = [];
    vm.filteredImages = [];
    vm.currentSlideIndex = 0;
    vm.currentSlideTitle = "";
    vm.clasificationIndex = 0;
    vm.code = config.code;
    vm.boxData = { rooms: 0, nights: 0, totalPax: 0 };
    vm.assigRateSet = {};
    vm.assigRoomRateModal = {};
    vm.isTrivagoRate = _paramQuery.room_search ? true : false;
    vm.listReviews = {};
    vm.showDetailScoreReviews = false;
    vm.sliderIsInit = false;

    vm.reviewerColorMap = {};

    // Filtros de reviews
    vm.reviewFilters = {
        order: 'recent',
        season: 'all'
    };
    vm.originalReviewsList = null;
    vm.loading = true;
    vm.loadingUnique = true;
    vm.toggleDescription = true;
    vm.toggleDescriptionAbout = true;
    vm.isIncompletePax = "";
    vm.overViewMinors = "";
    vm.averageDetailToggle = false;
    vm.showReviewsTooltip = false;
    vm.phoneBase = config.phoneDefault || "";
    vm.currency = config.currencyCodeName;
    vm.roomsLimit = config.limitRoomsRates || 0;
    vm.ratesLimit = config.limitRates || 0;
    vm.roomsAvailables = 0;
    vm.limitRoomsFilter = vm.roomsLimit;
    vm.roomRateMobileSelected = {};
    vm.source_origin = "";
    vm.mealplanCodesList = [];
    vm.sizeDescriptionString = config.hotelAboutConfigIdeal;
    vm.responsePayment = {
        fixedPayments: [],
        monthInterestFree: []
    };
    vm.TitleModalRAPD = "";
    vm.dateRAPDSticky = "";
    vm.isCancelation = false;
    vm.selectModalRoom = 0;
    vm.totalSticky = 0;
    vm.totalPromoDiscount = 0;
    vm.totalImpSticky = 0;
    vm.totalFeesIncludes = 0;
    vm.totalRoomSticky = 0;
    vm.viewDetailSticky = false;
    vm.totalHasTaxSticky = false;
    vm.datesRecommended = [];
    vm.pageError = {
        has: false,
        type: null
    }
    vm.responseroomsAvailables = [];
    vm.monthInterestData = {};
    vm.ratesResponse = {
        rooms: []
    };
    vm.sumTotalSticky = 0;
    vm.ratesResponse = {};
    vm.onSubmitLoading = false;
    vm.onSubmitLoadingRecomendation = false;
    vm.hasCancellationFree = false;
    vm.hasPayLater = false;
    vm.isBlockRAPD = false;
    vm.RateForRAPD = {};
    vm.roomsForRAPD = "";
    vm.headTabs = {
        rooms: '#rooms',
        amenities: '#amenities',
        map: '#location',
        current: '',
    }
    vm.featuredRoom = {};
    vm.isRequote = false;
    vm.boxData = { rooms: 0, nights: 0, totalPax: 0 };
    vm.roomDelTrivago = {};
    vm.indexRoomTrivago = -1;
    vm.recommendedDates = null;
    vm.sourceTriGooHotelsIds = false;
    vm.isMsiAvailable = false;
    vm.msiMonthsAllow = [];
    vm.notAmount = false;
    vm.notMessage = false;
    let copyBox = {};
    vm.isRAPDRecomendation = false;
    vm.hasErrorHandle = false;
    vm.rateModal = {};
    vm.roomModal = {
        totalRooms: 0
    };
    vm.roomIndexModal = {};
    vm.isGoSection = false;
    vm.similarHotels = [];

    const service = new LowPriceNotifierService(config.domainAPIUrl);
    vm.alertsFavorites = {
        notificationSuccess: false,
        notificationError: false,
        notificationWarning: false,
        message: "",
        actionType: ''
    };
    vm.favoriteHotels = [];
    vm.showTimer = false;
    let notificationTimeout = null;
    vm.sourceOrigen = "";
    vm.filteredServices = filterServicesByCharge(vm.hotel.services);
    vm.visibleServicesCount = 9;
    vm.visibleSInfoHotelCount = 2;
    vm.toggleDescription = false;
    vm.toggleServices = false;
    vm.toggleSellingPoints = false;
    vm.stickyRates = [];
    vm.totalTotalSticky = 0;
    vm.isRecomendationCheckout = false;
    vm.recomendationsList = {
        loading: true,
        rooms: [],
        checkoutHash: []
    }
    vm.recomendationsListCopy = {
        rooms: []
    }

    vm.recomendationsListUnique = {
        loading: true,
        rooms: [],
        checkoutHash: []
    }
    vm.showStickyHeader = false;
    vm.quantityLoop = 0;
    let lang = window.__pt.ln;
    vm.lang = lang;
    vm.roomsAvailLoading = false;
    let newPax = {};
    let newPaxRequote = {};
    vm.showMoreDetail = false;
    vm.showMoreCheckIn = false;
    vm.showAditionalCheckIn = false;
    vm.lengthPaxes = lengthPax(box.pax);
    vm.paxFam = newPax;
    vm.applicableRAPDSticky = false;
    vm.appicableExperiment = WidthDevice >= 992;
    vm.openServicesSections = {};
    vm.nearbyPlacesCategory = 0;
    vm.applicableGallery = window.innerWidth <= 767;
    const hasAdultsOnly = hotel.tags && hotel.tags.some(tag => {
        const name = tag.name.toLowerCase();
        return name === "solo adultos" || name === "adults only";
    });
    vm.toltipSticky = false;
    vm.totalChildrens = 0;
    vm.totalAdults = 0;
    vm.validPax = false;
    vm.onlyAdults = hasAdultsOnly;
    vm.currentSlideIndex = 1;
    vm.currentSlideTitle = "";
    vm.closeSumary = false;
    vm.closeSumaryModal = false;
    vm.ApplyFamilyRules = false;
    vm.isFamiliesVisible = true;
    vm.nearbyHotels = [];
    vm.nearbyMarkers = [];
    vm.markerCluster = null;
    vm.lib = { marker: null };
    vm.detailCardMap = {};

    //Favorites funciontality
    vm.getFavoriteHotelDetails = function () {
        return vm.favoriteHotels.find(favHotel => favHotel.productId === `${vm.hotel.hotelId}` &&
            favHotel.checkin === box.checkIn &&
            favHotel.checkout === box.checkOut &&
            angular.equals(comvertToAB(favHotel.rooms), box.pax)
        );
    };
    vm.updateHotelsState = function () {
        const favoriteHotel = vm.getFavoriteHotelDetails();
        if (favoriteHotel) {
            vm.hotel.isFavorite = true;
            vm.hotel.favoriteDetails = favoriteHotel;
        } else {
            vm.hotel.isFavorite = false;
            vm.hotel.favoriteDetails = null;
        }
    };
    vm.addFavorites = function (event) {
        event.preventDefault();
        event.stopPropagation();

        let copyBoxPax = comvertToMain(box.pax);
        const addHotelRequest = {
            productId: `${hotel.hotelId}`,
            userId: _userKeyFac,
            uri: place.uri,
            site: config.domain,
            channel: isMobile ? config.chkSourceMobile : config.chkSourceDesktop,
            originalPrice: vm.cheaperRoomRate.disabled ? 0 : vm.cheaperRoomRate.taxes.totalRoomRatePerNight,
            checkin: box.checkIn,
            checkout: box.checkOut,
            rooms: copyBoxPax.map(pax => ({
                adults: pax.adults,
                children: pax.children.map(child => child.year)
            })),
            campaignToken: _campaignToken || "",
            placeId: placeContainer.id,
            placeUri: placeContainer.uri,
            placeType: placeContainer.type,
            placeName: placeContainer.displayText,
            isMobile: isMobile
        };
        if (vm.hotel.isFavorite) {
            const favoriteId = vm.getFavoriteId(hotel.favoriteDetails.id, box.checkIn, box.checkOut);
            if (favoriteId) {
                service.removeHotel({ Id: favoriteId, UserId: _userKeyFac }).then(response => {
                    $scope.$applyAsync(() => {

                        vm.favoriteHotels = vm.favoriteHotels.filter(favHotel =>
                            !(favHotel.productId === `${hotel.hotelId}` &&
                                favHotel.checkin === box.checkIn &&
                                favHotel.checkout === box.checkOut &&
                                angular.equals(comvertToAB(favHotel.rooms), box.pax))
                        );
                        const favoriteHotel = { ...addHotelRequest, id: favoriteId, name: hotel.name };
                        trackerFavs.logDeleteFav(favoriteHotel, 'details');
                        vm.updateHotelsState();
                        vm.showNotification('error', hotel.name, 'delete');
                    });
                }).catch(error => {
                    $scope.$applyAsync(() => {
                        vm.showNotification('error', error);
                    });
                });
            }
        } else {
            // Agregar el hotel a favoritos
            service.addHotel(addHotelRequest).then(response => {
                $scope.$applyAsync(() => {
                    if (response.value) {
                        const favoriteHotel = { ...addHotelRequest, id: response.value, name: hotel.name };
                        vm.favoriteHotels.push(favoriteHotel);
                        trackerFavs.logAddFav(favoriteHotel, 'details');
                        vm.updateHotelsState();
                        vm.showNotification('success', hotel.name, 'save');
                    } else {
                        vm.showNotification('warning', '', '');
                    }

                });
            }).catch(error => {
                $scope.$applyAsync(() => {
                    vm.showNotification('error', error);
                });
            });
        }
        _globalUtil.vibrate();
    };
    vm.showNotification = (type, message, actionType) => {
        // Cancelar cualquier timeout anterior
        if (notificationTimeout) {
            $timeout.cancel(notificationTimeout);
        }
        vm.showTimer = false;
        $timeout(() => {
            vm.showTimer = true;
        });
        vm.alertsFavorites.notificationSuccess = type === 'success';
        vm.alertsFavorites.notificationError = type === 'error';
        vm.alertsFavorites.notificationWarning = type === 'warning';
        vm.alertsFavorites.message = message;
        vm.alertsFavorites.actionType = actionType; // 'save' or 'delete'

        // Ocultar la notificación después de 6 segundos
        notificationTimeout = $timeout(function () {
            vm.alertsFavorites.notificationSuccess = false;
            vm.alertsFavorites.notificationError = false;
            vm.alertsFavorites.notificationWarning = false;
            vm.alertsFavorites.message = "";
            vm.alertsFavorites.actionType = '';
        }, 6000);
    };

    function getFavorites() {
        const request = { UserId: _userKeyFac, country: config.country.toUpperCase() };

        service.getHotelsByUser(request).then(response => {
            $scope.$applyAsync(() => {
                vm.favoriteHotels = response.value;
                vm.updateHotelsState();

            });
        }).catch(error => {
            console.error('Error fetching hotels by user:', error);
        });
    }

    vm.getFavoriteId = function (Id, checkin, checkout) {
        const favorite = vm.favoriteHotels.find(favHotel =>
            favHotel.id === Id &&
            favHotel.checkin === checkin &&
            favHotel.checkout === checkout &&
            angular.equals(comvertToAB(favHotel.rooms), box.pax)
        );
        return favorite ? favorite.id : null;
    };

    vm.getNormalizedMealPlanName = function (mealPlanName) {
        if (!mealPlanName) return mealPlanName;

        if (mealPlanName.toLowerCase().includes('todo incluido')) {
            return 'Todo Incluido';
        }

        return mealPlanName;
    };

    vm.hasRoomFreeCancellation = function (room) {
        return !!(room && room.rate && Array.isArray(room.rate.rate) &&
            room.rate.rate.some(rate => rate && !rate.isNonRefundable && rate.cancellationPolicies && rate.cancellationPolicies.freeCancellationExpire));
    };

    vm.isFreeCancellationRate = function (rate) {
        return !!(rate && !rate.isNonRefundable && rate.cancellationPolicies && rate.cancellationPolicies.freeCancellationExpire);
    };

    vm.updateFreeCancellationAvailability = function (rooms, mealPlanCodes) {
        const availableRooms = rooms || [];
        const hasMealPlanFilter = Array.isArray(mealPlanCodes) && mealPlanCodes.length > 0;

        vm.hasFreeCancellationOption = availableRooms.some(room => {
            if (!hasMealPlanFilter) {
                return vm.hasRoomFreeCancellation(room);
            }

            return !!(room && room.rate && Array.isArray(room.rate.rate) &&
                room.rate.rate.some(rate =>
                    rate &&
                    mealPlanCodes.includes(rate.mealPlanCode) &&
                    vm.isFreeCancellationRate(rate)
                ));
        });

        if (!vm.hasFreeCancellationOption) {
            vm.freeCancellationFilterActive = false;
        }
    };

    vm.setFilteredRooms = function (rooms, mealPlanCodes) {
        vm.filteredRoomsBase = rooms || [];
        vm.filteredMealPlanCodes = Array.isArray(mealPlanCodes) ? mealPlanCodes : [];
        vm.updateFreeCancellationAvailability(vm.filteredRoomsBase, mealPlanCodes);
        vm.applyFreeCancellationFilter();
    };

    vm.applyFreeCancellationFilter = function () {
        try {
            const baseRooms = vm.filteredRoomsBase || [];
            const mealPlanCodes = vm.filteredMealPlanCodes || [];
            const isEligibleFreeCancellationRate = rate =>
                vm.isFreeCancellationRate(rate) &&
                (mealPlanCodes.length === 0 || mealPlanCodes.includes(rate.mealPlanCode));

            if (!vm.freeCancellationFilterActive) {
                vm.filteredRooms = baseRooms;
                return;
            }

            vm.filteredRooms = baseRooms
                .filter(room => room && room.rate && Array.isArray(room.rate.rate) &&
                    room.rate.rate.some(rate => isEligibleFreeCancellationRate(rate)))
                .map(room => {
                    if (isMobile) {
                        const selectedRate = room.rate.rate.find(rate => isEligibleFreeCancellationRate(rate));

                        room.rate.rate.forEach(rate => {
                            rate.selected = rate === selectedRate;
                        });
                        room.roomRateMobileSelected = selectedRate;
                        room.isRateSelectedMobile = !!selectedRate;

                        return room;
                    }

                    if (!room.rate || !Array.isArray(room.rate.rate)) return room;
                    return {
                        ...room,
                        rate: {
                            ...room.rate,
                            rate: room.rate.rate.filter(rate => isEligibleFreeCancellationRate(rate))
                        }
                    };
                });
        } catch (error) {
            vm.filteredRooms = vm.filteredRoomsBase || [];
        }
    };

    vm.toggleFreeCancellationFilter = function () {
        vm.freeCancellationFilterActive = !vm.freeCancellationFilterActive;
        vm.applyFreeCancellationFilter();
    };

    vm.buildMealPlanClasifications = function () {
        try {
            if (!vm.rooms || vm.rooms.length === 0) {
                vm.mealPlanClasifications = [];
                vm.hasFreeCancellationOption = false;
                vm.setFilteredRooms([]);
                return;
            }

            const mealPlanCounts = {};
            vm.rooms.forEach(room => {
                if (room && room.rate && room.rate.rate && Array.isArray(room.rate.rate)) {
                    room.rate.rate.forEach(rate => {
                        if (rate && rate.mealPlanCode) {
                            const planName = (vm.mealplans && vm.mealplans[rate.mealPlanCode]) || rate.mealPlanCode;
                            const normalizedPlanName = vm.getNormalizedMealPlanName(planName);

                            if (!mealPlanCounts[normalizedPlanName]) {
                                mealPlanCounts[normalizedPlanName] = {
                                    name: normalizedPlanName,
                                    codes: [rate.mealPlanCode],
                                    rooms: [],
                                    isSelected: false
                                };
                            } else if (!mealPlanCounts[normalizedPlanName].codes.includes(rate.mealPlanCode)) {
                                mealPlanCounts[normalizedPlanName].codes.push(rate.mealPlanCode);
                            }
                        }
                    });
                }
            });

            Object.keys(mealPlanCounts).forEach(normalizedPlanName => {
                const planCodes = mealPlanCounts[normalizedPlanName].codes;
                const uniqueRooms = vm.rooms.filter(room => {
                    if (!room || !room.rate || !room.rate.rate) return false;
                    return room.rate.rate.some(rate => rate && planCodes.includes(rate.mealPlanCode));
                });
                mealPlanCounts[normalizedPlanName].rooms = uniqueRooms;
            });

            const allRoomsWithMealPlans = vm.rooms.filter(room => {
                if (!room || !room.rate || !room.rate.rate) return false;
                return room.rate.rate.some(rate => rate && rate.mealPlanCode);
            });

            vm.mealPlanClasifications = [
                {
                    name: 'all',
                    rooms: allRoomsWithMealPlans,
                    count: allRoomsWithMealPlans.length,
                    isSelected: true
                },
                ...Object.values(mealPlanCounts)
            ];

            if (vm.mealPlanClasifications.length > 0) {
                vm.selectedMealPlanClasificationName = vm.mealPlanClasifications[0].name;
                vm.setFilteredRooms(vm.mealPlanClasifications[0].rooms);
                vm.selectedMealPlanClasification(vm.mealPlanClasifications[0], 0);

                if (vm.mealPlanClasifications.length === 2) {
                    $timeout(() => {
                        vm.rooms.forEach(room => {
                            if (room && room.rate && room.rate.rate && room.rate.rate.length === 1) {
                                const rate = room.rate.rate[0];
                                rate.selected = true;
                                room.roomRateMobileSelected = rate;
                                room.isRateSelectedMobile = true;

                                const filteredRoom = vm.filteredRooms.find(fr => fr.roomId === room.roomId);
                                if (filteredRoom) {
                                    filteredRoom.roomRateMobileSelected = rate;
                                    filteredRoom.isRateSelectedMobile = true;
                                    if (filteredRoom.rate && filteredRoom.rate.rate && filteredRoom.rate.rate.length > 0) {
                                        filteredRoom.rate.rate[0].selected = true;
                                    }
                                }
                            }
                        });
                    }, 100);
                }
            }
        } catch (error) {
            console.error('Error in buildMealPlanClasifications:', error);
            vm.mealPlanClasifications = [];
            vm.hasFreeCancellationOption = false;
            vm.setFilteredRooms(vm.rooms || []);
        }
    };

    vm.selectedMealPlanClasification = function (data, index) {
        try {
            vm.mealPlanClasifications = vm.mealPlanClasifications.map(clasification => ({
                ...clasification,
                isSelected: clasification.name === data.name
            }));

            const foundClasification = vm.mealPlanClasifications.find(f => f.name === data.name);

            if (foundClasification) {
                vm.selectedMealPlanClasificationName = foundClasification.name;

                if (data.name === 'all') {
                    vm.setFilteredRooms(foundClasification.rooms);
                    $timeout(() => {
                        vm.rooms.forEach(room => {
                            if (room && room.rate && room.rate.rate && room.rate.rate.length > 0) {
                                room.rate.rate.forEach(rate => {
                                    rate.selected = false;
                                });

                                const selectedRate = vm.freeCancellationFilterActive
                                    ? room.rate.rate.find(rate => vm.isFreeCancellationRate(rate))
                                    : room.rate.rate[0];

                                if (!selectedRate) return;

                                selectedRate.selected = true;
                                room.roomRateMobileSelected = selectedRate;
                                room.isRateSelectedMobile = true;

                                const filteredRoom = vm.filteredRooms.find(fr => fr.roomId === room.roomId);
                                if (filteredRoom) {
                                    filteredRoom.roomRateMobileSelected = selectedRate;
                                    filteredRoom.isRateSelectedMobile = true;
                                    if (filteredRoom.rate && filteredRoom.rate.rate && filteredRoom.rate.rate.length > 0) {
                                        filteredRoom.rate.rate.forEach(rate => rate.selected = false);
                                        const filteredSelectedRate = filteredRoom.rate.rate.find(rate =>
                                            rate.rateKey === selectedRate.rateKey
                                        ) || filteredRoom.rate.rate[0];
                                        filteredSelectedRate.selected = true;
                                    }
                                }
                            }
                        });
                    }, 50);
                } else {
                    vm.rooms.forEach(room => {
                        if (room && room.rate && room.rate.rate) {
                            room.rate.rate.forEach(rate => {
                                rate.selected = false;
                            });
                            room.isRateSelectedMobile = false;
                            room.roomRateMobileSelected = null;
                        }
                    });

                    vm.setFilteredRooms(foundClasification.rooms.map(room => {
                        if (room && room.rate && room.rate.rate && Array.isArray(room.rate.rate)) {
                            if (isMobile) {
                                return room;
                            } else {
                                const filteredRates = room.rate.rate.filter(rate =>
                                    rate && data.codes.includes(rate.mealPlanCode)
                                ); return {
                                    ...room,
                                    rate: {
                                        ...room.rate,
                                        rate: filteredRates
                                    }
                                };
                            }
                        }
                        return room;
                    }), data.codes);

                    $scope.$applyAsync();

                    $timeout(() => {
                        foundClasification.rooms.forEach((room) => {
                            if (room && room.rate && room.rate.rate && Array.isArray(room.rate.rate)) {
                                const originalRoomIndex = vm.rooms.findIndex(originalRoom =>
                                    originalRoom.roomId === room.roomId
                                );

                                if (originalRoomIndex !== -1) {
                                    const targetRateIndex = vm.rooms[originalRoomIndex].rate.rate.findIndex(rate =>
                                        rate &&
                                        data.codes.includes(rate.mealPlanCode) &&
                                        (!vm.freeCancellationFilterActive || vm.isFreeCancellationRate(rate))
                                    ); if (targetRateIndex !== -1) {
                                        const targetRate = vm.rooms[originalRoomIndex].rate.rate[targetRateIndex];
                                        targetRate.selected = true;
                                        vm.rooms[originalRoomIndex].roomRateMobileSelected = targetRate;
                                        vm.rooms[originalRoomIndex].isRateSelectedMobile = true;

                                        const filteredRoomIndex = vm.filteredRooms.findIndex(filteredRoom =>
                                            filteredRoom.roomId === room.roomId
                                        );

                                        if (filteredRoomIndex !== -1) {
                                            vm.filteredRooms[filteredRoomIndex].roomRateMobileSelected = targetRate;
                                            vm.filteredRooms[filteredRoomIndex].isRateSelectedMobile = true;

                                            vm.filteredRooms[filteredRoomIndex].rate.rate.forEach((rate, index) => {
                                                rate.selected = (index === targetRateIndex);
                                            });
                                        }
                                    }
                                }
                            }
                        });

                        $scope.$applyAsync();
                    }, 0);
                }
            }

        } catch (error) {
            console.error('Error in selectedMealPlanClasification:', error);
            vm.setFilteredRooms(vm.rooms || []);
        }
    };

    vm.isFavoriteHotel = (productId = null) => {
        return vm.favoriteHotels.some(favHotel =>
            favHotel.productId === `${(productId ?? hotel.hotelId)}` &&
            favHotel.checkin === box.checkIn &&
            favHotel.checkout === box.checkOut &&
            angular.equals(comvertToAB(favHotel.rooms), box.pax)
        );
    };
    function comvertToAB(input) {
        return input.reduce((acc, room) => {
            acc.adults += room.adults;
            acc.children = acc.children.concat(room.children.map(age => ({ "year": age })));
            acc.rooms += 1;
            return acc;
        }, { "adults": 0, "children": [], "rooms": 0 });
    }
    function comvertToMain(data) {
        const { adults, children, rooms } = data;

        const adultsPerRoom = Math.floor(adults / rooms);
        const extraAdults = adults % rooms;

        const childrenPerRoom = Math.floor(children.length / rooms);
        const extraChildren = children.length % rooms;

        const result = [];

        let childIndex = 0;

        for (let i = 0; i < rooms; i++) {
            const currentRoomAdults = adultsPerRoom + (i < extraAdults ? 1 : 0);
            const currentRoomChildrenCount = childrenPerRoom + (i < extraChildren ? 1 : 0);
            const currentRoomChildren = [];
            for (let j = 0; j < currentRoomChildrenCount; j++) {
                currentRoomChildren.push({ year: children[childIndex].year });
                childIndex++;
            }

            result.push({
                adults: currentRoomAdults,
                children: currentRoomChildren
            });
        }

        return result;
    }
    $rootScope.$on(settings.bookerChangeEvent, function (event, args) {
        vm.roomsAvailLoading = false;
        vm.validPax = false;
        let paxesDeslink = fn.clone(args);
        vm.recomendationsList = {
            loading: true,
            rooms: [],
            checkoutHash: []
        }
        vm.recomendationsListCopy = {
            rooms: []
        }
        vm.hasErrorHandle = false;
        roomsLogin = [];
        vm.isTrivagoRate = false;
        box.pax = paxesDeslink.paxes;
        paramsRoomRates.checkin = fn.formatDate(args.checkIn, settings.formatDate);
        paramsRoomRates.checkout = fn.formatDate(args.checkOut, settings.formatDate);
        box.checkIn = paramsRoomRates.checkin;
        box.checkOut = paramsRoomRates.checkout;
        paramnsRevalidate.checkin = fn.formatDate(args.checkIn, settings.formatDate);
        paramnsRevalidate.checkout = fn.formatDate(args.checkOut, settings.formatDate);
        paramsRoomRates.offer = false;
        vm.ApplyFamilyRules = (box.pax.adults + box.pax.children.length) <= 4 && WidthDevice <= 992;
        vm.updateHotelsState();
        newPax = matchFamilyRule(box.pax, vm.appicableExperiment || !vm.ApplyFamilyRules);
        vm.lengthPaxes = lengthPax(box.pax);
        copyBox = fn.clone(box);
        vm.paxFam = newPax;
        initializeValues();
        vm.stickyRates = [];
        vm.isGoSection = true;

        loadRoomRates();

        if (!vm.notMessage) {
            loadRatesFromLogin();
        }
        if (settings.site.siteName == "pricetravel" && userLocation.country == "MX") {
            getSkillBase();
        }
    });

    function init() {
        vm.roomsAvailLoading = false;
        vm.recomendationsList = {
            loading: true,
            rooms: []
        }
        vm.recomendationsListCopy = {
            rooms: []
        }
        caruosel();
        vm.validPax = false;
        vm.notAmount = config.hotelsTagLogin ? config.hotelsTagLogin.listA.includes(hotel.hotelId.toString()) : false;
        vm.notMessage = config.hotelsTagLogin ? config.hotelsTagLogin.listB.includes(hotel.hotelId.toString()) : false;
        var paramns = _paramQuery.source || null;
        fn.setCookie("source_origin", paramns, "1");
        vm.source_origin = fn.getCookie("source_origin");
        let codept = _paramQuery.coupon;
        var codeptFromCookie = fn.getCookie("codept");
        var finalCodept = codept || codeptFromCookie;

        fn.setCookie("codept", finalCodept, "1");

        let indexHotelPla = config.hotelsIdsPR ? config.hotelsIdsPR.find(x => x == hotel.hotelId) : -1;
        if (indexHotelPla > -1) { //&& (vm.source_origin == "trivago" || vm.source_origin == "google-hotel-ads")) {
            vm.sourceTriGooHotelsIds = true;
        }
        vm.hotel.surveyAverage = {
            averageValue: (vm.hotel?.surveyAverage?.averageValue ?? 0) * 2,
            totalSurveys: vm.hotel?.surveyAverage?.totalSurveys ?? 0
        };
        copyBox = fn.clone(box);
        vm.ApplyFamilyRules = (box.pax.adults + box.pax.children.length) <= 4 && WidthDevice <= 992;
        initializeValues();
        newPax = matchFamilyRule(box.pax, vm.appicableExperiment || !vm.ApplyFamilyRules);
        vm.paxFam = newPax;
        vm.isGoSection = false;

        if (config.showReviews && !settings.rb) {
            vm.reviewsLoadingModal = true;
            vm.getReviews(vm.hotel.hotelId, true);
        }

        if (vm.source_origin && box.hasValidPaxes) {
            loadRoomRatesTrivago();
        }
        loadRoomRates();
        if (!settings.rb) {
            getFavorites();
        }
        if (!vm.notMessage) {
            loadRatesFromLogin();
        }
        if (!settings.rb) {
            if (settings.site.siteName == "pricetravel" && userLocation.country == "MX") {
                getSkillBase();
            }
            onSearchPaymentMethods();
            initStickySearchBox();
            transformDescription();
            initScrollSpy();
            vm.grid = buildGridGallery(vm.gallery);
            setRecentDestination(hotel);
            if (isMobile) {
                vm.initMainGalleryCarousel();
            }
        }


    }

    function initializeValues() {
        _paxes = getPaxes();
        vm.gallery = vm.hotel.gallery;
        vm.hotel.currentImageIndex = 0;
        vm.rooms = vm.hotel.rooms;

        vm.buildMealPlanClasifications();
        vm.setFilteredRooms(vm.rooms || []);
        initialCampaignToken();
    }
    /*FAMILIAS*/
    function lengthPax(pax) {
        let totalPax = pax.adults;
        if (pax.children && pax.children.length > 0) {
            totalPax += pax.children.length;
        }
        return totalPax;
    }
    //NEW LOGICA FAMILIAS
    vm.showStickyDetail = () => {
        if (vm.viewDetailSticky) {
            $('#collapseSticky').collapse('hide');
        } else {
            $('#collapseSticky').collapse('show');
        }
        vm.viewDetailSticky = !vm.viewDetailSticky;
    }

    function initVisibilityListener() {
        const el = document.getElementById('familiesContent');
        const familiesContentAssing = document.getElementById('familiesContentAssing');
        if (!el) {
            $timeout(initVisibilityListener, 100);
            return;
        }
        function checkVisibility() {
            const rect = el.getBoundingClientRect();
            const winH = window.innerHeight;

            const visible = rect.top < winH && rect.bottom > 0;

            if (vm.isFamiliesVisible != visible) {
                vm.isFamiliesVisible = visible;
                if (!visible) {
                    familiesContentAssing.classList.add('families__content--expanded');
                    setTimeout(() => {
                        familiesContentAssing.classList.add('families__content--stiky');
                    }, 50);

                } else {
                    setTimeout(() => {
                        familiesContentAssing.classList.remove('families__content--stiky');
                        setTimeout(() => {
                            familiesContentAssing.classList.remove('families__content--expanded');
                        }, 50);
                    }, 50);
                }
                $scope.$applyAsync();
            }
        }
        window.addEventListener('scroll', checkVisibility, { passive: true });
        window.addEventListener('resize', checkVisibility);

        $timeout(checkVisibility, 0);
        $scope.$on('$destroy', () => {
            window.removeEventListener('scroll', checkVisibility);
            window.removeEventListener('resize', checkVisibility);
        });
    }
    $(document).on('hidden.bs.modal', function () {
        const familiesModal = document.getElementById('modal-families');
        if (familiesModal && familiesModal.classList.contains('show')) {
            $('body').addClass('modal-open');
        }
    });

    $(document).on('show.bs.modal', '#modal-families', function () {
        vm.closeSumaryModal = false;
        if (vm.closeSumaryCancelFn) {
            vm.closeSumaryCancelFn();
            vm.closeSumaryCancelFn = null;
        }
        if (vm.closeSumary) {
            const promise = $timeout(() => {
                vm.closeSumary = false;
                vm.closeSumaryCancelFn = null;
            }, 2000);
            vm.closeSumaryCancelFn = () => $timeout.cancel(promise);
        }
        $scope.$applyAsync();
    });

    $(document).on('hidden.bs.modal', '#modal-families', function () {
        if (vm.closeSumaryCancelFn) {
            vm.closeSumaryCancelFn();
            vm.closeSumaryCancelFn = null;
        }
        vm.closeSumary = false;
        vm.closeSumaryModal = false;
        $scope.$applyAsync();
    });

    vm.toggleRecomendation = () => {
        vm.closeSumary = !vm.closeSumary;
    };

    vm.toggleRecomendationModal = () => {
        vm.closeSumaryModal = !vm.closeSumaryModal;
    };

    vm.titleTotalRecomendation = () => {
        const roomTitle = vm.recomendationsList.totalRooms == 1 ? lang.room : lang.rooms;
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? lang.child : lang.children;
        const childrenPart = newPax.paxes.children.length > 0 ? `, ${newPax.paxes.children.length} ${childrenTitle}` : '';
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        return `${vm.recomendationsList.totalRooms} ${roomTitle}, ${nightCounts} ${nightTitle} ${lang.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }
    vm.getTitleForHeaderRecomentation = (unique = false) => {
        return `${unique ? lang.uniqueRoom : lang.recommendedRoom} ${lang.for} ${newPax.paxes.adults + newPax.paxes.children.length} ${lang.guests}`;
    }
    // Devuelve el mealPlanCode compartido si todas las habitaciones recomendadas
    // tienen el mismo plan de alimentos; de lo contrario, null.
    vm.recomendationSharedMealPlanCode = () => {
        const rooms = vm.recomendationsList && vm.recomendationsList.rooms;
        if (!rooms || rooms.length === 0) return null;
        const firstCode = rooms[0].rate && rooms[0].rate.mealPlanCode;
        if (!firstCode) return null;
        const allSame = rooms.every(room => room.rate && room.rate.mealPlanCode === firstCode);
        return allSame ? firstCode : null;
    }
    vm.titleForRoomRecomendation = (index, room, allText = true) => {
        const roomTitle = lang.room;
        let datos = room.rate.paxFam.split("|");
        const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
        let childrenPart = "";
        if (datos.length > 1) {
            var titleChildren = datos[1].split(",").length == 1 ? lang.child : lang.children
            childrenPart = `${datos[1].split(",").length} ${titleChildren}`;
        }

        const prefix = allText ? `${roomTitle} ${index} ${lang.for} ` : `${lang.for} `;

        return `${prefix}${datos[0]} ${adultsTitle} ${childrenPart}`.trim();
    }
    vm.titleForRoomAria = (index, room) => {
        const roomTitle = lang.room;
        let datos = room.rate.paxFam.split("|");
        const adultsCount = parseInt(datos[0] || "0");
        const adultsWord = vm._fixMasculineUno(vm.numberToWords(adultsCount, false));
        const adultsTitle = adultsCount == 1 ? lang.adult : lang.adults;
        let childrenPart = "";
        if (datos.length > 1) {
            const childCount = datos[1].split(",").length;
            const childWord = vm._fixMasculineUno(vm.numberToWords(childCount, false));
            const titleChildren = childCount == 1 ? lang.child : lang.children;
            childrenPart = `${lang.and} ${childWord} ${titleChildren}`;
        }
        return `${roomTitle} ${index} ${lang.for} ${adultsWord} ${adultsTitle}${childrenPart ? " " + childrenPart : ""}`;
    }
    vm.getRoomCardAria = (index, room) => {
        const base = vm.titleForRoomAria(index, room);
        const name = room && room.name ? room.name : "";
        const meal = room && room.rate && vm.mealplans[room.rate.mealPlanCode] ? vm.mealplans[room.rate.mealPlanCode] : "";
        let parts = [base];
        if (name) parts.push(name);
        if (meal) parts.push(meal);
        return parts.join(", ");
    }
    vm.getRecommendationSummaryAriaUnique = (data) => {
        const roomTitle = data.totalRooms == 1 ? lang.room : lang.rooms;
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? lang.child : lang.children;
        const childrenPart = newPax.paxes.children.length > 0
            ? `, ${newPax.paxes.children.length} ${childrenTitle}`
            : '';
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        return `${data.totalRooms} ${roomTitle}, ${nightCounts} ${nightTitle} ${lang.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }
    vm.filterRatesByMealplan = function (selectedMealplan) {
        return function (rate) {
            if (!selectedMealplan) {
                return true;
            }
            return rate.mealPlanCode === selectedMealplan.mealPlanCode && rate.isNonRefundable === selectedMealplan.nonRefundable && rate.cancellationPolicies.freeCancellationExpire != null === selectedMealplan.freeCancellationExpire;
        };
    };
    vm.assignSelectedPax = (roomFamSelected) => {
        if (roomFamSelected && roomFamSelected.pax) {
            vm.roomFamSelected.selectedPax = roomFamSelected.pax[0];
        }
    }
    vm.numberToWords = function (n, feminine) {
        if (typeof n !== 'number' || !isFinite(n)) return '';
        const nb = vm.lang && vm.lang.numberWords;
        if (!nb) return String(n);
        const direct = nb.units[n];
        if (direct !== undefined) {
            let word = direct;
            if (feminine && word) {
                if (word === 'uno') word = 'una';
                if (word === 'veintiuno') word = 'veintiu' + 'na';
            }
            return word;
        }
        if (n < 100) {
            const t = Math.floor(n / 10) * 10;
            const u = n % 10;
            if (u === 0) return nb.tens[t] || String(n);
            let unit = nb.units[u] || String(u);
            if (feminine && unit === 'uno') unit = 'una';
            const joiner = nb.joiner || ' ';
            return (nb.tens[t] || String(t)) + joiner + unit;
        }
        return String(n);
    };
    vm._fixMasculineUno = function (text) {
        if (!text) return text;
        return text.replace(/\buno\b/g, 'un').replace(/\bveintiuno\b/g, 'veintiún');
    };
    vm._esHundreds = function (n) {
        const nb = vm.lang.numberWords;
        if (n < 100) return vm.numberToWords(n, false);
        const h = Math.floor(n / 100) * 100;
        const r = n % 100;
        if (h === 100) {
            return r === 0 ? nb.hundreds[100] : ('ciento ' + vm.numberToWords(r, false));
        }
        const hName = nb.hundreds[h];
        return r === 0 ? hName : (hName + ' ' + vm.numberToWords(r, false));
    };
    vm._esLarge = function (n) {
        if (n === 0) return vm.lang.numberWords.units[0];
        let parts = [];
        const nb = vm.lang.numberWords;
        const millions = Math.floor(n / 1000000);
        const remAfterMillions = n % 1000000;
        if (millions > 0) {
            const mText = millions === 1 ? 'un' : vm._fixMasculineUno(vm._esHundreds(millions));
            parts.push(mText + ' ' + (millions === 1 ? nb.magnitude.millionSingular : nb.magnitude.millionPlural));
        }
        const thousands = Math.floor(remAfterMillions / 1000);
        const rem = remAfterMillions % 1000;
        if (thousands > 0) {
            const tText = thousands === 1 ? nb.magnitude.thousand : (vm._fixMasculineUno(vm._esHundreds(thousands)) + ' ' + nb.magnitude.thousand);
            parts.push(tText);
        }
        if (rem > 0) {
            parts.push(vm._esHundreds(rem));
        }
        return parts.join(' ');
    };
    vm._enHundreds = function (n) {
        const nb = vm.lang.numberWords;
        if (n < 100) {
            const t = Math.floor(n / 10) * 10;
            const u = n % 10;
            if (n < 20) return nb.units[n];
            if (u === 0) return nb.tens[t];
            return nb.tens[t] + (nb.joiner || '-') + nb.units[u];
        }
        const h = Math.floor(n / 100);
        const r = n % 100;
        const base = vm.lang.numberWords.units[h] + ' hundred';
        if (r === 0) return base;
        const rText = vm._enHundreds(r);
        return base + ' ' + rText;
    };
    vm._enLarge = function (n) {
        if (n === 0) return vm.lang.numberWords.units[0];
        const nb = vm.lang.numberWords;
        let parts = [];
        const millions = Math.floor(n / 1000000);
        const remAfterMillions = n % 1000000;
        if (millions > 0) {
            const mText = millions === 1 ? vm.lang.numberWords.units[1] + ' ' + nb.magnitude.millionSingular
                : vm._enHundreds(millions) + ' ' + nb.magnitude.millionPlural;
            parts.push(mText);
        }
        const thousands = Math.floor(remAfterMillions / 1000);
        const rem = remAfterMillions % 1000;
        if (thousands > 0) {
            const tText = vm._enHundreds(thousands) + ' ' + nb.magnitude.thousand;
            parts.push(tText);
        }
        if (rem > 0) {
            parts.push(vm._enHundreds(rem));
        }
        return parts.join(' ');
    };
    vm.numberToWordsLarge = function (n, feminine) {
        n = Math.floor(Math.abs(n));
        const nb = vm.lang && vm.lang.numberWords;
        if (!nb) return String(n);
        const isSpanish = !!nb.hundreds;
        return isSpanish ? vm._esLarge(n) : vm._enLarge(n);
    };
    vm.getCurrencyName = function () {
        const map = vm.lang && vm.lang.currencyWords;
        if (!map) return vm.currency || '';
        return map[vm.currency] || vm.currency || '';
    };
    vm.getAmountAriaLabel = function (amount) {
        let amountTotal = $filter('currency')(amount || 0, 0, true);
        const numText = vm.numberToWordsLarge(amountTotal.replace(/[^\d]/g, ''), false);
        const currText = vm.getCurrencyName();
        return numText + ' ' + currText;
    };
    vm.getRoomsNightsAria = function (rooms, nights) {
        const roomsText = vm.numberToWords(rooms, true) + ' ' + (rooms > 1 ? vm.lang.rooms : vm.lang.room);
        const nightsText = vm.numberToWords(nights, true) + ' ' + (nights > 1 ? vm.lang.nights : vm.lang.night);
        return roomsText + ', ' + nightsText;
    };
    vm.getMealPlanNames = function (room) {
        if (!room || !room.mealplans || !room.mealplans.length) {
            return '';
        }
        const seen = new Set();
        const names = [];
        for (let i = 0; i < room.mealplans.length; i++) {
            const mp = room.mealplans[i];
            const code = mp && (mp.mealPlanCode || mp.mealplancode);
            if (!code || seen.has(code)) {
                continue;
            }
            seen.add(code);
            const name = vm.mealplans[code];
            if (name) {
                names.push(name);
            }
        }
        return names.join(', ');
    };
    vm.showModalFamilias = (modal, room) => {
        vm.roomFamSelected = room;
        $(`#${modal}`).modal("show");
        $timeout(() => {
            vm.updateRoomsFamiliesHeight();
            $scope.$applyAsync();
        }, 50);
    }
    vm.getNumDistriOnlyMinors = (params) => {
        let datos = params.split("|");
        const childrenAges = datos[1] ? datos[1].split(",").join(", ") : "";
        if (childrenAges) {
            return `(${childrenAges} ${childrenAges != 1 ? lang.years : lang.year})`;
        }
    };
    vm.filterRatesByPax = function (selectedPax) {
        return function (rate) {
            if (!selectedPax) {
                return true;
            }
            return rate.paxFam === selectedPax;
        };
    };
    vm.ttitleSummaryModalAdd = (pax) => {
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        if (pax) {
            let datos = pax.split("|");
            const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
            if (datos.length > 1) {
                var titleChildren = datos[1].split(",").length == 1 ? lang.child : lang.children
                return `1 ${lang.room}, ${nightCounts} ${nightTitle} ${lang.for} ${datos[0]} ${adultsTitle} y ${datos[1].split(",").length} ${titleChildren}`;
            } else {
                return `1 ${lang.room}, ${nightCounts} ${nightTitle} ${lang.for} ${datos[0]} ${adultsTitle}`;
            }
        }

    }
    vm.getTitleStickyDetailFam = (params, rate) => {
        if (!params) return "";

        const [adultsStr, minorsStr] = params.split("|");
        const adultCount = parseInt(adultsStr) * (rate?.selectedRoomValue || 1);
        const multiplier = rate?.selectedRoomValue || 1;
        let minors = [];
        if (minorsStr) {
            minors = Array(multiplier).fill(minorsStr.split(",")).flat().map(m => m.trim());
        }

        const minorCount = minors.length;
        const adultsTitle = adultCount === 1 ? lang.adult : lang.adults;
        const childrenTitle = minorCount === 1 ? lang.child : lang.children;

        let result = `${adultCount} ${adultsTitle}`;

        if (minorCount > 0) {
            const minorsByAge = minors.reduce((acc, age) => {
                acc[age] = (acc[age] || 0) + 1;
                return acc;
            }, {});
            const formattedAges = Object.entries(minorsByAge).map(([age, count]) => {
                const ageText = age === "1" ? lang.year : lang.years;
                const minorText = count > 1 ? lang.children : lang.child;
                return `${count} ${minorText} ${lang.the} ${age} ${ageText}`
            });
            const agesDisplay = minors.map(age => {
                return age === "1" ? `${age} ${lang.year}` : `${age} ${lang.years}`;
            }).join(` ${lang.and} `);

            result += ` y ${minorCount} ${childrenTitle}`;

            if (minorCount <= 2) {
                result += ` <span class="font-14 font-400 font-subtle">(${agesDisplay})</span>`;
            } else {
                result += ` <span class="font-14 font-400 font-subtle">(${formattedAges.join(',<br>')})</span>`;
            }
        }

        return result;
    };
    vm.selectedRateRoomFam = (rate, selectedRoom, room) => {
        const totalSelected = vm.stickyRates
            .reduce((sum, r) => sum + (r.selectedRoomValue || 0), 0);

        if (totalSelected >= 8) {
            vm.availableLimitMobile = true;
            setTimeout(() => {
                $scope.$applyAsync(() => { vm.availableLimitMobile = false; });
            }, 2000);
            return;
        }
        rate.selectedRoomValue = rate.selectedRoomValue + selectedRoom;
        if (selectedRoom !== 0) {
            const existingRateIndex = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);

            if (existingRateIndex !== -1) {
                vm.stickyRates[existingRateIndex].selectedRoomValue = rate.selectedRoomValue;
            } else {
                rate.name = room.name;
                rate.roomId = room.roomId;
                rate.img = room.picture.cloudUri;
                vm.stickyRates.push(rate);
            }
        } else {
            const index = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);
            if (index !== -1) {
                vm.stickyRates.splice(index, 1);
            }
        }
        $(`#rooms-families`).modal("hide");
        $('#collapseSticky').collapse('show');
        vm.viewDetailSticky = true;
    };

    vm.modalDialogHeight = 0;
    vm.updateRoomsFamiliesHeight = () => {
        const el = document.querySelector('#rooms-families .modal-dialog');
        if (el) {
            const rect = el.getBoundingClientRect();
            vm.modalDialogHeight = Math.round(rect.height);
        }
    };

    $(document).ready(() => {
        if (!vm.appicableExperiment && !vm.ApplyFamilyRules) {
            observeSectionById('footer');
            initVisibilityListener();
            const modalEl = $('#rooms-families');
            if (modalEl && modalEl.length) {
                modalEl.on('shown.bs.modal', () => {
                    $timeout(() => {
                        vm.updateRoomsFamiliesHeight();
                        $scope.$applyAsync();
                    }, 50);
                });
                modalEl.on('hidden.bs.modal', () => {
                    vm.modalDialogHeight = 0;
                    $scope.$applyAsync();
                });
            }
            window.addEventListener('resize', () => {
                if ($('#rooms-families').hasClass('show')) {
                    vm.updateRoomsFamiliesHeight();
                    $scope.$applyAsync();
                }
            });
        }
    });

    function observeSectionById(sectionId) {
        const target = document.getElementById(sectionId);
        if (!target) return;
        const familiesContentAssing = document.getElementById('familiesContentAssing');
        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    familiesContentAssing.style.display = 'none';
                } else {
                    familiesContentAssing.style.display = 'flex';
                }
            });
        }, {
            threshold: 0.5
        });

        observer.observe(target);
    }

    vm.setRecomedationLabel = () => {
        const roomTitle = vm.recomendationsList.totalRooms == 1 ? lang.room : lang.rooms;
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? lang.child : lang.children;
        const childrenPart = newPax.paxes.children.length > 0
            ? `, ${newPax.paxes.children.length} ${childrenTitle}`
            : '';
        return `${vm.recomendationsList.totalRooms} ${roomTitle} ${lang.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }
    vm.setRecomendationMetas = () => {
        const roomTitle = vm.roomsTotal == 1 ? lang.room : lang.rooms;
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? lang.child : lang.children;
        const childrenPart = newPax.paxes.children.length > 0
            ? `, ${newPax.paxes.children.length} ${childrenTitle}`
            : '';
        return `${vm.roomsTotal} ${roomTitle} ${lang.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }
    vm.getRecomendateDatePaxNight = (days) => {
        const nightTitle = days == 1 ? lang.night : lang.nights;
        return `${days} ${nightTitle}`;
    }
    vm.getRecomendateDatePax = (days) => {
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? lang.child : lang.children;
        const childrenPart = newPax.paxes.children.length > 0
            ? ` ${lang.and} ${newPax.paxes.children.length} ${childrenTitle}:`
            : ':';
        return `${lang.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }

    vm.getIsPaxesDefined = () => {
        return newPax.paxes.adults == 2 && newPax.paxes.children.length == 0;
    }
    vm.getRoom = (total) => {
        return `${total == 1 ? lang.room : lang.rooms}`;
    }
    vm.getTitleStickyDetail = (paramns, rate) => {
        if (params) {
            let datos = paramns.split("|");
            const adultsTitle = datos[0] * rate.selectedRoomValue == 1 ? lang.adult : lang.adults;
            const childrenAges = datos[1] ? datos[1].split(",").length * rate.selectedRoomValue : "";
            if (childrenAges) {
                const childrenTitle = datos[1].split(",").length * rate.selectedRoomValue == 1 ? lang.child : lang.children;
                return `${datos[0] * rate.selectedRoomValue} ${adultsTitle}, ${datos[1].split(",").length * rate.selectedRoomValue} ${childrenTitle}`;
            } else {
                return `${datos[0] * rate.selectedRoomValue} ${adultsTitle}`;
            }
        }
    }
    vm.getNumDistri = (params, AorM) => {
        if (params) {
            let datos = params.split("|");
            const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
            if (datos.length > 1) {
                var titleChildren = datos[1].split(",").length == 1 ? lang.child : lang.children
                return AorM ? `${datos[0]} ${adultsTitle}` : `${datos[1].split(",").length} ${titleChildren}`;
            } else {
                return AorM ? `${datos[0]} ${adultsTitle}` : 0;
            }
        }
    }
    vm.getTitleRecomendedPax = (params) => {
        if (params) {
            let datos = params.split("|");
            const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
            if (datos.length > 1) {
                var titleChildren = datos[1].split(",").length == 1 ? lang.child : lang.children;
                return `${datos[0]} ${adultsTitle}, ${datos[1].split(",").length} ${titleChildren}`;
            } else {
                return `${datos[0]} ${adultsTitle}`;
            }
        }
    }
    //(1 y 4 años)
    vm.getNumDistriToltip = (params) => {
        let datos = params.split("|");
        const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
        const childrenAges = datos[1] ? datos[1].split(",").join(", ") : "";
        if (childrenAges) {
            const childrenTitle = datos[1].length == 1 ? lang.child : lang.children;
            return `(${childrenAges} años)`;
        }
    };
    vm.getNumDistriMovil = (params, AorM) => {
        if (params) {
            let datos = params.split("|");
            if (datos.length > 1) {
                return AorM ? parseInt(datos[0]) : parseInt(datos[1].split(",").length);
            } else {
                return AorM ? parseInt(datos[0]) : 0;
            }
        }
    }
    vm.distriTablePax = (params) => {
        if (params) {
            let datos = params.split("|");
            const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
            const childrenTitle = datos[1] && datos[1].split(",").length == 1 ? lang.child : lang.children;

            const childrenAges = datos[1] ? datos[1].split(",").join(", ") : "";
            if (childrenAges) {
                return `${parseInt(datos[0])} ${adultsTitle}, ${datos[1].split(",").length} ${childrenTitle} ${lang.the} ${childrenAges} ${datos[1].split(",").length == 1 && childrenAges == "1" ? lang.year : lang.years}`;
            } else {
                return `${parseInt(datos[0])} ${adultsTitle}`;
            }

        }
    };
    //(1 y 4 años)
    vm.getNumDistriToltipMovil = (params) => {
        let datos = params.split("|");
        const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
        const childrenAges = datos[1] ? datos[1].split(",").join(", ") : "";
        if (childrenAges) {
            const childrenTitle = datos[1].split(",").length == 1 ? lang.child : lang.children;
            return `${datos[0]} ${adultsTitle} y ${datos[1].split(",").length} ${childrenTitle} (de ${childrenAges} ${lang.years})`;
        } else {
            return `${datos[0]} ${adultsTitle}`;
        }
    };
    vm.getRecomendationTitlePax = (params) => {
        let datos = params.split("|");
        const rooms = newPax.paxes.rooms > 1 ? `${lang.fora} ${lang.room}` : ``;
        if (datos.length > 1) {
            const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;

            const childrenTitle = datos[1].split(",").length == 1 ? lang.child : lang.children;
            return `${lang.for} ${datos[0]} ${adultsTitle},  ${datos[1].split(",").length} ${childrenTitle} ${rooms}`;
        } else {
            const adultsTitle = datos[0] == 1 ? lang.adult : lang.adults;
            return `${lang.for} ${datos[0]} ${adultsTitle} ${rooms}`;
        }
    }
    vm.titlePax = () => {
        const roomTitle = vm.recomendationsList.totalRooms == 1 ? lang.room : lang.rooms;
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        return `${vm.recomendationsList.totalRooms} ${roomTitle}, ${nightCounts} ${nightTitle} `;
    }
    vm.titlePaxMeta = () => {
        const roomTitle = vm.roomsTotal == 1 ? lang.room : lang.rooms;
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? lang.child : lang.children;
        const childrenPart = newPax.paxes.children.length > 0 ? `, ${newPax.paxes.children.length} ${childrenTitle}` : '';
        return `${vm.roomsTotal} ${roomTitle}, ${nightCounts} ${nightTitle} ${lang.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }
    vm.getTitleSticky = () => {
        const nightCounts = vm.getNights();
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        return `${vm.totalRoomSticky} ${vm.totalRoomSticky > 1 ? lang.rooms : lang.room}, ${vm.getNights()} ${nightTitle}`;
    }
    vm.getNights = () => {
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        return fn.diffBetweenDays(checkIn, checkOut);
    }

    vm.getStayDates = () => {
        const formatStayDate = (date) => window.dayjs(fn.getDate(date)).format(settings.formatBoxDate).replace(/\./g, '');
        return {
            checkIn: formatStayDate(paramsRoomRates.checkin),
            checkOut: formatStayDate(paramsRoomRates.checkout)
        };
    }
    vm.getTitleModalRAPD = (isRecommendation) => {
        if (!isRecommendation) {
            return `${lang.total} ${vm.totalRoomSticky} ${vm.totalRoomSticky > 1 ? lang.rooms : lang.room}, ${vm.sumTotalSticky} ${vm.sumTotalSticky > 1 ? lang.persons : lang.person}:`;
        } else {
            const sumTotal = newPax.paxes.adults + newPax.children;
            return `${lang.total} ${vm.recomendationsList.totalRooms} ${vm.recomendationsList.totalRooms > 1 ? lang.rooms : lang.room}, ${sumTotal} ${sumTotal > 1 ? lang.persons : lang.person}:`;
        }

    }
    vm.getRecomendationTitleTotal = () => {
        const adultsTitle = newPax.paxes.adults == 1 ? lang.adult : lang.adults;
        const childrenPart = newPax.children > 0
            ? `, ${newPax.children} ${newPax.children == 1 ? lang.child : lang.children}`
            : '';
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        return `${nightCounts} ${nightTitle}, ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    };
    vm.asigRateModal = (rate, room = {}) => {
        vm.assigRateSet = rate;
        vm.selectModalRoom = vm.assigRateSet.selectedRoomValue ?? 0;
        vm.assigRoomRateModal = room;
    }
    vm.showModal = (modal, btnTitle = "", btnText = "") => {
        $(`#${modal}`).modal("show");
        if (modal == "modal-payform" || modal == "modal-contact") {
            trackerFooter.selectContent(btnTitle, btnText);
        }
        if (modal === 'gallery-modal') {
            memorySlider = {};
            let paramsClasification = {
                hotelId: vm.hotel.hotelId,
                culture: cultureData.internalCultureCode
            };
            $http.get(config.endPoints.clasificationsUrl, { params: paramsClasification, headers: getHeaders() }).then(onSuccessClasifications, (err) => {
                onErrorCategories(err);
            });
        }
    }

    vm.toggleReviewsTooltip = () => {
        vm.showReviewsTooltip = !vm.showReviewsTooltip;
    }

    vm.closeFiltersModal = () => {
        $('#modal_reviews_filters').modal('hide');

        $timeout(() => {
            const modalReviews = $('#modal_reviews');
            if (modalReviews.hasClass('show')) {
                modalReviews.css({
                    'overflow-y': 'auto',
                    'pointer-events': 'auto'
                });

                const reviewsContainer = modalReviews.find('#reviews-container');
                if (reviewsContainer.length) {
                    reviewsContainer.css({
                        'overflow-y': 'auto',
                        'max-height': 'none'
                    });
                }

                modalReviews.focus();

                if (reviewsContainer.length) {
                    reviewsContainer.trigger('scroll');
                }
            }
        }, 150);
    }

    $timeout(() => {
        const modalFilters = $('#modal_reviews_filters');
        const modalReviews = $('#modal_reviews');

        if (modalFilters.length) {
            modalFilters.off('hidden.bs.modal.reviewsFilterFix');
            modalFilters.off('shown.bs.modal.reviewsFilterFix');

            modalFilters.on('hidden.bs.modal.reviewsFilterFix', function () {
                $timeout(() => {
                    if (modalReviews.hasClass('show')) {
                        modalReviews.css({
                            'overflow-y': 'auto',
                            'pointer-events': 'auto',
                            'overflow': 'auto'
                        });

                        const reviewsContainer = modalReviews.find('#reviews-container');
                        if (reviewsContainer.length) {
                            reviewsContainer.css({
                                'overflow-y': 'auto',
                                'max-height': 'none',
                                'overflow': 'auto'
                            });
                        }

                        const modalContent = modalReviews.find('.modal-content');
                        if (modalContent.length) {
                            modalContent.css({
                                'overflow-y': 'auto',
                                'max-height': 'none'
                            });
                        }

                        modalReviews.focus();

                    }
                }, 50);
            });

            modalFilters.on('shown.bs.modal.reviewsFilterFix', function () {
                modalFilters.focus();
            });
        }
    }, 1000);

    vm.showModalReviews = (modal, option) => {
        var content = new Object();
        content.calf = vm.hotel.surveyAverage ? vm.hotel.surveyAverage.averageValue : 0;
        content.calfDesc = $filter('getRatingDesc')(vm.hotel.surveyAverage ? vm.hotel.surveyAverage.averageValue : 0);
        content.content_type = "link";
        if (option == "galery") {
            content.elementText = "reviews_header";
        } else if (option = "detail") {
            content.elementText = "reviews_content";
        }
        tracker.selectedReviews(content);
        vm.getReviews(vm.hotel.hotelId, true);

        if (modal === 'modal_reviews') {
            window.reviewsScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            vm.buttonFloating();
        }

        $(`#${modal}`).modal("show");

        if (modal === 'modal_reviews') {
            $(`#${modal}`).one('hidden.bs.modal', function () {
                vm.cleanupScrollListener();

                if (!vm.modalClosedManually) {
                    if (window.reviewsScrollPosition !== undefined) {
                        window.scrollTo(0, window.reviewsScrollPosition);
                        window.reviewsScrollPosition = undefined;
                    }
                }
                vm.modalClosedManually = false;
            });
        }
    }

    vm.hideModal = (modal) => {
        if (modal === 'modal_reviews') {
            vm.showScrollToTop = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }

            $('#modal_reviews').off('scroll.scrollToTop').off('shown.bs.modal.scrollToTop');

            if (window.reviewsScrollPosition !== undefined) {
                window.scrollTo(0, window.reviewsScrollPosition);
                window.reviewsScrollPosition = undefined;
            }
        }

        $(`#${modal}`).modal("hide");
    }

    vm.closeReviewsModal = () => {
        $('#modal_reviews').modal('hide');
    }

    vm.closeModal = (modal) => {
        if (modal === 'modal_reviews') {
            vm.modalClosedManually = true;
            vm.cleanupScrollListener();
        }
        $(`#${modal}`).modal("hide");
    }

    vm.showScrollToTop = false;
    vm.scrollElement = null;

    vm.scrollToTopReviews = () => {
        if (vm.scrollElement) {
            if (vm.scrollElement === window) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                vm.scrollElement.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    };

    vm.buttonFloating = () => {
        $timeout(() => {
            const modalReviews = document.getElementById('modal_reviews');
            const modalDialog = modalReviews?.querySelector('.modal-dialog');
            const modalContent = modalReviews?.querySelector('.modal-content');
            const reviewsContainer = document.getElementById('reviews-container');

            let scrollElement = null;
            if (modalReviews && modalReviews.scrollHeight > modalReviews.clientHeight) {
                scrollElement = modalReviews;
            } else if (modalDialog && modalDialog.scrollHeight > modalDialog.clientHeight) {
                scrollElement = modalDialog;
            } else if (modalContent && modalContent.scrollHeight > modalContent.clientHeight) {
                scrollElement = modalContent;
            } else if (reviewsContainer && reviewsContainer.scrollHeight > reviewsContainer.clientHeight) {
                scrollElement = reviewsContainer;
            } else {
                scrollElement = window;
            }

            vm.scrollElement = scrollElement;

            const handleScroll = () => {
                const scrollTop = scrollElement === window ? window.scrollY : scrollElement.scrollTop;

                let shouldShow = vm.showScrollToTop;

                if (!vm.showScrollToTop && scrollTop > 200) {
                    shouldShow = true;
                } else if (vm.showScrollToTop && scrollTop < 100) {
                    shouldShow = false;
                }

                if (shouldShow !== vm.showScrollToTop) {
                    vm.showScrollToTop = shouldShow;

                    try {
                        if (!$scope.$$phase && !$scope.$root.$$phase) {
                            $scope.$digest();
                        }
                    } catch (e) {
                        console.warn('⚠️ Error en digest:', e.message);
                    }
                }
            };

            if (scrollElement === window) {
                window.removeEventListener('scroll', handleScroll);
                window.addEventListener('scroll', handleScroll, { passive: true });
            } else {
                scrollElement.removeEventListener('scroll', handleScroll);
                scrollElement.addEventListener('scroll', handleScroll, { passive: true });
            }

            const initialScrollTop = scrollElement === window ? window.scrollY : scrollElement.scrollTop;

            if (initialScrollTop > 200) {
                vm.showScrollToTop = true;
                try {
                    if (!$scope.$$phase && !$scope.$root.$$phase) {
                        $scope.$digest();
                    }
                } catch (e) {
                    console.warn('⚠️ Error en digest inicial:', e.message);
                }
            }
        }, 1000);
    };

    vm.cleanupScrollListener = () => {
        vm.showScrollToTop = false;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
        $('#modal_reviews').off('shown.bs.modal.scrollCheck');
    };

    vm.testScrollToTopButton = () => {
        vm.showScrollToTop = !vm.showScrollToTop;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    };

    vm.forceShowScrollButton = () => {
        vm.showScrollToTop = true;
        try {
            if (!$scope.$$phase && !$scope.$root.$$phase) {
                $scope.$digest();
            }
        } catch (e) {
            console.warn('⚠️ Error en digest force show:', e.message);
        }

        $timeout(() => {
            const btn = document.querySelector('.btnFloating');
        }, 100);
    };

    vm.forceHideScrollButton = () => {
        vm.showScrollToTop = false;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    };

    if (typeof window !== 'undefined') {
        window.debugScrollButton = vm.testScrollToTopButton;
        window.forceShowScroll = vm.forceShowScrollButton;
        window.forceHideScroll = vm.forceHideScrollButton;

        window.vmHandleVideoLoad = vm.handleVideoLoad;
        window.vmHandleThumbnailVideoLoad = vm.handleThumbnailVideoLoad;
    }

    vm.getHotelDescription = () => {
        let text = vm.hotel.description || '';
        let MAXIMUM_LETTERS = 500;
        let textLengthTotal = text.length;
        let residui = text.length - MAXIMUM_LETTERS;

        if (residui > 40) {
            vm.showMoreHotelDescription = true;
        }

        if (!vm.toggleDescription && text && textLengthTotal > 500 && vm.showMoreHotelDescription) {
            return text.substring(0, 500) + '...';
        }

        return text;
    };

    vm.getHotelFeeDescription = () => {
        let text = '';
        let MAXIMUM_LETTERS = 500
        if (vm.hotel.fees) {
            const description = vm.hotel.fees.description || '';
            const alternative = vm.hotel.fees.alternative || '';

            const validDescription = hasMeaningfulContent(description) ? description : '';
            const validAlternative = hasMeaningfulContent(alternative) ? alternative : '';

            text = [validDescription, validAlternative].filter(Boolean).join('');
        }

        if (text == "" && vm.cheaperRoomRate.externalSalesAdvisory) {
            text = vm.cheaperRoomRate.externalSalesAdvisory;
        }
        let textLengthTotal = text.length;
        let residui = text.length - MAXIMUM_LETTERS;

        if (residui > 40) {
            vm.showMoreDetail = true;
        }

        if (!vm.cheaperRoomRate.showAditional && text && textLengthTotal > 500 && vm.showMoreDetail) {
            return text.substring(0, 500) + '...';
        }

        return text;
    };

    vm.getCheckInInstructions = () => {
        let text = '';
        let MAXIMUM_LETTERS = 500;
        const checkInInstructions = vm.hotel.checkInInstructions || '';
        const validCheckInInstructions = hasMeaningfulContent(checkInInstructions) ? checkInInstructions : '';

        text = validCheckInInstructions;

        let textLengthTotal = text.length;
        let residui = text.length - MAXIMUM_LETTERS;

        if (residui > 40) {
            vm.showMoreCheckIn = true;
        }

        if (!vm.showAditionalCheckIn && text && textLengthTotal > 500 && vm.showMoreCheckIn) {
            return text.substring(0, 500) + '...';
        }

        return text;
    };
    vm.getHotelFeeDescriptionComplete = () => {
        let text = '';

        if (vm.hotel.fees) {
            const description = vm.hotel.fees.description || '';
            const alternative = vm.hotel.fees.alternative || '';

            const validDescription = hasMeaningfulContent(description) ? description : '';
            const validAlternative = hasMeaningfulContent(alternative) ? alternative : '';

            text = [validDescription, validAlternative].filter(Boolean).join('');
        }

        if (text == "" && vm.cheaperRoomRate.externalSalesAdvisory) {
            text = vm.cheaperRoomRate.externalSalesAdvisory;
        }


        return text;
    };

    vm.getCheckInInstructionsComplete = () => {
        const checkInInstructions = vm.hotel.checkInInstructions || '';
        return hasMeaningfulContent(checkInInstructions) ? checkInInstructions : '';
    };


    vm.eventSetReviews = () => {
        vm.showDetailScoreReviews = !vm.showDetailScoreReviews;
        var content = new Object();
        content.calf = vm.hotel.surveyAverage ? vm.hotel.surveyAverage.averageValue : 0;
        content.calfDesc = $filter('getRatingDesc')(vm.hotel.surveyAverage ? vm.hotel.surveyAverage.averageValue : 0);
        content.elementText = "reviews_scoredetail";
        content.content_type = "button";
        tracker.selectedReviews(content);
    }
    vm.showModalRAPDOrigin = (modal, rate, room) => {
        if (rate) {
            vm.RateForRAPD = rate;
            vm.roomsForRAPD = room;
        }
        $(`#${modal}`).modal("show");
    }

    vm.handleReviewsModalScroll = (modal) => {
        if (vm.scrollToReviewText) {
            $(`#${modal}`).one('shown.bs.modal', function () {
                setTimeout(() => {
                    const targetIndex = vm.listReviews.verified.recent.findIndex(review =>
                        review.text && review.text.trim() === vm.scrollToReviewText
                    );

                    if (targetIndex !== -1) {
                        const reviewElement = document.getElementById(`review-${targetIndex}`);
                        if (reviewElement) {
                            reviewElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }
                    vm.scrollToReviewText = null;
                }, 300);
            });
        }
    };

    vm.showModalRAPD = (modal, rate, room, roomIndex, trivago = false) => {

        if (modal === 'modal_reviews') {
            vm.scrollToReviewText = (rate && typeof rate === 'string' && rate.trim().length > 0)
                ? rate.trim()
                : null;
            vm.buttonFloating();
        } else if (modal === 'modal_reviews_filters') {
            const modalReviews = $('#modal_reviews');
            if (modalReviews.hasClass('show')) {
                modalReviews.css('pointer-events', 'none');
            }
        } else {
            if (rate) {
                vm.rateModal = rate;
                vm.roomModal = room;
                vm.roomModal.totalRooms = vm.isRequote ? newPaxRequote.paxes.rooms : newPax.paxes.rooms;
                vm.roomIndexModal = roomIndex;
                vm.isTrivagoModal = trivago;
            }
        }

        $(`#${modal}`).modal("show");

        if (modal === 'modal_reviews') {
            vm.handleReviewsModalScroll(modal);

            $(`#${modal}`).one('hidden.bs.modal', function () {
                vm.cleanupScrollListener();

                if (!vm.modalClosedManually) {
                    if (window.reviewsScrollPosition !== undefined) {
                        window.scrollTo(0, window.reviewsScrollPosition);
                        window.reviewsScrollPosition = undefined;
                    }
                }
                vm.modalClosedManually = false;
            });
        }
    }
    vm.showModalRAPDFam = (modal, isRecommendation = false, isUnique = false) => {
        vm.isTrivagoModal = false;
        if (vm.stickyRates == 0 && !isRecommendation && !isUnique) {
            vm.hasErrorHandle = true;
            return;
        } else {
            vm.hasErrorHandle = false;
        }

        vm.modalRapdCurrentData = null;
        vm.RAPDObject = {
            totalSticky: 0,
            totalHasTaxSticky: false,
            totalImpSticky: 0,
            totalTotalSticky: 0,
            feesAmountTotal: 0,
            paymentNow: false
        };
        if (isRecommendation || isUnique) {
            let totalAdulst = 0;
            let totalChildrens = 0;
            // Verificar las condiciones en vm.recomendationsList.rooms
            const allConditionsMet = Object.values(isUnique ? vm.recomendationsListUnique.rooms : vm.recomendationsList.rooms).every(room => {
                // Asegúrate de ajustar las propiedades y condiciones según la estructura de tus datos
                const rate = room.rate.rate || room.rate;
                const paxFamParts = rate.paxFam.split('|');
                const adults = paxFamParts[0] ? parseInt(paxFamParts[0]) : 0;
                const childs = paxFamParts[1] ? parseInt(paxFamParts[1].split(',').length) : 0;
                totalAdulst += adults;
                totalChildrens += childs;
                if (rate && rate.bookNowPayLaterTimeLimit && rate.isBookNowPayLaterApplicable && !vm.isBlockRAPD && rate.collectType != 2 && !isUnique) {
                    vm.dateRAPDSticky = rate.bookNowPayLaterTimeLimit;
                    return true; // La condición se cumple
                } else {
                    return false; // La condición no se cumple
                }
            });

            if (allConditionsMet && modal) {
                let checkIn = fn.getDate(paramsRoomRates.checkin);
                let checkOut = fn.getDate(paramsRoomRates.checkout);
                const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
                const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
                const adultsTitle = totalAdulst == 1 ? lang.adult : lang.adults;
                const childrenPart = totalChildrens > 0
                    ? `, ${totalChildrens} ${totalChildrens == 1 ? lang.child : lang.children}`
                    : '';
                vm.sumTotalSticky = totalAdulst + totalChildrens;
                vm.getRecomedationLabelSticky = `${nightCounts} ${nightTitle}, ${totalAdulst} ${adultsTitle}${childrenPart}`;

                vm.isRecomendationCheckout = true;
                vm.applicableRAPDSticky = true;
                vm.RAPDObject.totalSticky = isUnique ? vm.recomendationsListUnique.totalRoomRatePerNight : vm.recomendationsList.totalRoomRatePerNight;
                vm.RAPDObject.totalHasTaxSticky = isUnique ? vm.recomendationsListUnique.hasTaxes : vm.recomendationsList.hasTaxes;
                vm.RAPDObject.totalImpSticky = isUnique ? vm.recomendationsListUnique.totalTaxesPerRoomPerNight : vm.recomendationsList.totalTaxesPerRoomPerNight;
                vm.RAPDObject.totalTotalSticky = isUnique ? vm.recomendationsListUnique.totalRoomRate : vm.recomendationsList.totalRoomRate;
                const sumTotal = newPax.paxes.adults + newPax.children;
                vm.RAPDObject.TotalPersons = sumTotal;
                vm.RAPDObject.TotalRooms = isUnique ? vm.recomendationsListUnique.totalRooms : vm.recomendationsList.totalRooms;
                vm.RAPDObject.feesAmountTotal = isUnique ? vm.recomendationsListUnique.feesAmountTotal : vm.recomendationsList.feesAmountTotal;
                vm.TitleModalRAPD = vm.getTitleModalRAPD(isRecommendation);
                $(`#${modal}`).modal("show");
            } else {
                vm.applicableRAPDSticky = false;
                vm.onSubmit(null, null, null, false, isRecommendation, false, isUnique);
            }
        } else {
            if (vm.applicableRAPDSticky && modal) {
                vm.isRecomendationCheckout = false;
                vm.RAPDObject.totalSticky = vm.totalSticky;
                vm.RAPDObject.totalHasTaxSticky = vm.totalHasTaxSticky;
                vm.RAPDObject.totalImpSticky = vm.totalImpSticky;
                vm.RAPDObject.totalFeesIncludes = vm.totalFeesIncludes;
                vm.RAPDObject.TotalPersons = vm.sumTotalSticky;
                vm.RAPDObject.totalTotalSticky = vm.totalTotalSticky;
                vm.RAPDObject.TotalRooms = vm.totalRoomSticky;
                vm.RAPDObject.feesAmountTotal = vm.totalFeesIncludes;
                vm.TitleModalRAPD = vm.getTitleModalRAPD(false);
                $(`#${modal}`).modal("show");
            } else {
                vm.onSubmit(null, null, null, false, false);
            }
        }
    }
    vm.showModalShared = (modal) => {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                url: window.location.href
            }).catch(err => console.log('Error sharing:', err));
        } else {
            $(`#${modal}`).modal("show");
        }
    }

    vm.showAmenitiesModal = (modal, room) => {
        vm.showModal(modal);
        vm.currentRoom = { ...room };

        if (room.currentImageIndex !== undefined) {
            vm.currentRoom.currentImageIndex = room.currentImageIndex;
        } else if (!vm.currentRoom.currentImageIndex) {
            vm.currentRoom.currentImageIndex = 0;
        }

        if (room.galleryPosition !== undefined) {
            vm.currentRoom.galleryPosition = room.galleryPosition;
            vm.currentRoom.currentImageIndex = Math.abs((room.galleryPosition - 1) % room.pictures.length);
        } else if (!vm.currentRoom.galleryPosition) {
            vm.currentRoom.galleryPosition = (vm.currentRoom.currentImageIndex || 0) + 1;
        }

        const usedConfigIndices = new Set();
        const featuredAmenities = [];
        const regularAmenities = [];

        (room.amenities || []).forEach(function (amenity) {
            if (amenity.includes('$')) {
                return;
            }

            const lowerAmenity = amenity.toLowerCase();
            let foundIndex = -1;

            for (let i = 0; i < featuredAmenitiesConfig.length; i++) {
                if (featuredAmenitiesConfig[i].keywords.some(kw => lowerAmenity.includes(kw.toLowerCase()))) {
                    foundIndex = i;
                    break;
                }
            }

            if (foundIndex !== -1 && !usedConfigIndices.has(foundIndex)) {
                usedConfigIndices.add(foundIndex);
                featuredAmenities.push({ label: amenity, icon: featuredAmenitiesConfig[foundIndex].icon });
            } else {
                regularAmenities.push(amenity);
            }
        });

        vm.currentRoom.featuredAmenities = featuredAmenities;
        vm.currentRoom.regularAmenities = regularAmenities;

        $timeout(() => {
            vm.initCustomCarousel();
        }, 200);
    }

    vm.initCustomCarousel = () => {
        if (!vm.currentRoom || !vm.currentRoom.pictures || vm.currentRoom.pictures.length <= 1) {
            return;
        }

        const maxIndex = vm.currentRoom.pictures.length - 1;
        if (vm.currentRoom.currentImageIndex > maxIndex) {
            vm.currentRoom.currentImageIndex = 0;
        }

        // Posición inicial sin transición para apertura del modal
        vm.updateCarouselPosition(false);

        // Restaurar transiciones después de un breve delay
        $timeout(() => {
            const track = document.getElementById('room-carousel-track');
            if (track) {
                track.style.transition = 'transform 0.3s ease-in-out';
            }
        }, 100);

        $timeout(() => {
            if (window.CarouselManager) {
                window.CarouselManager.initCarousel({
                    carouselId: 'room-gallery-carousel',
                    modalId: 'modal-room-amenities',
                    nextFunction: vm.nextRoomImage,
                    prevFunction: vm.prevRoomImage,
                    scope: $scope,
                    minSwipeDistance: 50
                });
            }
        }, 50);
    }


    vm.updateCarouselPosition = (useTransition = true) => {
        const track = document.getElementById('room-carousel-track');
        const slides = document.querySelectorAll('#room-carousel-track .carousel-slide');

        if (track && slides.length > 0) {
            const currentIndex = vm.currentRoom.currentImageIndex || 0;
            const translateX = -currentIndex * 100;

            // Aplicar o quitar transición según el parámetro
            if (useTransition) {
                track.style.transition = 'transform 0.3s ease-in-out';
            } else {
                track.style.transition = 'none';
            }

            track.style.transform = `translateX(${translateX}%)`;

            slides.forEach((slide, index) => {
                slide.classList.toggle('active', index === currentIndex);
            });
        }
    }

    vm.prevRoomImage = () => {
        if (!vm.currentRoom || !vm.currentRoom.pictures) return;

        const currentIndex = vm.currentRoom.currentImageIndex || 0;
        const newIndex = currentIndex > 0 ? currentIndex - 1 : vm.currentRoom.pictures.length - 1;

        vm.currentRoom.currentImageIndex = newIndex;
        vm.currentRoom.galleryPosition = newIndex + 1;
        vm.updateCarouselPosition();

        vm.syncRoomMainImage();

        if (window.CarouselManager) {
            window.CarouselManager.triggerThumbnailAutoScroll('modal-room-amenities');
        }
    }

    vm.scrollToDetailSection = (id) => {
        const modalBody = document.querySelector('#modal-room-amenities .modal-body');
        const element = document.getElementById(id);
        if (modalBody && element) {
            const offset = element.offsetTop - 40; // Adjust for sticky nav height (~44px)
            modalBody.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
            vm.activeDetailSection = id.includes('amenities') ? 'amenities' : 'notes';
        }
    };

    vm.nextRoomImage = () => {
        if (!vm.currentRoom || !vm.currentRoom.pictures) return;

        const currentIndex = vm.currentRoom.currentImageIndex || 0;
        const newIndex = currentIndex < vm.currentRoom.pictures.length - 1 ? currentIndex + 1 : 0;

        vm.currentRoom.currentImageIndex = newIndex;
        vm.currentRoom.galleryPosition = newIndex + 1;
        vm.updateCarouselPosition();

        vm.syncRoomMainImage();

        if (window.CarouselManager) {
            window.CarouselManager.triggerThumbnailAutoScroll('modal-room-amenities');
        }
    }





    vm.slideRoomCarousel = (event, room, direction) => {
        event.preventDefault();

        if (!room.pictures || room.pictures.length <= 1) return;

        if (room.isTransitioning) return;
        room.isTransitioning = true;

        const currentIndex = room.currentImageIndex || 0;
        const maxIndex = room.pictures.length - 1;

        let newIndex;
        if (direction === 'right') {
            newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        } else {
            newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        }

        room.currentImageIndex = newIndex;
        room.galleryPosition = newIndex + 1;
        room.picture.cloudUri = room.pictures[newIndex]["cloudUri"];

        vm.updateRoomCarouselPosition(room);

        setTimeout(() => {
            room.isTransitioning = false;
        }, 300);

        if (vm.currentRoom && vm.currentRoom.roomId === room.roomId) {
            vm.currentRoom.currentImageIndex = newIndex;
            vm.currentRoom.galleryPosition = newIndex + 1;
            vm.updateCarouselPosition();
        }
    }

    vm.updateDotsPosition = () => {
        const current = vm.hotel.currentImageIndex || 0;
        const totalDots = vm.gallery ? vm.gallery.length : 0;

        const inactiveDotWidth = 12;
        const activeDotWidth = 35;
        const gap = 6;
        const padding = 6;
        const containerWidth = 119;

        const totalTrackWidth = ((totalDots > 0 ? totalDots - 1 : 0) * (inactiveDotWidth + gap)) + (totalDots > 0 ? activeDotWidth : 0);
        const contentWidth = containerWidth - (2 * padding);

        if (totalTrackWidth <= contentWidth) {
            vm.dotsTranslateX = 0;
            return;
        }

        const activeDotLeft = current * (inactiveDotWidth + gap);
        const activeDotCenter = activeDotLeft + (activeDotWidth / 2);

        let translate = (containerWidth / 2) - padding - activeDotCenter;

        translate = Math.min(0, translate);
        const minTranslate = contentWidth - totalTrackWidth;
        translate = Math.max(minTranslate, translate);

        vm.dotsTranslateX = translate;
    }

    vm.updateMainGalleryPosition = (useTransition = true,) => {
        const track = document.getElementById('gallery-principal-track');
        if (track) {
            const currentIndex = vm.hotel.currentImageIndex || 0;
            const translateX = -currentIndex * 100;

            if (useTransition) {
                track.style.transition = 'transform 0.3s ease-in-out';
            } else {
                track.style.transition = 'none';
            }

            track.style.transform = `translateX(${translateX}%)`;
        }
        vm.updateDotsPosition();
    }

    vm.selectMainGalleryImage = (index) => {
        if (!vm.gallery || vm.gallery.length <= 1) return;
        if (vm.isMainGalleryTransitioning) return;

        vm.isMainGalleryTransitioning = true;

        vm.hotel.currentImageIndex = index;
        vm.updateMainGalleryPosition(index);

        setTimeout(() => {
            vm.isMainGalleryTransitioning = false;
        }, 300);

        // Trigger digest if needed
        if (!$scope.$$phase) {
            $scope.$applyAsync();
        }
    }

    vm.slideMainGallery = (event, direction) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (!vm.gallery || vm.gallery.length <= 1) return;
        if (vm.isMainGalleryTransitioning) return;

        vm.isMainGalleryTransitioning = true;

        const currentIndex = vm.hotel.currentImageIndex || 0;
        const maxIndex = vm.gallery.length - 1;
        let newIndex;

        if (direction === 'right') {
            newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        } else {
            newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        }

        vm.hotel.currentImageIndex = newIndex;
        vm.updateMainGalleryPosition();

        setTimeout(() => {
            vm.isMainGalleryTransitioning = false;
        }, 300);

        // Trigger digest if needed
        if (!$scope.$$phase) {
            $scope.$applyAsync();
        }
    }

    vm.initMainGalleryCarousel = () => {
        $timeout(() => {
            vm.updateDotsPosition();
            if (window.CarouselManager && vm.gallery && vm.gallery.length > 1) {
                window.CarouselManager.initCarousel({
                    carouselId: 'gallery-principal-carousel',
                    modalId: 'main-gallery-view',
                    nextFunction: (event) => vm.slideMainGallery(event, 'right'),
                    prevFunction: (event) => vm.slideMainGallery(event, 'left'),
                    scope: $scope,
                    minSwipeDistance: 50
                });
            }
        }, 0);
    }

    // Reviews Gallery Carousel
    vm.reviewsCarouselIndex = 0;
    vm.reviewsTranslateX = 0;
    vm.isReviewsGalleryTransitioning = false;

    vm.updateReviewsCarouselPosition = (useTransition = true) => {
        const track = document.getElementById('reviews-gallery-track');
        if (track) {
            const item = track.children[0];
            if (!item) return;

            const itemWidth = item.offsetWidth;
            const style = window.getComputedStyle(track);
            const gap = parseFloat(style.gap) || 16;

            const moveAmount = itemWidth + gap;
            const translateX = -(vm.reviewsCarouselIndex * moveAmount);

            if (useTransition) {
                track.style.transition = 'transform 0.3s ease-in-out';
            } else {
                track.style.transition = 'none';
            }

            track.style.transform = `translateX(${translateX}px)`;
            vm.reviewsTranslateX = translateX;
        }
    }

    vm.slideReviewsGallery = (event, direction) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const gallery = vm.listReviews?.verified?.gallery;
        if (!gallery || gallery.length === 0) return;

        if (vm.isReviewsGalleryTransitioning) return;

        const track = document.getElementById('reviews-gallery-track');
        const carousel = document.getElementById('reviews-gallery-carousel');

        let visibleItems = 4; // Default fallback

        if (track && carousel) {
            const item = track.children[0];
            if (item) {
                const itemWidth = item.offsetWidth;
                const style = window.getComputedStyle(track);
                const gap = parseFloat(style.gap) || 16;
                const totalItemWidth = itemWidth + gap;
                const containerWidth = carousel.offsetWidth;
                // Calculate how many items fit fully
                visibleItems = Math.floor(containerWidth / totalItemWidth);
                // Ensure at least 1 item is considered visible to avoid division by zero issues logic
                visibleItems = Math.max(1, visibleItems);
            }
        }

        // If all items fit, maxIndex will be 0 or less
        const maxIndex = Math.max(0, gallery.length - visibleItems);

        if (maxIndex === 0) return;

        vm.isReviewsGalleryTransitioning = true;

        const currentIndex = vm.reviewsCarouselIndex || 0;

        let newIndex;

        if (direction === 'right') {
            newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        } else {
            newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        }

        vm.reviewsCarouselIndex = newIndex;
        vm.updateReviewsCarouselPosition();

        setTimeout(() => {
            vm.isReviewsGalleryTransitioning = false;
        }, 300);

        if (!$scope.$$phase) {
            $scope.$applyAsync();
        }
    }

    vm.initReviewsCarousel = () => {
        $timeout(() => {
            if (window.CarouselManager) {
                window.CarouselManager.initCarousel({
                    carouselId: 'reviews-gallery-carousel',
                    modalId: 'modal_reviews',
                    nextFunction: (event) => vm.slideReviewsGallery(event, 'right'),
                    prevFunction: (event) => vm.slideReviewsGallery(event, 'left'),
                    scope: $scope,
                    minSwipeDistance: 50
                });
            }
        }, 500);
    }

    vm.updateRoomCarouselPosition = (room) => {
        const track = document.getElementById(`room-carousel-track-${room.roomId}`);
        const slides = track?.querySelectorAll('.room-carousel-slide');

        if (track && slides && slides.length > 0) {
            const currentIndex = room.currentImageIndex || 0;
            const translateX = -currentIndex * 100;

            track.style.transform = `translateX(${translateX}%)`;
            track.style.transition = 'transform 0.3s ease-in-out';

            slides.forEach((slide, index) => {
                slide.classList.toggle('active', index === currentIndex);
            });
        }
    }


    vm.slideCarrousel = async (event, room, direction) => {
        vm.slideRoomCarousel(event, room, direction);
    }

    vm.getCurrentRoomImage = () => {
        if (!vm.currentRoom || !vm.currentRoom.pictures || vm.currentRoom.pictures.length === 0) {
            return vm.currentRoom?.picture?.cloudUri || '@principal?.CloudUri';
        }

        const index = vm.currentRoom.currentImageIndex || 0;
        return vm.currentRoom.pictures[index]?.cloudUri || vm.currentRoom.picture?.cloudUri || '@principal?.CloudUri';
    }

    vm.selectRoomImage = (index) => {
        if (!vm.currentRoom || !vm.currentRoom.pictures) return;

        vm.currentRoom.currentImageIndex = index;
        vm.currentRoom.galleryPosition = index + 1;

        // Navegación directa sin transición para mejor performance
        vm.updateCarouselPosition(false);

        // Restaurar transiciones después de un breve delay para futuras navegaciones
        $timeout(() => {
            const track = document.getElementById('room-carousel-track');
            if (track) {
                track.style.transition = 'transform 0.3s ease-in-out';
            }
        }, 50);

        vm.syncRoomMainImage();

        if (window.CarouselManager) {
            window.CarouselManager.triggerThumbnailAutoScroll('modal-room-amenities');
        }
    }

    vm.syncRoomMainImage = () => {
        if (!vm.currentRoom) return;

        const originalRoom = vm.hotel.rooms?.find(room => room.roomId === vm.currentRoom.roomId);
        if (originalRoom && originalRoom.pictures && originalRoom.pictures.length > 0) {
            originalRoom.currentImageIndex = vm.currentRoom.currentImageIndex;
            originalRoom.galleryPosition = vm.currentRoom.galleryPosition;

            const newImageUri = originalRoom.pictures[vm.currentRoom.currentImageIndex]["cloudUri"];

            if (originalRoom.picture.cloudUri !== newImageUri) {
                originalRoom.picture.cloudUri = newImageUri;

                vm.updateRoomCarouselPosition(originalRoom);

                $timeout(() => {
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, 0);
            }
        }
    }

    vm.currentReview = null;

    vm.findAndOpenReviewGallery = (galleryItem) => {
        vm.selectedGalleryItem = galleryItem;
        const recentReviews = vm.listReviews?.verified?.recent;
        if (recentReviews && galleryItem) {
            for (let i = 0; i < recentReviews.length; i++) {
                const review = recentReviews[i];
                if (review.evidences) {
                    const evidenceIndex = review.evidences.findIndex(e =>
                        e.url === galleryItem.url ||
                        normalizeUrl(e.url) === normalizeUrl(galleryItem.url)
                    );

                    if (evidenceIndex !== -1) {
                        vm.openReviewGallery(review, evidenceIndex);
                        return;
                    }
                }
            }
        }
        let paramsReviewsRequest = {
            PropertyId: vm.hotel.hotelId,
            Language: config.cultureReviews,
            IsReviews: true,
            Site: config.siteName,
            PageSize: vm.reviewsPagination.pageSize,
            Id: galleryItem.id,
        }
        $http.get(config.endPoints.reviewTokenUrl, { params: paramsReviewsRequest, headers: getHeaders() }).then(onSuccessReviewToken, (err) => {
            onErrorReviewToken(err);
        });
    }
    function onSuccessReviewToken(response) {
        if (response && response.data) {
            const evidences = response.data.evidences || response.data || [];
            const selectedUrl = normalizeUrl(vm.selectedGalleryItem.url);
            let index = evidences.findIndex(e =>
                normalizeUrl(e.url) === selectedUrl
            );
            if (index < 0) index = 0;
            vm.openReviewGallery(response.data, index);
        }
    }
    function normalizeUrl(url) {
        return url?.replace('static.cdnpth.com', 'img.cdnpth.com');
    }
    function onErrorReviewToken(err) {
        console.error("Error al obtener el token de reseña:", err);
    }

    vm.openReviewGallery = (review, imageIndex = 0) => {
        vm.currentReview = { ...review };

        let globalIndex = 0;

        if (review && review.evidences && review.evidences.length > 0) {
            const localIndex = Math.min(Math.max(imageIndex, 0), review.evidences.length - 1);
            const targetUrl = normalizeUrl(review.evidences[localIndex].url);

            if (vm.listReviews?.verified?.gallery) {
                vm.selectedGalleryItem = vm.listReviews.verified.gallery.find(g =>
                    g.id === review.id && normalizeUrl(g.url) === targetUrl
                ) || vm.listReviews.verified.gallery.find(g => normalizeUrl(g.url) === targetUrl) || null;
            }
        }

        if (vm.listReviews?.verified?.gallery && vm.selectedGalleryItem) {
            const currentUrl = normalizeUrl(vm.selectedGalleryItem.url);
            const foundIndex = vm.listReviews.verified.gallery.findIndex(g =>
                g.id === vm.selectedGalleryItem.id && normalizeUrl(g.url) === currentUrl
            );
            if (foundIndex !== -1) {
                globalIndex = foundIndex;
            } else {
                const fallbackMatch = vm.listReviews.verified.gallery.findIndex(g => normalizeUrl(g.url) === currentUrl);
                if (fallbackMatch !== -1) globalIndex = fallbackMatch;
            }
        } else if (review && review.evidences && review.evidences.length > 0) {
            globalIndex = Math.min(Math.max(imageIndex, 0), review.evidences.length - 1);
        }

        vm.currentReview.currentImageIndex = globalIndex;

        const reviewsModal = document.getElementById('modal_reviews');
        if (reviewsModal && reviewsModal.classList.contains('show')) {
            const modalContent = reviewsModal.querySelector('.modal-content');
            if (modalContent) {
                vm.reviewsModalScrollTop = modalContent.scrollTop;
            }
        }

        $(`#modal_review_gallery`).modal({
            backdrop: true,
            keyboard: true
        });

        $(`#modal_review_gallery`).modal("show");

        setTimeout(() => {
            const modal = document.getElementById('modal_review_gallery');
            if (modal) {
                modal.style.zIndex = '1095';
                modal.focus();

                const activationEvent = new Event('modalActivated', { bubbles: true });
                modal.dispatchEvent(activationEvent);

                vm.initVideoThumbnails();
            }
        }, 10);

        $timeout(() => {
            if (window.CarouselManager) {
                window.CarouselManager.initCarousel({
                    carouselId: 'review-gallery-carousel',
                    modalId: 'modal_review_gallery',
                    nextFunction: vm.nextReviewImage,
                    prevFunction: vm.prevReviewImage,
                    scope: $scope,
                    minSwipeDistance: 50
                });
            }
        }, 50);


        $(`#modal_review_gallery`).one('shown.bs.modal', function () {
            const modal = document.getElementById('modal_review_gallery');
            if (modal) {
                modal.focus();

                const galleryBackdrop = document.querySelector('.modal-backdrop:last-child');
                if (galleryBackdrop) {
                    galleryBackdrop.style.zIndex = '1089';
                    galleryBackdrop.classList.add('gallery-modal-backdrop');
                }

                if (vm.listReviews?.verified?.gallery) {
                    const currentIndex = vm.currentReview.currentImageIndex || 0;
                    const maxIndex = vm.listReviews.verified.gallery.length - 1;

                    if (currentIndex > maxIndex) {
                        vm.currentReview.currentImageIndex = Math.max(0, maxIndex);
                    }
                }

                setTimeout(() => {
                    vm.updateReviewCarouselPosition(false);
                }, 10);

                setTimeout(() => {
                    const track = document.getElementById('review-carousel-track');
                    if (track) {
                        track.style.transition = 'transform 0.3s ease-in-out';
                    }
                    vm.updateReviewCarouselPosition(true);
                }, 300);
            }
        });

        $(`#modal_review_gallery`).one('hidden.bs.modal', function () {
            vm.selectedGalleryItem = null;

            const galleryBackdrop = document.querySelector('.gallery-modal-backdrop');
            if (galleryBackdrop) {
                galleryBackdrop.classList.remove('gallery-modal-backdrop');
            }

            setTimeout(() => {
                const reviewsModal = document.getElementById('modal_reviews');
                if (reviewsModal && reviewsModal.classList.contains('show')) {
                    const modalContent = reviewsModal.querySelector('.modal-content');

                    if (modalContent) {
                        if (vm.reviewsModalScrollTop !== undefined) {
                            modalContent.scrollTop = vm.reviewsModalScrollTop;
                        }
                    }

                    if (!document.body.classList.contains('modal-open')) {
                        document.body.classList.add('modal-open');
                    }
                }
            }, 100);
        });

        $(`#modal_review_gallery`).on('click.gallery-focus', function (e) {
            if (e.target === this || $(e.target).hasClass('modal-backdrop')) {
                setTimeout(() => {
                    const modal = document.getElementById('modal_review_gallery');
                    if (modal) {
                        modal.focus();
                    }
                }, 10);
            }
        });

        $(`#modal_review_gallery`).on('modalActivated', function () {
            const modal = this;
            modal.focus();

            const interactiveElements = modal.querySelectorAll('button, img[tabindex="0"], [tabindex="0"]');
            interactiveElements.forEach(element => {
                element.style.pointerEvents = 'auto';
            });
        });

        $(`#modal_review_gallery`).one('hide.bs.modal', function () {
            $(`#modal_review_gallery`).off('click.gallery-focus');
            $(`#modal_review_gallery`).off('modalActivated');
        });
    }

    vm.prevReviewImage = () => {
        if (!vm.currentReview || !vm.listReviews.verified.gallery || vm.listReviews.verified.gallery.length === 0) return;

        const currentIndex = vm.currentReview.currentImageIndex || 0;
        const maxIndex = vm.listReviews.verified.gallery.length - 1;
        const newIndex = currentIndex > 0 ? currentIndex - 1 : maxIndex;

        vm.changeGlobalGalleryImage(newIndex);
    }

    vm.nextReviewImage = () => {
        if (!vm.currentReview || !vm.listReviews.verified.gallery || vm.listReviews.verified.gallery.length === 0) return;

        const currentIndex = vm.currentReview.currentImageIndex || 0;
        const maxIndex = vm.listReviews.verified.gallery.length - 1;
        const newIndex = currentIndex < maxIndex ? currentIndex + 1 : 0;

        vm.changeGlobalGalleryImage(newIndex);
    }

    vm.selectReviewImage = (index) => {
        if (!vm.listReviews?.verified?.gallery || index < 0 || index >= vm.listReviews.verified.gallery.length) {
            return;
        }
        vm.changeGlobalGalleryImage(index);
    }

    vm.selectReviewEvidence = (evidenceLocalIndex) => {
        if (!vm.currentReview || !vm.currentReview.evidences || !vm.listReviews?.verified?.gallery) return;

        const evidence = vm.currentReview.evidences[evidenceLocalIndex];
        if (!evidence) return;

        const evidenceUrl = evidence.url.replace('static.cdnpth.com', 'img.cdnpth.com');
        const globalIndex = vm.listReviews.verified.gallery.findIndex(g =>
            g.id === vm.currentReview.id && g.url.replace('static.cdnpth.com', 'img.cdnpth.com') === evidenceUrl
        );

        if (globalIndex !== -1) {
            vm.changeGlobalGalleryImage(globalIndex);
        }
    }

    vm.changeGlobalGalleryImage = (newIndex) => {
        const nextGalleryItem = vm.listReviews.verified.gallery[newIndex];
        if (!nextGalleryItem) return;

        if (!vm.currentReview || vm.currentReview.id !== nextGalleryItem.id) {
            const currentGlobalIndexTarget = newIndex;

            vm.selectedGalleryItem = nextGalleryItem;
            let paramsReviewsRequest = {
                PropertyId: vm.hotel.hotelId,
                Language: config.cultureReviews,
                IsReviews: true,
                Site: config.siteName,
                PageSize: vm.reviewsPagination.pageSize,
                Id: nextGalleryItem.id,
            }
            $http.get(config.endPoints.reviewTokenUrl, { params: paramsReviewsRequest, headers: getHeaders() }).then((response) => {
                if (response && response.data) {
                    vm.currentReview = { ...response.data };
                    vm.currentReview.currentImageIndex = currentGlobalIndexTarget;
                    vm.updateReviewCarouselPosition();
                }
            });
        } else {
            vm.currentReview.currentImageIndex = newIndex;
            vm.updateReviewCarouselPosition();
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }
    }

    vm.getCurrentReviewImage = () => {
        if (!vm.currentReview || !vm.currentReview.evidences) return '';

        const images = vm.currentReview.evidences.filter(evidence => evidence.type === 'image');
        if (images.length === 0) return '';

        const index = vm.currentReview.currentImageIndex || 0;
        const imageUrl = images[index]?.url || '';

        return imageUrl.replace('static.cdnpth.com', 'img.cdnpth.com');
    }

    vm.getEvidenceIndex = (review, targetEvidence) => {
        if (!review || !review.evidences || !targetEvidence) {
            return 0;
        }

        const index = review.evidences.findIndex(evidence =>
            evidence.url === targetEvidence.url && evidence.type === targetEvidence.type
        );

        return index >= 0 ? index : 0;
    }

    vm.getCurrentReviewMedia = () => {
        if (!vm.currentReview || !vm.currentReview.evidences) return null;

        const index = vm.currentReview.currentImageIndex || 0;
        const evidence = vm.currentReview.evidences[index];

        if (!evidence) return null;

        return {
            type: evidence.type,
            url: evidence.url.replace('static.cdnpth.com', 'img.cdnpth.com')
        };
    }

    vm.updateReviewCarouselPosition = (animate = true) => {
        if (!vm.currentReview || !vm.listReviews?.verified?.gallery) return;

        const track = document.getElementById('review-carousel-track');
        const slides = track?.querySelectorAll('.carousel-slide');

        if (!track || !slides || slides.length === 0) return;

        const currentIndex = vm.currentReview.currentImageIndex || 0;
        const maxIndex = slides.length - 1;

        if (currentIndex < 0 || currentIndex > maxIndex) return;

        const translateX = -currentIndex * 100;

        if (!animate) {
            track.style.transition = 'none';
        }

        track.style.transform = `translateX(${translateX}%)`;

        if (animate) {
            track.style.transition = 'transform 0.3s ease-in-out';
        }

        slides.forEach((slide, index) => {
            const isActive = index === currentIndex;
            slide.classList.toggle('active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

            const video = slide.querySelector('video');
            if (video && !isActive) {
                video.pause();
                video.currentTime = 0;
            }
        });
    }

    vm.handleVideoLoad = (video) => {
        try {
            if (!video.poster || video.poster.includes('_poster.jpg')) {
                const originalCurrentTime = video.currentTime;
                video.currentTime = 1;

                video.addEventListener('seeked', function onSeeked() {
                    video.removeEventListener('seeked', onSeeked);
                    if (originalCurrentTime === 0) {
                        video.currentTime = 0;
                    }
                }, { once: true });
            }
        } catch (error) {
            console.log('Error setting video poster frame:', error);
        }
    };

    vm.handleThumbnailVideoLoad = (video) => {
        try {
            video.currentTime = Math.min(1, video.duration * 0.1 || 1);

            video.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });

            video.addEventListener('play', function (e) {
                e.preventDefault();
                video.pause();
            });
        } catch (error) {
            console.log('Error setting thumbnail video frame:', error);
        }
    };

    vm.initVideoThumbnails = () => {
        $timeout(() => {
            const videoThumbnails = document.querySelectorAll('.thumbnail-video');
            videoThumbnails.forEach(video => {
                video.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });

                video.addEventListener('play', function (e) {
                    e.preventDefault();
                    video.pause();
                    video.currentTime = Math.min(1, video.duration * 0.1 || 1);
                });

                video.addEventListener('loadedmetadata', function () {
                    if (video.duration && video.duration > 1) {
                        video.currentTime = Math.min(1, video.duration * 0.1);
                    }
                });
            });
        }, 100);
    }

    vm.getAvatarColorClass = (reviewerName) => {
        if (!reviewerName || typeof reviewerName !== 'string' || reviewerName.trim() === '') {
            return 'card__avatar--anonymous';
        }

        if (!vm.reviewerColorMap) {
            vm.reviewerColorMap = {};
        }

        if (vm.reviewerColorMap[reviewerName]) {
            return `card__avatar--${vm.reviewerColorMap[reviewerName]}`;
        }

        const colors = ['blue', 'violet', 'pink', 'green'];
        const colorIndex = Math.floor(Math.random() * colors.length);

        vm.reviewerColorMap[reviewerName] = colors[colorIndex];

        return `card__avatar--${colors[colorIndex]}`;
    }

    vm.shouldShowReviewIcons = (review) => {
        const isPriceTravel = review.verification_source &&
            review.verification_source.toLowerCase().indexOf('pricetravel') !== -1;

        const hasBothTexts = review.text && review.text.trim() !== '' &&
            review.negative_text && review.negative_text.trim() !== '';

        return isPriceTravel && hasBothTexts;
    };

    vm.showInclusiveModal = (modal) => {
        vm.showModal(modal);
    }

    vm.onClosed = (modal) => {
        $(`#${modal}`).modal("hide");
    }

    vm.lazyLoadImage = ({ isVisible, element }, url) => {
        const image = vm.filteredImages.find(img => img.uri === url);
        if (isVisible && image && !image.loaded) {

            element.style.backgroundImage = isVisible ? `url(${url})` : element.style.backgroundImage;
            image.loaded = true;
        }
    }

    vm.mapDetail = new GoogleMapDetail($scope, $http, $timeout, config, fn, hotel, box);

    vm.closeMapCard = function () {
        vm.mapDetail.closeMapCard();
    };

    vm.slideCarousel = function (evt, hotel, direction) {
        evt.preventDefault();
        evt.stopPropagation();
        const carousel = evt.currentTarget.closest('.carousel');
        if (!carousel || !carousel.__carouselApi) return;
        if (direction === 'next') carousel.__carouselApi.next();
        else carousel.__carouselApi.prev();
    };

    vm.loadHotelSlide = async function (hotel, slideIndex) {
        if (!hotel.isLoadGallery) {
            const qr = {
                HotelId: hotel.hotelId || hotel.id,
                culture: cultureData.internalCultureCode,
                organizationId: config.organization,
                propertyId: config.property,
                imageProfileId: 'desktop',
                productType: hotel.productType
            };

            const response = await $http.get(config.endPoints.galleryDetailUrl, { params: qr, headers: getHeaders() });

            const firstPhoto = hotel.gallery?.[0] || { cloudUri: hotel.cloudUri };
            hotel.gallery = fn.clone([firstPhoto, ...(response.data.gallery || [])]);
            hotel.isLoadGallery = true;
        }
    };

    vm.renderCurrencyDisplay = function (amount) {
        const currencyComponent = `<currency-display amount="${amount}" show-currency-code="true"></currency-display>`;
        const compiledComponent = $compile(currencyComponent)($scope);
        $scope.$digest();
        return compiledComponent[0].outerHTML;
    };

    vm.goToHotel = function (url) {
        if (url) {
            window.location.href = url;
        } else {
            vm.goSection('rooms', 100, 1000);
        }
    };
    vm.renderMap = () => {
        vm.showCardMap = true;
        vm.isMapExpanded = false;
        vm.isMobileTablet = fn.mobileAndTabletCheck();

        vm.zoomIn = () => vm.mapDetail.zoomIn();
        vm.zoomOut = () => vm.mapDetail.zoomOut();

        vm.toggleExpand = () => {
            vm.isMapExpanded = !vm.isMapExpanded;
            const modal = document.getElementById('modal-fullscreen-xl');
            if (vm.isMapExpanded) {
                modal.classList.add('map-expanded');
            } else {
                modal.classList.remove('map-expanded');
            }
            setTimeout(() => {
                if (vm.mapDetail.mapInstance) google.maps.event.trigger(vm.mapDetail.mapInstance, 'resize');
            }, 300);
        };

        vm.geolocate = () => vm.mapDetail.geolocate();

        const handleMap = async () => {
            const mapElement = document.getElementById('map');
            if (!mapElement) return;

            const loadGoogleMapsAPI = () => {
                return new Promise((resolve, reject) => {
                    if (typeof google !== 'undefined' && google.maps) {
                        resolve();
                    } else {
                        if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
                            resolve();
                        } else {
                            fn.getScript(config.endPoints.googleMapsApi, "", () => {
                                if (typeof google !== 'undefined' && google.maps) {
                                    resolve();
                                } else {
                                    reject(new Error('Failed to load Google Maps API'));
                                }
                            });
                        }
                    }
                });
            };

            loadGoogleMapsAPI().then(() => vm.mapDetail.init(mapElement)).catch(() => { });
        };

        handleMap();
    };


    vm.sendContentFooter = (title) => {
        trackerFooter.clickLink(`footer :: ${title}`);

    }

    vm.showMoreRooms = () => {
        _showMoreRooms = !_showMoreRooms;

        if (!_showMoreRooms) {
            vm.limitRoomsFilter = vm.roomsAvailables;
        } else {
            tracker.selectedFilter("Ver todas las habitaciones");
            vm.limitRoomsFilter = vm.roomsLimit;
        }

    }

    vm.sharedBy = (destino) => {
        let paramsSharedRequest = {
        }
        paramsSharedRequest.Key = "";
        paramsSharedRequest.Url = window.location.pathname + window.location.search + "&utm_source=" + (destino ? destino : "copy_link") + "&utm_medium=social&utm_campaign=share_hotel";
        $http.get(config.uriShared, { params: paramsSharedRequest }).then(function (response) { onSuccessSharedRequest(response, destino) }, onErrorShared);
    }

    vm.onSelectDate = (date) => {
        const { checkin, checkout } = date;
        
        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('checkin', checkin);
        currentUrl.searchParams.set('checkout', checkout);
        
        window.location.href = currentUrl.toString();
    }
    vm.handleClick = function () {
        const dataMetric = { ...box, ...hotel, ..._paxes };
        if (typeof trackerMetric !== 'undefined' && typeof trackerMetric.metricDatesRecommended === 'function') {
            trackerMetric.metricDatesRecommended('click_suggested_dates', { data: dataMetric });
        }
        var roomsSection = document.getElementById('rooms');
        var roomsSectionPosition = roomsSection.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({ top: roomsSectionPosition - 250, behavior: 'smooth' });
    };
    vm.isSubmitOrRAPD = (room, rate, roomIndex, meta = false) => {
        if (rate.bookNowPayLaterTimeLimit
            && rate.isBookNowPayLaterApplicable
            && !vm.isBlockRAPD
            && rate.collectType != 2 && !room.unique) {
            vm.showModalRAPD('modal-rapd-mini', rate, room, roomIndex, meta);
        } else {
            vm.onSubmit(room, rate, roomIndex, false, false, true)
        }
    }
    vm.onSubmit = (room, rate, roomIndex, paynow = false, isRecommendation = false, typeMain = false, isUnique = false) => {
        var paxesToSend = [];
        if (typeMain) {
            if (vm.onlyAdults) {
                newPax.paxesFormat.forEach((pax) => {
                    paxesToSend.push(pax.split('|')[0]);
                });
            } else {
                paxesToSend = newPax.paxesFormat;
            }
        } else if (isUnique) {
            vm.recomendationsListUnique.checkoutHash.forEach((roomrate) => {
                paxesToSend.push(roomrate.paxFam);
            });
        } else if (isRecommendation || vm.isRecomendationCheckout) {
            vm.onSubmitLoadingRecomendation = true;
            vm.recomendationsList.checkoutHash.forEach((roomrate) => {
                paxesToSend.push(roomrate.paxFam);
            });
        } else {
            vm.onSubmitLoading = true;
            vm.stickyRates.forEach((roomrate) => {
                let paxFamParts = roomrate.paxFam.split('|');
                let multiplier = roomrate.selectedRoomValue;
                var totlaAdults = parseInt(paxFamParts) * multiplier;
                var totalChildres = "";
                if (paxFamParts[1] && paxFamParts[1].length > 0) {
                    totalChildres = Array.from({ length: multiplier }, () => paxFamParts[1]).flat().join(',');
                }
                let result = totalChildres && totalChildres != "" ? totlaAdults.toString() + '|' + totalChildres : totlaAdults.toString();
                paxesToSend.push(result);
            });
        }
        const paxesData = fn.mapPaxToUrlNew(paxesToSend, true, true);
        const valuesDefaults = getValuesDefaults();
        let items = [];
        if (typeMain) {
            items.push({
                idRate: rate.rateId,
                rateKey: rate.rateKey,
                idRoom: rate.roomId,
                promotionValue: rate.promotionValue,
                totalRoomRatePerNight: rate.taxes.totalRoomRatePerNight,
                name: room.name,
                mealPlanCode: rate.mealPlanCode,
                totalAmount: rate.totalAmount,
                checkoutHash: rate.checkoutHash,
                isBookNowPayLater: paynow,
                rooms: vm.isRequote ? newPaxRequote.paxes.rooms : newPax.paxes.rooms,
                pax: rate.paxFam,
                index: roomIndex,
                provider: rate.provider
            });
        } else if (isRecommendation || vm.isRecomendationCheckout) {
            vm.recomendationsList.checkoutHash.forEach((roomrate, index) => {
                items.push(
                    {
                        idRate: roomrate.rateId,
                        rateKey: roomrate.rateKey,
                        idRoom: roomrate.roomId,
                        promotionValue: roomrate.promotionValue,
                        totalRoomRatePerNight: roomrate.taxes.totalRoomRatePerNight,
                        name: roomrate.name,
                        mealPlanCode: roomrate.mealPlanCode,
                        totalAmount: roomrate.totalAmount,
                        checkoutHash: roomrate.checkoutHash,
                        isBookNowPayLater: paynow,
                        rooms: 1,
                        pax: roomrate.paxFam,
                        index: index + 1,
                        provider: roomrate.provider
                    }
                );
            });
        } else if (isUnique) {
            vm.recomendationsListUnique.checkoutHash.forEach((roomrate, index) => {
                items.push(
                    {
                        idRate: roomrate.rateId,
                        rateKey: roomrate.rateKey,
                        idRoom: roomrate.roomId,
                        promotionValue: roomrate.promotionValue,
                        totalRoomRatePerNight: roomrate.taxes.totalRoomRatePerNight,
                        name: roomrate.name,
                        mealPlanCode: roomrate.mealPlanCode,
                        totalAmount: roomrate.totalAmount,
                        checkoutHash: roomrate.checkoutHash,
                        isBookNowPayLater: paynow,
                        rooms: 1,
                        pax: roomrate.paxFam,
                        index: index + 1,
                        provider: roomrate.provider
                    }
                );
            });
        } else {
            vm.stickyRates.forEach((roomrate, index) => {
                items.push(
                    {
                        idRate: roomrate.rateId,
                        rateKey: roomrate.rateKey,
                        idRoom: roomrate.roomId,
                        promotionValue: roomrate.promotionValue,
                        totalRoomRatePerNight: roomrate.taxes.totalRoomRatePerNight,
                        name: roomrate.name,
                        mealPlanCode: roomrate.mealPlanCode,
                        totalAmount: roomrate.totalAmount,
                        checkoutHash: roomrate.checkoutHash,
                        isBookNowPayLater: paynow,
                        rooms: roomrate.selectedRoomValue,
                        pax: roomrate.paxFam,
                        index: index + 1,
                        provider: roomrate.provider
                    }
                );
            });
        }
        let data = {
            idHotel: hotel.hotelId,
            hotelCheckIn: box.checkIn,
            CheckIn: box.checkIn,
            CheckOut: box.checkOut,
            Source: config.source,
            ChkSource: isMobile ? config.chkSourceMobile : config.chkSourceDesktop,
            ChkSourceGroup: isMobile ? config.chkSourceGroupMobile : config.chkSourceGroupDesktop,
            isBookNowPayLater: paynow,
            index: 1,
            pageUrl: window.location.pathname + window.location.search,
            isMetaSearchEngine: vm.source_origin !== "",
            Amount: typeMain ? rate.totalAmount : isRecommendation || vm.isRecomendationCheckout ? vm.recomendationsList.totalRoomRatePerNight : vm.totalSticky,
            useNewConfig: true,
            applicable: typeMain,
            promotions: paramsRoomRates.promotions
        };
        //CONVERSION METAS
        const parser = new CampaignParser(window.location.search);
        const campaign = parser.parse();
        data = { ...data, ...paxesData, ...valuesDefaults, site: settings.site.siteName };
        var form = document.createElement("form");
        form.setAttribute("method", "POST");
        form.setAttribute("action", `/${cultureData.cultureCode}${config.checkoutUrl}`);
        StorageService.setSession(data);
        for (var key in data) {
            if (data[key] != null) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", data[key]);
                form.appendChild(hiddenField);
            }
        }
        items.map((room, index) => {
            for (var key in room) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", `roomList[${index}][${key}]`);
                hiddenField.setAttribute("value", room[key]);
                form.appendChild(hiddenField);
            }
        });
        if (campaign) {
            Object.keys(campaign).forEach(k => {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", `Conversion.${k}`);
                hiddenField.setAttribute("value", campaign[k]);
                form.appendChild(hiddenField);
            });
        }

        const eventData = {
            ...data
        }

        tracker.setUserInteraction(paynow);
        tracker.setAddToCart(eventData, items);
        tracker.beginCheckOutTB(eventData, items);

        $("#loader-page").removeClass("d-none");
        document.body.appendChild(form);
        form.submit();
    }



    vm.reviewsPagination = {
        currentPage: 1,
        pageSize: 12,
        loading: false,
        hasMore: true,
        allReviews: [],
        lastOrder: 'recent'
    };

    vm.resetReviewsState = () => {
        vm.reviewsPagination.allReviews = [];
        vm.reviewsPagination.currentPage = 1;
        vm.reviewsPagination.hasMore = true;
        vm.originalReviewsList = null;

        if (vm.listReviews && vm.listReviews.verified) {
            vm.listReviews.verified.recent = [];
        }

        if (vm.topRecentShortOriginal.length > 0) {
            vm.topRecentShort = angular.copy(vm.topRecentShortOriginal);
        }
    };

    vm.getSortingParams = () => {
        switch (vm.reviewFilters.order) {
            case 'high':
                return {
                    'Sorting.SortBy': 'Rating',
                    'Sorting.Direction': 'Descending'
                };
            case 'low':
                return {
                    'Sorting.SortBy': 'Rating',
                    'Sorting.Direction': 'Ascending'
                };
            case 'recent':
            default:
                return {};
        }
    };

    vm.getReviews = (propertyId, isReviews, page = 1) => {
        if (page === 1) {
            vm.reviewsLoadingModal = true;
            vm.reviewsPagination.allReviews = [];
            vm.reviewsPagination.currentPage = 1;
            vm.reviewsPagination.hasMore = true;
            vm.reviewsPagination.lastOrder = vm.reviewFilters.order;
        } else {
            vm.reviewsPagination.loading = true;
        }

        let paramsReviewsRequest = {
        }
        paramsReviewsRequest.PropertyId = propertyId;
        paramsReviewsRequest.Language = config.cultureReviews;
        paramsReviewsRequest.IsReviews = isReviews;
        paramsReviewsRequest.Site = config.siteName;
        paramsReviewsRequest.PageSize = vm.reviewsPagination.pageSize;
        paramsReviewsRequest.PageNumber = page;

        const sortingParams = vm.getSortingParams();
        Object.assign(paramsReviewsRequest, sortingParams);

        $http.get(config.expediaReviewsURL, { params: paramsReviewsRequest }).then(function (response) {
            onSuccessReviewsRequest(response, page)
        }, onErrorShared);
    }


    vm.loadMoreReviews = () => {
        if (!vm.reviewsPagination.loading && vm.reviewsPagination.hasMore) {
            vm.reviewsPagination.currentPage++;
            vm.getReviews(vm.hotel.hotelId, true, vm.reviewsPagination.currentPage);
        }
    }

    vm.applyFilters = ($event) => {
        if ($event) {
            $event.preventDefault();
        }

        if (!vm.listReviews || !vm.listReviews.verified || !vm.listReviews.verified.recent) {
            return;
        }

        if (vm.reviewFilters.order !== vm.reviewsPagination.lastOrder) {
            vm.reviewsPagination.lastOrder = vm.reviewFilters.order;

            vm.resetReviewsState();

            vm.getReviews(vm.hotel.hotelId, true, 1);
            vm.closeModal('modal_reviews_filters');
            return;
        }

        if (!vm.originalReviewsList) {
            vm.originalReviewsList = angular.copy(vm.reviewsPagination.allReviews.length > 0 ? vm.reviewsPagination.allReviews : vm.listReviews.verified.recent);
        }

        let filteredReviews = angular.copy(vm.originalReviewsList);

        if (vm.reviewFilters.season !== 'all') {
            filteredReviews = filteredReviews.filter(review => {
                if (!review.stay_date) return false;

                let month;

                if (review.stay_date.includes('-')) {
                    const dateParts = review.stay_date.split('-');
                    month = parseInt(dateParts[1], 10);
                } else if (review.stay_date.length === 6) {
                    month = parseInt(review.stay_date.substring(4, 6), 10);
                } else {
                    const stayDate = new Date(review.stay_date);
                    if (!isNaN(stayDate.getTime())) {
                        month = stayDate.getMonth() + 1;
                    } else {
                        return false;
                    }
                }

                if (month < 1 || month > 12) return false;

                switch (vm.reviewFilters.season) {
                    case 'spring':
                        return month >= 3 && month <= 5;
                    case 'summer':
                        return month >= 6 && month <= 8;
                    case 'autumn':
                        return month >= 9 && month <= 11;
                    case 'winter':
                        return month === 12 || month <= 2;
                    default:
                        return true;
                }
            });
        }

        switch (vm.reviewFilters.order) {
            case 'recent':
                filteredReviews.sort((a, b) => {
                    const dateA = new Date(a.date_submitted || a.stay_date + '-01');
                    const dateB = new Date(b.date_submitted || b.stay_date + '-01');
                    return dateB - dateA;
                });
                break;
            case 'high':
                filteredReviews.sort((a, b) => (b.rating || 0) - (a.rating || 0));
                break;
            case 'low':
                filteredReviews.sort((a, b) => (a.rating || 0) - (b.rating || 0));
                break;
        }

        vm.listReviews.verified.recent = filteredReviews;


        if (!$scope.$$phase) {
            $scope.$apply();
        }

        $('#modal_reviews_filters').modal('hide');

        $timeout(() => {
            const modalReviews = document.querySelector('#modal_reviews');
            if (modalReviews && modalReviews.classList.contains('show')) {

                modalReviews.focus();
                modalReviews.scrollTop = 0;

                modalReviews.style.overflowY = 'auto';
            }

            const modalContent = document.querySelector('#modal_reviews .modal-content');
            if (modalContent) {
                modalContent.scrollTop = 0;
            }

            const modalDialog = document.querySelector('#modal_reviews .modal-dialog');
            if (modalDialog) {
                modalDialog.scrollTop = 0;
            }

            const header = document.querySelector('#modal_reviews .modal__header');
            if (header) {
                header.scrollIntoView({ behavior: 'auto', block: 'start' });
            }

            const firstFilteredReview = document.querySelector('#modal_reviews article:first-child');
            if (firstFilteredReview) {
                firstFilteredReview.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
        }, 500);

        if (filteredReviews.length > 0 && vm.reviewFilters.season !== 'all') {
            const sampleReviews = filteredReviews.slice(0, 3);
            sampleReviews.forEach((review, index) => {
                if (review.stay_date) {
                    let month;
                    if (review.stay_date.includes('-')) {
                        const dateParts = review.stay_date.split('-');
                        month = parseInt(dateParts[1], 10);
                    } else if (review.stay_date.length === 6) {
                        month = parseInt(review.stay_date.substring(4, 6), 10);
                    } else {
                        const stayDate = new Date(review.stay_date);
                        month = !isNaN(stayDate.getTime()) ? stayDate.getMonth() + 1 : 'invalid';
                    }
                }
            });
        }
    };

    vm.resetFilters = () => {
        vm.reviewFilters = {
            order: 'recent',
            season: 'all'
        };

        if (vm.reviewsPagination.lastOrder !== 'recent') {
            vm.resetReviewsState();

            vm.getReviews(vm.hotel.hotelId, true, 1);
            return;
        }

        if (vm.originalReviewsList) {
            vm.listReviews.verified.recent = angular.copy(vm.originalReviewsList);
        }

        if (!$scope.$$phase) {
            $scope.$apply();
        }

        $('#modal_reviews_filters').modal('hide');

        $timeout(() => {
            const modalReviews = document.querySelector('#modal_reviews');
            if (modalReviews && modalReviews.classList.contains('show')) {
                modalReviews.focus();
                modalReviews.scrollTop = 0;
                modalReviews.style.overflowY = 'auto';
                modalReviews.style.pointerEvents = 'auto';

            }

            const modalContent = document.querySelector('#modal_reviews .modal-content');
            if (modalContent) {
                modalContent.scrollTop = 0;
            }

            const modalDialog = document.querySelector('#modal_reviews .modal-dialog');
            if (modalDialog) {
                modalDialog.scrollTop = 0;
            }

            const header = document.querySelector('#modal_reviews .modal__header');
            if (header) {
                header.scrollIntoView({ behavior: 'auto', block: 'start' });
            }

            const firstReview = document.querySelector('#modal_reviews article:first-child');
            if (firstReview) {
                firstReview.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
        }, 500);
    };

    vm.getFilterOrderText = () => {
        switch (vm.reviewFilters.order) {
            case 'recent':
                return lang.reviews_most_recent || 'Los más recientes';
            case 'high':
                return lang.reviews_rating_high_low || 'Puntuación (mayor a menor)';
            case 'low':
                return lang.reviews_rating_low_high || 'Puntuación (menor a mayor)';
            default:
                return lang.reviews_most_recent || 'Los más recientes';
        }
    };

    vm.getStart = (stars) => {
        var htmlStar = "";
        var limit = 5;

        for (var i = 0; i < limit; i++) {
            if (stars > i) {
                if ((stars - i) == 0.5) {
                    htmlStar += "<i class='bi bi-star-half'></i>";
                }
                else {
                    htmlStar += "<i class='bi bi-star-fill'></i>";
                }
            }
            else {
                htmlStar += "";
            }
        }

        return htmlStar;
    }
    vm.goSection = (section, gap = 45, timeOut = 100) => {
        vm.isScrolling = true;
        if (vm.scrollTimeout) clearTimeout(vm.scrollTimeout);

        vm.activeDetailSection = section; // Update active state immediately
        vm.scrollToActiveTab(section);
        var targetId = section;
        var element = document.getElementById(targetId);

        // Fallback for rooms section
        if (!element && section === 'rooms') {
            targetId = 'roomSection';
            element = document.getElementById(targetId);
        }

        if (element) {
            setTimeout(() => {
                var nav = document.getElementById('searchbox');
                var navHeight = nav ? nav.offsetHeight : 0;
                var extraOffset = 16;
                var elementTop = element.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: elementTop - navHeight - extraOffset, behavior: 'smooth' });
            }, timeOut)
        } else {
            $('html, body').scrollTop($(`#${section}`).offset().top - gap);
        }

        vm.scrollTimeout = setTimeout(() => {
            vm.isScrolling = false;
        }, timeOut + 1000);
    }

    vm.goSectCloseModal = (modal, section, gap = 45) => {
        $(`#${modal}`).modal("hide");
        vm.goSection(section)
    }

    vm.showSpecialPrice = (rate) => {
        if (!rate || Object.keys(rate).length === 0) {
            return false;
        }
        return (
            (rate.promotionValue && promotionsBlackList.includes(rate.promotionValue)) ||
            (promotionsBlackList.includes(rate.promotion) && (!rate.bookingDates && !rate.travelDates))
        );
    };
    vm.setLimitRoom = () => {

        if (vm.ratesResponse && vm.ratesResponse.rooms && vm.ratesResponse.rooms.length > 0) {
            const availableRooms = vm.roomsAvailables;
            vm.roomsAvailables = availableRooms;

            // Caso 1: Si hay menos de 5 habitaciones disponibles, mostrar solo las habitaciones disponibles.
            if (availableRooms < 5) {
                vm.showMoreRoomsButton = false; // No mostrar el botón "Ver más habitaciones".
                return availableRooms;
            }
            // Caso 2: Si hay 5 o más habitaciones disponibles, determinar si se expande o se contrae.
            if (availableRooms >= 5) {
                vm.showMoreRoomsButton = availableRooms > vm.limitRoomsFilter; // Mostrar el botón si hay más de 8 habitaciones disponibles.
                return Math.min(availableRooms, vm.limitRoomsFilter);
            }
        }

        // Caso 3: Si no hay ninguna habitación disponible, mostrar solo 1 habitación sin disponibilidad.
        vm.showMoreRoomsButton = false; // No mostrar el botón "Ver más habitaciones".
        return 1;
    }

    vm.getShowPromotion = (rate) => {
        var promotionsToShow = config.promotionKeyShow;
        if (promotionsToShow) {
            var promotionToFind = rate ? promotionsToShow.find(x => x.key == rate.promotionType) : "";
            if (promotionToFind) {
                return promotionToFind.blackFAndHotS;
            }
        }

        return false;
    }
    vm.getPromotionType = (rate) => {
        var promotionsToShow = config.promotionKeyShow;
        if (config.hotelPromotions && Array.isArray(config.hotelPromotions.hotelIds) && config.hotelPromotions.hotelIds.includes(hotel.hotelId)) {
            rate.promotionType = config.hotelPromotions.promotionTypeInt;
            rate.promotion = config.hotelPromotions.promotion;
            return config.hotelPromotions.promotionType;
        }
        if (promotionsToShow) {
            var promotionToFind = rate ? promotionsToShow.find(x => x.key == rate.promotionType) : "";
            if (promotionToFind) {
                if (promotionToFind.blackFAndHotS) {
                    return 'blackandhost';
                }
                if (promotionToFind.isAniversary) {
                    return 'aniversario';
                }
            }
        }

        return null;
    }

    vm.getPromotionTranslation = (promotionText) => {
        return promotionText;
    };
    vm.onSelectRecommenderDate = (e, item) => {
        e.preventDefault();
        e.stopPropagation();

        tracker.selectDateSuggested(item);

        let urlarray = window.location.href.split('?');
        let query = fn.searchUri(urlarray[1]);
        query.checkin = item.CheckIn;
        query.checkout = item.CheckOut;
        let queryString = fn.objectToQueryParams(query);
        window.location.href = urlarray[0] + '?' + queryString;
    }

    vm.selectRateMobile = (rate, roomIndex, rateIndex) => {
        vm.rooms[roomIndex].rate.rate.forEach(function (rate) {
            rate.selected = false;
        });
        vm.rooms[roomIndex].rate.rate[rateIndex].selected = vm.rooms[roomIndex].rate.rate[rateIndex].selected ? true : !vm.rooms[roomIndex].rate.rate[rateIndex].selected;
        vm.rooms[roomIndex].roomRateMobileSelected = rate;
    }
    function loadRoomRatesTrivago() {
        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        } else {
            initialCampaignToken();
        }
        vm.loading = true;
        vm.recomendationsList.loading = true;
        vm.hasCancellationFree = false;
        vm.hasPayLater = false;
        vm.recommendedDates = null;
        vm.checkIn = paramsRoomRates.checkin;
        vm.checkOut = paramsRoomRates.checkout;
        let paramnsRatesClone = { ...paramsRoomRates }
        paramnsRatesClone.rooms = getPaxesTrivago(box.paxes).paxesFormat;
        paramnsRatesClone.CampaignToken = _campaignToken;
        paramnsRatesClone.userKey = _userKey;
        paramnsRatesClone.culture = cultureData.internalCultureCode;
        paramnsRatesClone.mobile = isMobile;
        paramnsRatesClone.login = _isLogin;
        paramnsRatesClone.responseTimeout = 20000;
        paramnsRatesClone.source = box.source ? box.source : "SPA-Hotel-List";
        paramnsRatesClone.channelId = isMobile ? config.chkSourceMobile : config.chkSourceDesktop;


        $http.get(config.endPoints.detailQuoteUrl, { params: paramnsRatesClone, headers: getHeaders() }).then(onSuccessRoomRatesTrivago, (err) => {
            OnErrorTrivago(err);
        });
    }
    function loadRoomRatesUnique(response) {
        vm.recomendationsListUnique = {
            loading: true,
            rooms: [],
            checkoutHash: []
        }
        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        } else {
            initialCampaignToken();
        }
        if (response && response.rooms && response.rooms.length == 0) {
            vm.loading = true;
        }
        vm.checkIn = paramsRoomRates.checkin;
        vm.checkOut = paramsRoomRates.checkout;
        let paramnsRatesClone = { ...paramsRoomRates }
        paramnsRatesClone.rooms = (vm.appicableExperiment || !vm.ApplyFamilyRules) && vm.source_origin.includes('trivago') && box.hasValidPaxes ? getPaxesTrivago(box.paxes).paxesFormat : newPax.paxesFormat;
        paramnsRatesClone.CampaignToken = _campaignToken;
        paramnsRatesClone.userKey = _userKey;
        paramnsRatesClone.culture = cultureData.internalCultureCode;
        paramnsRatesClone.mobile = isMobile;
        paramnsRatesClone.login = _isLogin;
        paramnsRatesClone.isUnique = true;
        paramnsRatesClone.responseTimeout = 20000;
        paramnsRatesClone.source = box.source ? box.source : "SPA-Hotel-List";
        paramnsRatesClone.channelId = isMobile ? config.chkSourceMobile : config.chkSourceDesktop;
        //campo para solo permitir primer recomendacion
        paramnsRatesClone.trivago = vm.source_origin.includes('trivago');


        $http.get(vm.appicableExperiment || !vm.ApplyFamilyRules ? config.endPoints.detailQuoteUrlFam : config.endPoints.detailQuoteUrl, { params: paramnsRatesClone, headers: getHeaders() }).then(onSuccessRoomRatesUnique, (err) => {
            onError(err);
        });
    }
    function getPaxesTrivago(box) {
        let boxLength = box && box.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };
        for (let i = 0; box && i < boxLength; i++) {
            const pax = box[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `|${pax.children.map(it => it.year).join(',')}`;
            }

            paxes.paxesFormat.push(paxFormat);
        }
        return paxes;
    }
    //Get rates rooms
    function loadRoomRates() {

        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        } else {
            initialCampaignToken();
        }

        vm.loading = true;
        vm.hasCancellationFree = false;
        vm.hasPayLater = false;
        vm.roomsAvailables = 0;
        vm.recommendedDates = null;
        vm.checkIn = paramsRoomRates.checkin;
        vm.checkOut = paramsRoomRates.checkout;
        paramsRoomRates.rooms = (vm.appicableExperiment || !vm.ApplyFamilyRules) && vm.source_origin.includes('trivago') && box.hasValidPaxes ? getPaxesTrivago(box.paxes).paxesFormat : newPax.paxesFormat;
        paramsRoomRates.CampaignToken = _campaignToken;
        paramsRoomRates.userKey = _userKey;
        paramsRoomRates.mobile = isMobile;
        paramsRoomRates.login = _isLogin;
        paramsRoomRates.culture = cultureData.internalCultureCode;
        paramsRoomRates.responseTimeout = 20000;
        paramsRoomRates.source = box.source ? box.source : "SPA-Hotel-List";
        paramsRoomRates.channelId = isMobile ? config.chkSourceMobile : config.chkSourceDesktop;
        paramsRoomRates.isOnlyA = vm.onlyAdults;
        //campo para solo permitir primer recomendacion
        paramsRoomRates.trivago = vm.source_origin.includes('trivago');

        if (!!providers) {
            paramsRoomRates.providers = providers;
        }

        if (box.isDefault) {
            paramsRoomRates.isOrganicTraffic = true;
        }

        vm.datesRecommended = [];

        $http.get(vm.appicableExperiment || !vm.ApplyFamilyRules ? config.endPoints.detailQuoteUrlFam : config.endPoints.detailQuoteUrl, { params: paramsRoomRates, headers: getHeaders() }).then(onLoadRatesRequote, (err) => {
            if (!settings.rb) {
                getAvailabilityReasons();
            }
            onError(err);
        });
    }

    function loadSimilarHotels() {
        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        } else {
            initialCampaignToken();
        }

        const pax = formatPax(newPax.paxesFormat);

        let paramsSimilarHotels = {
            IdHotelsBase: hotel.hotelId,
            site: paramsRoomRates.site,
            mobile: isMobile,
            channelId: isMobile ? config.chkSourceMobile : config.chkSourceDesktop,
            userKey: _userKey,
            culture: cultureData.internalCultureCode,
            checkin: paramsRoomRates.checkin,
            checkout: paramsRoomRates.checkout,
            CampaignToken: _campaignToken,
            rooms: newPax.paxesFormat,
            pax: `/${pax}`,
        };

        $http.get(config.endPoints.similarHotelsUrl, { params: paramsSimilarHotels, headers: getHeaders() })
            .then(onSuccessSimilarHotels, onErrorSimilarHotels);
    }

    function formatPax(paxesFormat = []) {
        return paxesFormat.map(item => {
            if (!item.includes('|') && /^[0-9]+$/.test(item)) {
                item += '/n';
            }
            return item.replace(/\|/g, '/');
        }).join('/');
    }

    function onSuccessSimilarHotels(response) {
        if (response && response.data && response.data.hotels) {
            vm.similarHotels = response.data.hotels;

            const nights = vm.getNights();

            vm.similarHotels.forEach(hotel => {
                if (hotel.taxes && hotel.taxes.breakdown && hotel.taxes.breakdown.breakDowns) {
                    hotel.taxes.feesAmountTotal = config.feesIncludes ? hotel.taxes.breakdown.breakDowns
                        .filter(fee => config.breakDownExcludedList.includes(fee.title))
                        .reduce((acc, fee) => acc + fee.amount, 0) : 0;

                    hotel.taxes.feesAmountTotalForNight = config.feesIncludes ? hotel.taxes.feesAmountTotal / nights : 0;
                } else {
                    hotel.taxes.feesAmountTotal = 0;
                    hotel.taxes.feesAmountTotalForNight = 0;
                }
            });
        }
    }

    function onErrorSimilarHotels(error) {
        vm.similarHotels = [];
    }

    vm.buildHotelUrl = (hotel) => {
        let paramsUri = {
            checkin: paramsRoomRates.checkin,
            checkout: paramsRoomRates.checkout,
            source: _paramQuery.source ? _paramQuery.source : "",
            promotions: _paramQuery.promotions
        };

        if (_campaignToken) {
            paramsUri.CampaignToken = _campaignToken;
        }

        if (_paramQuery.coupon) {
            paramsUri.coupon = _paramQuery.coupon;
        }

        let pax = fn.mapPaxToUrl(newPax.paxes);

        let paramsUriConcat = { ...paramsUri, ...pax };

        let query = fn.objectToQueryParams(paramsUriConcat);

        return `${config.siteUrl}${config.pathHotelDetail}${hotel.uri}_a${hotel.hotelId}?${query}`;
    }

    vm.onSimilarHotelClick = (hotel, event) => {
        const position = vm.similarHotels.findIndex(h => h.hotelId === hotel.hotelId) + 1;
        tracker.similarHotelClick(hotel, position);
        return true;
    }

    function loadRatesFromLogin() {

        if (!settings.rb) {
            let paramsLogin = { ...paramsRoomRates };
            paramsLogin.rooms = (vm.appicableExperiment || !vm.ApplyFamilyRules) && vm.source_origin.includes('trivago') && box.hasValidPaxes ? getPaxesTrivago(box.paxes).paxesFormat : newPax.paxesFormat;
            paramsLogin.userKey = null;
            paramsLogin.CampaignToken = null;
            paramsLogin.login = !_isLogin;
            paramsLogin.channelId = isMobile ? (config.channelConfigDefault?.mobileLogin.channelId != 0 ? config.channelConfigDefault.mobileLogin.channelId : paramsLogin.channelId) : (config.channelConfigDefault?.desktopLogin.channelId != 0 ? config.channelConfigDefault.desktopLogin.channelId : paramsLogin.channelId);
            paramsLogin.isOnlyA = vm.onlyAdults;
            //campo para solo permitir primer recomendacion
            paramsLogin.trivago = vm.source_origin.includes('trivago');

            if (!!providers)
                paramsLogin.providers = providers;

            $http.get(vm.appicableExperiment || !vm.ApplyFamilyRules ? config.endPoints.detailQuoteUrlFam : config.endPoints.detailQuoteUrl, { params: paramsLogin, headers: getHeaders() }).then(onLoadRatesFromLogin, (err) => { });
        }


    }
    //REVALIDATE
    function loadRevalidate(rate, pax, roomId, isMobile) {
        paramnsRevalidate.rooms = pax;
        paramnsRevalidate.mobile = isMobile;
        paramnsRevalidate.responseTimeout = 20000;
        paramnsRevalidate.channelId = isMobile ? config.chkSourceMobile : config.chkSourceDesktop;
        paramnsRevalidate.roomId = roomId;
        paramnsRevalidate.isUnique = rate.provider == 109 || rate.provider == 161;
        paramnsRevalidate.CampaignToken = _campaignToken;
        $http.get(config.endPoints.revalidateUrl, { params: paramnsRevalidate, headers: getHeaders() }).then(function (params) {
            rate.loadingAvailibles = false;
            if (params.data.roomsAvailibles > 0) {
                rate.limitAvailibles = params.data.roomsAvailibles;
            } else {
                rate.limitAvailibles = 1;
            }
            if (isMobile) {
                vm.incrementRevalidate(rate);
            }


        }, (err) => {
            rate.loadingAvailibles = false;
            rate.limitAvailibles = 1;
        });
    }
    vm.toggleDropdown = (rate, room) => {
        rate.showDron = !rate.showDron;
        if (rate.showDron) {
            rate.loadingAvailibles = true;
            loadRevalidate(rate, rate.paxFam, room.roomId);
        }
    };
    vm.selectedRateRoom = (rate, selectedRoom, room) => {
        vm.hasErrorHandle = false;
        if (selectedRoom.value > 1 && rate.loadingAvailibles) {
            return;
        }
        rate.showDron = !rate.showDron;
        rate.selectedRoomValue = selectedRoom.value;
        if (selectedRoom.value !== 0) {
            const existingRateIndex = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);

            if (existingRateIndex !== -1) {
                // Si ya existe en vm.stickyRates, actualiza solo selectedRoomValue
                vm.stickyRates[existingRateIndex].selectedRoomValue = selectedRoom.value;
            } else {
                // Si no existe, agrega el objeto al array
                rate.name = room.name;
                rate.roomId = room.roomId;
                rate.img = room.picture.cloudUri;
                vm.stickyRates.push(rate);
            }
        } else {
            const index = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);
            if (index !== -1) {
                // Si existe y selectedRoom.value es 0, elimínalo de vm.stickyRates
                vm.stickyRates.splice(index, 1);
            }
        }
    };
    vm.incrementQuantity = async (rate) => {
        loadRevalidate(rate, rate.paxFam, rate.roomId, true);
    };
    vm.incrementRevalidate = async (rate) => {
        const totalSelected = vm.stickyRates
            .reduce((sum, r) => sum + (r.selectedRoomValue || 0), 0);

        if (totalSelected >= 8) {
            vm.availableLimitMobile = true;
            setTimeout(() => {
                $scope.$applyAsync(() => { vm.availableLimitMobile = false; });
            }, 2000);
            return;
        }

        if (rate.selectedRoomValue + 1 <= rate.limitAvailibles) {
            const existingRateIndex = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);
            if (existingRateIndex !== -1) {
                vm.stickyRates[existingRateIndex].selectedRoomValue += 1;
            }
            // return rate.selectedRoomValue += 1;
        } else {
            vm.availableLimitMobile = true;
            setTimeout(() => {
                $scope.$applyAsync(() => { vm.availableLimitMobile = false; });
            }, 2000);
        }
    }
    vm.decrementQuantity = (rate, room) => {
        const existingRateIndex = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);
        if (rate.selectedRoomValue - 1 == 0) {
            if (existingRateIndex !== -1) {
                vm.stickyRates.splice(existingRateIndex, 1);
            }
            // return rate.selectedRoomValue = 0;
        } else {
            if (existingRateIndex !== -1) {
                vm.stickyRates[existingRateIndex].selectedRoomValue -= 1;
            }
            // return rate.selectedRoomValue -= 1;
        }

    };
    vm.setValueModalRoom = (roomSelect) => {
        vm.selectModalRoom = roomSelect;
        var valueToLoop = vm.assigRateSet.roomsSelectection
        valueToLoop.forEach(item => {
            item.active = false;
            if (item.value == vm.selectModalRoom) {
                item.active = true;
            }

        })
    };
    vm.deleteStickyDetail = (rate, event) => {
        event.stopPropagation();
        const roomRateIndex = vm.stickyRates.findIndex(roomRate => roomRate.rateKey === rate.rateKey && roomRate.paxFam === rate.paxFam);
        if (roomRateIndex !== -1) {
            vm.stickyRates.splice(roomRateIndex, 1);
            const targetRoom = vm.rooms.find(r => r.roomId === rate.roomId);
            if (targetRoom && targetRoom.rate) {
                const roomRateIndexInTargetRoom = targetRoom.rate.rate.findIndex(roomRate => roomRate.rateKey === rate.rateKey && roomRate.paxFam === rate.paxFam);

                if (roomRateIndexInTargetRoom !== -1) {
                    targetRoom.rate.rate[roomRateIndexInTargetRoom].selectedRoomValue = 0;
                }
            }
        }
    };
    vm.selectedRateRoomModal = (rate, room = {}) => {
        let targetRoom;
        if (Object.keys(room).length === 0) {
            // Si room es un objeto vacío, busca la habitación directamente por rate.roomId
            targetRoom = vm.rooms.find(r => r.roomId === rate.roomId);
        } else {
            // Si room tiene valores, úsalo directamente
            targetRoom = room;
        }
        if (targetRoom && targetRoom.rate) {
            const roomRateIndex = targetRoom.rate.rate.findIndex(roomRate => roomRate.rateKey === rate.rateKey && roomRate.paxFam === rate.paxFam);

            if (roomRateIndex !== -1) {
                const selectedRoomValue = vm.selectModalRoom;
                const existingStickyRateIndex = vm.stickyRates.findIndex(stickyRate => stickyRate.rateKey === rate.rateKey && stickyRate.paxFam === rate.paxFam);

                targetRoom.rate.rate[roomRateIndex].selectedRoomValue = selectedRoomValue;

                if (existingStickyRateIndex !== -1) {
                    // Si ya existe en vm.stickyRates, actualiza solo selectedRoomValue
                    vm.stickyRates[existingStickyRateIndex].selectedRoomValue = selectedRoomValue;
                    if (vm.selectModalRoom === 0) {
                        const indexInStickyRates = vm.stickyRates.indexOf(targetRoom.rate.rate[roomRateIndex]);
                        if (indexInStickyRates !== -1) {
                            vm.stickyRates.splice(indexInStickyRates, 1);
                        }
                    }
                } else {
                    // Si no existe, agrega el objeto al array
                    if (selectedRoomValue !== 0) {
                        targetRoom.rate.rate[roomRateIndex].name = room.name;
                        targetRoom.rate.rate[roomRateIndex].roomId = room.roomId;
                        var clonedRate = angular.copy(targetRoom.rate.rate[roomRateIndex]);
                        vm.stickyRates.push(clonedRate);
                    }
                }
            }
        }
    };
    $scope.$watch('vm.stickyRates', function (newStickyRates, oldStickyRates) {
        if (!angular.equals(newStickyRates, oldStickyRates)) {
            updateStickyData(newStickyRates);
        }
    }, true);

    function updateStickyData(stickyRates) {
        vm.totalSticky = 0;
        vm.totalImpSticky = 0;
        vm.totalRoomSticky = 0;
        vm.totalPromoDiscount = 0;
        vm.totalTotalSticky = 0;
        vm.imgSticky = "";
        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        const nightCounts = fn.diffBetweenDays(checkIn, checkOut);
        let totalAdulst = 0;
        let totalChildrens = 0;
        vm.totalHasTaxSticky = false;
        vm.getRecomedationLabelSticky = "";
        vm.getRecomedationDateSticky = "";
        vm.sumTotalSticky = 0;
        vm.applicableRAPDSticky = true;
        vm.applicableMonthsIntereses = true;
        vm.totalFeesIncludes = 0;
        vm.dateRAPDSticky = "";
        vm.isCancelation = false;
        vm.AgesMenors = "";
        vm.totalChildrens = 0;
        vm.ApplicableExclusivePromotion = false;
        const childrenCount = {};
        for (const rate of stickyRates) {
            if (rate.selectedRoomValue) {
                vm.totalRoomSticky += rate.selectedRoomValue;
                vm.totalSticky += (rate.taxes.totalRoomRatePerNight) * rate.selectedRoomValue;
                vm.totalTotalSticky += rate.taxes.totalRoomRate * rate.selectedRoomValue;
                vm.totalHasTaxSticky = rate.taxes.hasTaxes;
                if (rate.taxes.totalTaxesPerRoomPerNight > 0) {
                    vm.totalImpSticky += rate.taxes.totalTaxes * rate.selectedRoomValue;

                }
                vm.imgSticky = rate.img;
                let feesAmountTotal = rate.taxes.feesAmountTotal * rate.selectedRoomValue;
                vm.totalFeesIncludes += feesAmountTotal;
                vm.isDiscount = rate.taxes.discount;
                vm.totalPromoDiscount += rate.taxes.totalRoomRateBeforePromoExclusive * rate.selectedRoomValue;
                const paxFamParts = rate.paxFam.split('|');
                const adults = paxFamParts[0] ? parseInt(paxFamParts[0]) : 0;
                const childs = paxFamParts[1] ? parseInt(paxFamParts[1].split(',').length) : 0;
                totalAdulst += adults * rate.selectedRoomValue;
                totalChildrens += childs * rate.selectedRoomValue;
                vm.AgesMenors += paxFamParts[1] ? vm.AgesMenors ? `,${paxFamParts[1]}` : paxFamParts[1] : "";

                const childrenAges = paxFamParts[1] ? paxFamParts[1].split(',').map(Number) : [];
                childrenAges.forEach(age => {
                    if (childrenCount.hasOwnProperty(age)) {
                        childrenCount[age] += rate.selectedRoomValue;
                    } else {
                        childrenCount[age] = rate.selectedRoomValue;
                    }
                });

                if (rate.collectType == 2) {
                    vm.applicableMonthsIntereses = false;
                }
                if (!(!vm.isBlockRAPD && rate.bookNowPayLaterTimeLimit && rate.isBookNowPayLaterApplicable && rate.collectType != 2 && !rate.unique)) {
                    vm.applicableRAPDSticky = false;
                } else {
                    vm.dateRAPDSticky = rate.bookNowPayLaterTimeLimit;
                    vm.isCancelation = !rate.isNonRefundable && rate.cancellationPolicies.freeCancellationExpire;
                }
            }
        }
        vm.ApplicableExclusivePromotion = stickyRates.every(room => {
            return room.taxes.exclusivePromotion;
        });
        const nightTitle = nightCounts == 1 ? lang.night : lang.nights;
        const adultsTitle = totalAdulst == 1 ? lang.adult : lang.adults;
        const childrenPart = totalChildrens > 0
            ? ` y ${totalChildrens} ${totalChildrens == 1 ? lang.child : lang.children}`
            : '';
        const agesPart = vm.AgesMenors.split(',').length == 1 ? vm.AgesMenors.split(',') == 1 ? lang.year : lang.years : lang.years;
        vm.sumTotalSticky = totalAdulst + totalChildrens;
        const children = totalChildrens > 0 && totalChildrens > 2 ? `${childrenPart}` : totalChildrens > 0 ? `${childrenPart} (${vm.AgesMenors} ${agesPart})` : "";
        const stayDates = vm.getStayDates();
        vm.stayDatesLabel = `${lang.dateFrom} ${stayDates.checkIn} ${lang.dateTo} ${stayDates.checkOut}`;
        vm.getRecomedationLabelSticky = `${vm.totalRoomSticky} ${vm.totalRoomSticky > 1 ? lang.rooms : lang.room}, ${totalAdulst} ${adultsTitle}${children}`;
        vm.getRecomedationDateSticky = `${lang.dateFrom} <span class="font-500">${stayDates.checkIn}</span> ${lang.dateTo} <span class="font-500">${stayDates.checkOut}</span>`;
        vm.newTitleSticky = `${totalAdulst} ${adultsTitle} ${childrenPart}`;
        //compara huespedes
        // Mensaje que indica la selección y compara con la búsqueda
        const totalInSearch = newPax.paxes.adults + newPax.paxes.children.length;
        const totalSelected = totalAdulst + totalChildrens;
        vm.totalChildrens = totalChildrens;
        vm.totalAdults = totalAdulst;
        //Mensaje para familias mobile
        //Falta 1 adulto y 2 menores
        let adultsIncomplete = newPax.paxes.adults - totalAdulst;
        let childrenIncomplete = newPax.paxes.children.length - totalChildrens;
        let childrendImcompletePart = childrenIncomplete > 0 ? `${childrenIncomplete} ${childrenIncomplete == 1 ? lang.child : lang.children}` : "";
        let adultsIncompletePart = adultsIncomplete > 0 ? `${adultsIncomplete} ${adultsIncomplete == 1 ? lang.adult : lang.adults}` : "";
        const totalIncomplete = adultsIncomplete + childrenIncomplete;
        vm.titleStickyImcomplete = totalIncomplete > 0
            ? `${totalIncomplete === 1 ? lang.remaining : lang.remainings} ` +
            `${adultsIncompletePart}` +
            `${childrenIncomplete > 0 ? ' ' + childrendImcompletePart : ''}, ` +
            `${lang.add_more_rooms}`
            : "";
        // Generación del mensaje final
        vm.isIncompletePax = totalSelected < totalInSearch ? formatString(lang.yourSelectionIncludes, totalSelected, totalSelected == 1 ? lang.person : lang.persons, totalInSearch) : "";
        const ageDescriptions = Object.entries(childrenCount)
            .map(([age, count]) => `${count} ${count > 1 ? lang.children : lang.child} ${lang.the} ${age} ${age != 1 ? lang.years : lang.year}`)
            .join(', <br>');
        vm.overViewMinors = ageDescriptions;
        //Procesar totalSelections y roomsSelectection solo si stickyRates tiene datos
        if (vm.stickyRates && vm.stickyRates.length > 0) {
            let totalSelections = 0;
            let totalWhatSelected = 0;
            for (const room of vm.rooms) {
                for (const rate of room.rate.rate) {
                    totalSelections += rate.selectedRoomValue || 0;
                    totalWhatSelected += rate.selectedRoomValue && rate.selectedRoomValue != 0 ? 1 : 0;
                }
            }
            const remainingSelections = 10 - totalSelections;
            for (const room of vm.rooms) {
                room.rate.rate.forEach((rate, index) => {
                    rate.roomsSelectection = Array.from({ length: rate.selectedRoomValue > 0 ? totalWhatSelected == 1 ? 11 : rate.selectedRoomValue + 1 + remainingSelections : remainingSelections + 1 }, (_, index) => ({
                        value: index,
                        selected: index <= room.selectedRoomValue,
                        title: index <= 1 ? lang.room : lang.rooms,
                        total: 0,
                        selectable: index > room.selectedRoomValue || room.selectedRoomValue === 0
                    }));
                });
            }
        } else {
            for (const room of vm.rooms) {
                room.rate?.rate?.forEach((rate, index) => {
                    rate.roomsSelectection = Array.from({ length: 11 }, (_, index) => ({
                        value: index,
                        selected: true,
                        title: index <= 1 ? lang.room : lang.rooms,
                        total: 0
                    }));
                });
            }
        }

    }

    $scope.$watch('vm.stickyRates', function (newStickyRates, oldStickyRates) {
        if (!angular.equals(newStickyRates, oldStickyRates)) {
            updateStickyData(newStickyRates);
        }
    }, true);

    vm.cloneRate = function (rate) {
        return angular.copy(rate);
    };


    function onLoadRatesRequote(value) {
        let dataRates = value.data.rooms;
        let newPax = matchFamilyRule(box.pax, true, true);

        vm.isRequote = false;
        setInfoRooms(paramsRoomRates, newPax);
        if (value.data.rooms.length === 0 && !vm.appicableExperiment && vm.ApplyFamilyRules) {
            newPax = matchFamilyRule(box.pax, true, true);
            let copia_paramsRoomRates = fn.clone(paramsRoomRates);
            copia_paramsRoomRates.rooms = newPax.paxesFormat;
            setInfoRooms(copia_paramsRoomRates, newPax);
            $http.get(vm.appicableExperiment || !vm.ApplyFamilyRules ? config.endPoints.detailQuoteUrlFam : config.endPoints.detailQuoteUrl, { params: copia_paramsRoomRates, headers: getHeaders() }).then(onSuccessGetRatesRequote, onError);
        } else {
            vm.isRequote = false;
            onSuccessRoomRates(value);
        }
    }

    function onSuccessDateRecommended(value) {
        const dataMetric = { ...box, ...hotel, ..._paxes };
        trackerMetric.metricDatesRecommended('show_suggested_dates', { data: dataMetric });
        const language = config.culture.split('-')[0];
        const { data } = value;
        data.forEach(reservation => {
            const formattedCheckin = formatDate(reservation.checkin, language);
            const formattedCheckout = formatDate(reservation.checkout, language);
            const dateDifference = calculateDateDifference(reservation.checkin, reservation.checkout);

            reservation.checkinDayOfWeek = formattedCheckin.dayOfWeek;
            reservation.checkinDayAndMonth = formattedCheckin.dayAndMonth;
            reservation.checkoutDayOfWeek = formattedCheckout.dayOfWeek;
            reservation.checkoutDayAndMonth = formattedCheckout.dayAndMonth;
            reservation.dateDifference = dateDifference;
        });
        vm.datesRecommended = data;
    }

    function onLoadRatesFromLogin(value) {
        roomsLogin = value.data.rooms;

        if (vm.rooms.length) {
            mergeNormalAndLoginRates();
        }

    }

    function mergeNormalAndLoginRates() {

        let factor = _isLogin ? -1 : 1;
        for (let x = 0; x < vm.rooms.length; x++) {
            let room = vm.rooms[x];
            let newRoom = roomsLogin.find(rml => "" + rml.roomId === "" + room.roomId);
            if (newRoom && room.rate) {
                for (let y = 0; y < room.rate.rate.length; y++) {
                    let newrate;
                    let rate = room.rate.rate[y];
                    newrate = newRoom.rate.find(nr => nr.paxFam == rate.paxFam && nr.mealPlanCode == rate.mealPlanCode);
                    if (newrate) {
                        let saved = (rate.taxes.totalRoomRate - newrate.taxes.totalRoomRate) * factor;
                        let discountPercentage = ((saved * 100) / rate.taxes.totalRoomRate);
                        let isValid = discountPercentage > 2 && saved >= fn.thresHold(config.code);
                        if (isValid && !vm.notMessage) {
                            rate.total_saved = saved;
                        }
                    }
                }
            }

        }
    }

    function onSuccessGetRatesRequote(valueRequote) {
        var { rooms } = valueRequote.data;

        let newPax2 = matchFamilyRule(box.pax, true, true);
        newPax2.paxes.rooms = newPax2.paxesFormat.length;
        valueRequote.data.isRequote = true;
        vm.isRequote = true;
        newPaxRequote = newPax2;

        if (!rooms.length) {

            const date = fn.getDate(paramsRoomRates.checkin);
            const params = {
                site: paramsRoomRates.site,
                mobile: paramsRoomRates.mobile,
                hotelId: paramsRoomRates.hotelid,
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                type: 'json',
                channelId: isMobile ? config.chkSourceMobile : config.chkSourceDesktop,
                rooms: vm.appicableExperiment ? newPax.paxesFormat : newPax2.paxesFormat,
                checkin: paramsRoomRates.checkin,
                checkout: paramsRoomRates.checkout,
                userKey: _userKey,
                login: _isLogin,
                source: box.source ? box.source : "SPA-Hotel-List",
                applicable: vm.appicableExperiment || !vm.ApplyFamilyRules
            }
            $http.get(vm.appicableExperiment || !vm.ApplyFamilyRules ? config.endPoints.dateRecommended : config.endPoints.dateRecommended, { params: params, headers: getHeaders() }).then(onSuccessDateRecommended, (err) => { });
        }
        onSuccessRoomRates(valueRequote);

    }

    function setInfoRooms(paramsRoomRates, paxes) {

        let checkIn = fn.getDate(paramsRoomRates.checkin);
        let checkOut = fn.getDate(paramsRoomRates.checkout);
        let nights = fn.diffBetweenDays(checkIn, checkOut);
        let rooms = paramsRoomRates.rooms.length;
        let totalPax = paxes.adults + paxes.children;

        vm.boxData = { rooms, nights, totalPax, checkIn, checkOut };
    }


    //Get Modal Payments
    function onSearchPaymentMethods() {
        if (vm.responsePayment.fixedPayments.length || vm.responsePayment.monthInterestFree.length) { return; }
        let params = {
            channel: config.channel,
            language: cultureData.internalCultureCode,
            currency: cultureData.currency,
            isdeposit: true
        }

        $http.get(config.endPoints.paymentMethodUrl, {
            params: params
        }).then(onSuccessPaymentMethods)

    }

    //Get skillBase
    function getSkillBase() {
        paramsSkillBase.adultQuantity = newPax.adults;
        paramsSkillBase.kidQuantity = newPax.children;
        paramsSkillBase.checkInDate = params.checkIn;
        paramsSkillBase.checkOutDate = params.checkOut;
        paramsSkillBase.site = config.domain;
        paramsSkillBase.placeId = placeContainer.id;
        paramsSkillBase.hotelId = vm.hotel.hotelId;
        paramsSkillBase.stepId = "hotel-detail";
        paramsSkillBase.device = isMobile ? "mobile" : "desktop"
        paramsSkillBase.product = "hotel";
        paramsSkillBase.source = _paramQuery.source ? _paramQuery.source : "";
        paramsSkillBase.user = __pt.user ? "user" : "anonymous";
        paramsSkillBase.country = __pt.culture.country;
        paramsSkillBase.login = _isLogin;


        $http.get(config.endPoints.skillBaseUrl, { params: paramsSkillBase }).then(onSuccessSkillBase);
    }

    //Get availability reasons
    function getAvailabilityReasons() {

        const payload = {
            rid: getRommsIds(),
            checkin: params.checkIn,
            checkout: params.checkOut,
            p: getPaxToMessagesApi()
        };

        $http.post(config.endPoints.availabilityReasonsUrl, payload).then(onSuccessAvailabilityReasons, onErrorAvailabilityReason);
    }
    vm.onBlur = function (rate) {
        $timeout(function () {
            rate.showDron = false;
        });
    };


    //Classifications
    function onSuccessClasifications({ data }) {
        if (!data.length) {
            vm.filteredImages = buildGridGallery(vm.gallery);
            return;
        }

        vm.clasifications = data.map(clasification => ({
            ...clasification,
            isSelected: clasification.name === 'all'
        }))
            .sort((a, b) => {
                if (a.name === 'all') return -1;
                if (b.name === 'all') return 1;
                return a.name.localeCompare(b.name);
            });

        vm.filteredImages = buildGridGallery(vm.clasifications[0].images);
        if (vm.clasifications && vm.clasifications.length > 0) {
            vm.selectedClasificationName = vm.clasifications[0].name;
            vm.selectedClasification(vm.clasifications[0], 0);

            if (vm.clasifications.length == 1) {
                trackCategory.sendEventTracker('Hotel Sin Categorias en Galeria', `fotos:${vm.clasifications[0].images.length}`)
            }
        }
    }


    vm.openSlider = (modal, selected, galleryIndex) => {
        vm.showModal(modal);
        vm.currentSlideIndex = selected;
        vm.clasificationIndex = galleryIndex;

        // Obtener el título de la imagen actual
        if (vm.filteredImages && vm.filteredImages[selected]) {
            vm.currentSlideTitle = vm.filteredImages[selected].description || "";
        } else {
            vm.currentSlideTitle = "";
        }
        $timeout(() => {
            vm.initGalleryCarousel(galleryIndex, true); // true indica que es apertura inicial
        }, 200);
    }

    // Inicializar carrusel de galería
    vm.initGalleryCarousel = (galleryIndex, isInitialOpen = false) => {
        const carousel = document.getElementById('gallery-carousel-filtered');
        if (!carousel) return;

        const track = carousel.querySelector('#gallery-carousel-track-filtered');
        if (!track) return;

        // Actualizar posición inicial sin transición si es apertura inicial
        vm.updateGalleryCarouselPositionFiltered(!isInitialOpen);

        // Si es apertura inicial, restaurar transiciones después de un breve delay
        if (isInitialOpen) {
            $timeout(() => {
                const track = document.getElementById('gallery-carousel-track-filtered');
                if (track) {
                    track.style.transition = 'transform 0.3s ease-in-out';
                }
            }, 100);
        }

        // Configurar centrado inteligente después de que todo esté renderizado
        $timeout(() => {
            vm.setupSmartThumbnailCentering();
        }, 100);

        if (window.CarouselManager) {
            window.CarouselManager.cleanupModalCarousels('slide-gallery-modal');
            window.CarouselManager.initCarousel({
                carouselId: 'gallery-carousel-filtered',
                modalId: 'slide-gallery-modal',
                nextFunction: vm.nextGalleryImage,
                prevFunction: vm.prevGalleryImage,
                scope: $scope,
                minSwipeDistance: 50
            });
        }


    }
    vm.setupSmartThumbnailCentering = () => {
        if (window.innerWidth <= 767) return;

        const container = document.querySelector('#slide-gallery-modal .thumbnails-container');
        if (!container) return;

        const hasScroll = container.scrollWidth > container.clientWidth;

        if (hasScroll) {
            container.style.justifyContent = 'flex-start';
        } else {
            container.style.justifyContent = 'center';
        }
    };

    // Actualizar posición del carrusel de galería
    vm.updateGalleryCarouselPosition = (galleryIndex, useTransition = true) => {
        const track = document.getElementById(`gallery-carousel-track-${galleryIndex}`);
        if (!track) return;

        const translateX = -vm.currentSlideIndex * 100;

        // Aplicar o quitar transición según el parámetro
        if (useTransition) {
            track.style.transition = 'transform 0.3s ease-in-out';
        } else {
            track.style.transition = 'none';
        }

        track.style.transform = `translateX(${translateX}%)`;
    }

    // Nueva función para actualizar posición del carrusel cuando se usan filteredImages
    vm.updateGalleryCarouselPositionFiltered = (useTransition = true) => {
        const track = document.getElementById('gallery-carousel-track-filtered');
        if (!track) return;

        const translateX = -vm.currentSlideIndex * 100;

        // Aplicar o quitar transición según el parámetro
        if (useTransition) {
            track.style.transition = 'transform 0.3s ease-in-out';
        } else {
            track.style.transition = 'none';
        }

        track.style.transform = `translateX(${translateX}%)`;
    }

    vm.selectGalleryImage = (index) => {
        if (!vm.filteredImages || index < 0 || index >= vm.filteredImages.length) return;

        vm.currentSlideIndex = index;
        vm.currentSlideTitle = vm.filteredImages[index].description || "";

        // Navegación directa sin transición para mejor performance
        vm.updateGalleryCarouselPositionFiltered(false);

        // Restaurar transiciones después de un breve delay para futuras navegaciones
        $timeout(() => {
            const track = document.getElementById('gallery-carousel-track-filtered');
            if (track) {
                track.style.transition = 'transform 0.3s ease-in-out';
            }
        }, 50);

        // Usar $timeout para asegurar que el DOM se actualice antes del auto-scroll
        $timeout(() => {
            // Reconfigurar centrado después de cambio de imagen
            vm.setupSmartThumbnailCentering();

            // Disparar auto-scroll de thumbnails
            if (window.CarouselManager) {
                window.CarouselManager.triggerThumbnailAutoScroll('slide-gallery-modal');
            }
        }, 100);
    }


    vm.prevGalleryImage = () => {
        if (!vm.filteredImages || vm.filteredImages.length <= 1) return;

        vm.currentSlideIndex = vm.currentSlideIndex > 0 ? vm.currentSlideIndex - 1 : vm.filteredImages.length - 1;
        vm.currentSlideTitle = vm.filteredImages[vm.currentSlideIndex].description || "";
        vm.updateGalleryCarouselPositionFiltered();

        // Usar $timeout para asegurar que el DOM se actualice antes del auto-scroll
        $timeout(() => {
            // Reconfigurar centrado después de cambio de imagen
            vm.setupSmartThumbnailCentering();

            // Disparar auto-scroll de thumbnails
            if (window.CarouselManager) {
                window.CarouselManager.triggerThumbnailAutoScroll('slide-gallery-modal');
            }
        }, 50);
    }


    vm.nextGalleryImage = () => {
        if (!vm.filteredImages || vm.filteredImages.length <= 1) return;

        vm.currentSlideIndex = vm.currentSlideIndex < vm.filteredImages.length - 1 ? vm.currentSlideIndex + 1 : 0;
        vm.currentSlideTitle = vm.filteredImages[vm.currentSlideIndex].description || "";
        vm.updateGalleryCarouselPositionFiltered();

        // Usar $timeout para asegurar que el DOM se actualice antes del auto-scroll
        $timeout(() => {
            // Reconfigurar centrado después de cambio de imagen
            vm.setupSmartThumbnailCentering();

            // Disparar auto-scroll de thumbnails
            if (window.CarouselManager) {
                window.CarouselManager.triggerThumbnailAutoScroll('slide-gallery-modal');
            }
        }, 50);
    }

    // Obtener el índice de la clasificación seleccionada
    vm.getSelectedClassificationIndex = () => {
        if (!vm.clasifications || vm.clasifications.length === 0) return 0;

        const selectedIndex = vm.clasifications.findIndex(c => c.isSelected);
        return selectedIndex >= 0 ? selectedIndex : 0;
    }


    vm.selectClasification = (selectClasification) => {
        vm.selectedClasificationName = selectClasification;
        vm.isFilterMenuOpen = false;
        const index = vm.clasifications.findIndex(clasification => clasification.name === selectClasification);
        const clasification = vm.clasifications.find(clasification => clasification.name === selectClasification);

        if (index !== -1) {
            vm.clasificationIndex = index;
        }
        vm.selectedClasification(clasification, index);
    };

    vm.getDisplayClasificationName = () => {
        return vm.selectedClasificationName === 'all'
            ? vm.allImagesText
            : vm.selectedClasificationName;
    };

    vm.selectedClasification = (data, index) => {
        vm.clasifications = vm.clasifications.map(clasification => ({
            ...clasification,
            isSelected: clasification.name === data.name,
            loaded: false
        }));

        const foundClasification = vm.clasifications.find(f => f.name == data.name);
        vm.filteredImages = buildGridGallery(foundClasification.images);
        vm.clasificationIndex = index;
        vm.selectedClasificationName = foundClasification.name;

        // Resetear el índice del slide al cambiar de categoría
        vm.currentSlideIndex = 0;
        vm.currentSlideTitle = vm.filteredImages[0]?.description || "";

        // Actualizar posición del carrusel
        vm.updateGalleryCarouselPositionFiltered(false);
    }

    vm.getClasificationByName = (selectedName) => {
        return vm.clasifications.find(c => {
            return c.name === selectedName;
        });
    };


    vm.toggleFilterMenu = () => {
        vm.isFilterMenuOpen = !vm.isFilterMenuOpen;
    };
    vm.validPaxCompleted = () => {
        vm.validPax = vm.rooms.some(room => {
            if (room && !room.rate?.disabled) {
                return room.rate?.rate?.every(rateItem => {
                    const paxFamDistributions = rateItem.paxFam;
                    const [adults, children] = paxFamDistributions.split('|');
                    return !(adults == newPax.adults && (children ? children.split(",").length : 0) == newPax.children);
                });
            }
            return false;
        });
    };

    function hasMeaningfulContent(html) {
        if (!html) return false;

        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        var text = tempDiv.textContent || tempDiv.innerText || '';

        return text.trim().length > 0;
    }
    function onSuccessRoomRatesUnique({ data }) {
        const gallery = hotel.gallery.find(pic => pic && pic.cloudUri && pic.cloudUri.includes(".jpg")) || {};
        const roomsLenght = hotel.rooms.length;
        const mealPlanCodes = new Set();
        vm.recomendationsListUnique = data.recomendations || vm.recomendationsListUnique;
        vm.closeSumary = false;
        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
        const roomsLength = hotel.rooms.length;
        const recomendationsListCopy = [];
        let totalRoomRateForNight = 0;
        const processedRoomIds = new Set();
        for (let i = 0; i < roomsLength; i++) {
            const room = hotel.rooms[i];
            if (processedRoomIds.has(room.roomId)) {
                continue;
            }
            processedRoomIds.add(room.roomId);
            const roomRate = fn.findObject(vm.recomendationsListUnique.rooms, 'roomId', room.roomId);
            if (roomRate && vm.appicableExperiment) {
                const copiedRoom = angular.copy(room);
                const roomImage = copiedRoom.pictures ? copiedRoom.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};
                copiedRoom.instructions = "";
                copiedRoom.capacityList = Array.from({ length: copiedRoom.capacity }, (_, index) => index);
                copiedRoom.picture = copiedRoom.picture || {};
                copiedRoom.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";
                roomRate.rate.taxes.feesAmountTotal = 0;
                roomRate.rate.taxes.feesAmountTotal += config.feesIncludes ? roomRate.rate.taxes?.breakdown?.breakDowns
                    .filter(fee => config.breakDownExcludedList.includes(fee.title))
                    .reduce((acc, fee) => acc + fee.amount, 0) : 0;
                roomRate.rate.taxes.feesAmountTotalForNight = config.feesIncludes ? roomRate.rate.taxes.feesAmountTotal / vm.getNights() : 0;
                copiedRoom.rate = roomRate;
                recomendationsListCopy.push(copiedRoom);

            }
            if (roomRate && !vm.appicableExperiment && !vm.ApplyFamilyRules) {
                const totalRooms = roomRate.totalRooms || 1;
                for (let i = 0; i < totalRooms; i++) {
                    const copiedRoom = angular.copy(room);

                    const roomImage = copiedRoom.pictures ? copiedRoom.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};

                    copiedRoom.instructions = "";
                    copiedRoom.capacityList = Array.from({ length: copiedRoom.capacity }, (_, index) => index);
                    copiedRoom.picture = copiedRoom.picture || {};
                    copiedRoom.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";

                    const rateToAssign = roomRate.listOriginal[i];
                    rateToAssign.taxes.feesAmountTotal = 0;
                    rateToAssign.taxes.feesAmountTotal += config.feesIncludes
                        ? rateToAssign.taxes?.breakdown?.breakDowns
                            .filter(fee => config.breakDownExcludedList.includes(fee.title))
                            .reduce((acc, fee) => acc + fee.amount, 0)
                        : 0;

                    rateToAssign.taxes.feesAmountTotalForNight = config.feesIncludes
                        ? rateToAssign.taxes.feesAmountTotal / vm.getNights()
                        : 0;
                    copiedRoom.rate = rateToAssign;
                    recomendationsListCopy.push(copiedRoom);
                }
            }
        }
        vm.recomendationsListUnique.rooms = recomendationsListCopy;
        vm.recomendationsListUnique.feesAmountTotal = 0;
        if (vm.recomendationsListUnique.rooms && vm.recomendationsListUnique.rooms.length > 0) {
            vm.recomendationsListUnique.feesAmountTotal = config.feesIncludes ? vm.recomendationsListUnique.breakdown?.breakDowns
                .filter(fee => config.breakDownExcludedList.includes(fee.title))
                .reduce((acc, fee) => acc + fee.amount, 0) : 0;
        }
        let firstRoom = [];
        let nuevasHabitaciones = [];
        let applyMore = false;
        if (data.rooms && data.rooms.length > 0) {
            // Guardar la primera habitación
            firstRoom = [data.rooms[0]];
            const responseRoomIds = new Set(firstRoom.map(room => room.roomId));
            const processedRoomIdsTable = new Set();
            const processedRoomIdsTableDuplicate = new Set();
            let notAvailableImg = false;
            for (let i = 0; i < roomsLenght; i++) {
                const room = angular.copy(hotel.rooms[i]);
                if (responseRoomIds.has(room.roomId.toString())) {
                    if (processedRoomIdsTable.has(room.roomId)) {
                        processedRoomIdsTableDuplicate.add(room.roomId);
                        roomRate = {
                            rate: [],
                            disabled: true
                        }
                        room.isRateSelectedMobile = false;
                        room.roomRateMobileSelected = {};
                        continue;
                    }
                    processedRoomIdsTable.add(room.roomId);

                    const roomImage = room.pictures ? room.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};
                    let roomRate = fn.findObject(firstRoom, 'roomId', room.roomId);

                    room.instructions = "";
                    room.capacityList = Array.from(Array(room.capacity).keys());
                    if (!notAvailableImg) {
                        notAvailableImg = !roomImage.cloudUri;
                    }
                    room.picture = room.picture || {};
                    room.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";
                    room.galleryPosition = 1;
                    if (!roomRate) {
                        roomRate = {
                            rate: [],
                            disabled: true
                        }
                        room.isRateSelectedMobile = false;
                        room.roomRateMobileSelected = {};
                    } else {
                        const allRatesValid = roomRate.rate.every(rate => rate.provider == 109 || rate.provider == 161);
                        if (!allRatesValid) {
                            vm.loading = false;
                            vm.loadingUnique = false;
                            vm.recomendationsListUnique = {
                                loading: false,
                                rooms: [],
                                checkoutHash: []
                            }
                            return;
                        } else {
                            room.recommended = roomRate.recommended;
                            room.recommendedRate = roomRate.recommendedRate;
                            room.recommendedRates = roomRate.recommendedRates;
                            applyMore = true;
                            room.instructions = roomRate.rate[0].externalSalesAdvisory || "";
                            roomRate.rate[0].selected = true;
                            initPaymentNow(roomRate);
                            let providerdot = setProviderIdentifier(roomRate.rate[0]);
                            room.expedia = providerdot.expedia;
                            room.derbysoft = providerdot.derbysoft;
                            room.hotelbeds = providerdot.hotelbeds;
                            room.synxis = providerdot.synxis;
                            room.unique = providerdot.unique;
                            room.isRateSelectedMobile = true;
                            room.limitRoom = vm.ratesLimit;
                            room.mealplans = [];
                            room.pax = [];
                            room.paxOrder = [];
                            roomRate.rate = roomRate.rate.sort((a, b) =>
                                (vm.getNumDistriMovil(a.paxFam, true) + vm.getNumDistriMovil(a.paxFam, false)) -
                                (vm.getNumDistriMovil(b.paxFam, true) + vm.getNumDistriMovil(b.paxFam, false))
                            );

                            for (const roomRates of roomRate.rate) {
                                roomRates.selectedRoomValue = 0;
                                roomRates.unique = room.unique;
                                roomRates.roomsSelectection = Array.from({ length: 11 }, (_, index) => ({
                                    value: index,
                                    selected: true,
                                    title: index <= 1 ? lang.room : lang.rooms,
                                    total: 0
                                }));
                                const exists = room.mealplans.some(mp => mp.mealPlanCode === roomRates.mealPlanCode && mp.nonRefundable === roomRates.isNonRefundable && mp.freeCancellationExpire === roomRates.cancellationPolicies.freeCancellationExpire != null);

                                if (!exists) {
                                    room.mealplans.push({
                                        mealPlanCode: roomRates.mealPlanCode,
                                        nonRefundable: roomRates.isNonRefundable,
                                        freeCancellationExpire: roomRates.cancellationPolicies.freeCancellationExpire != null
                                    });
                                }

                                room.pax.push(roomRates.paxFam);
                                room.paxOrder.push(vm.getNumDistriMovil(roomRates.paxFam, true) + vm.getNumDistriMovil(roomRates.paxFam, false));
                            }
                            room.selectedMealplan = room.mealplans[0];
                            room.selectedPax = room.pax[0];
                            room.showMoreRate = false;
                            room.roomRateMobileSelected = roomRate.rate[0]
                            room.paxOrder = room.paxOrder.sort((a, b) => b - a);
                        }
                    }


                    room.selectedRateFam = roomRate.rate[0];
                    roomRate.rate = roomRate.rate.sort((a, b) =>
                        (vm.getNumDistriMovil(b.paxFam, true) + vm.getNumDistriMovil(b.paxFam, false)) -
                        (vm.getNumDistriMovil(a.paxFam, true) + vm.getNumDistriMovil(a.paxFam, false))
                    );
                    room.rate = roomRate;
                    for (const roomRateItem of roomRate.rate) {

                        roomRateItem.taxes.feesAmountTotal = config.feesIncludes ? roomRateItem.taxes?.breakdown?.breakDowns
                            .filter(fee => config.breakDownExcludedList.includes(fee.title))
                            .reduce((acc, fee) => acc + fee.amount, 0) : 0;
                        roomRateItem.taxes.feesAmountTotalForNight = config.feesIncludes ? roomRateItem.taxes.feesAmountTotal / vm.getNights() : 0;
                        mealPlanCodes.add(roomRateItem.mealPlanCode);
                        if (config.hotelPromotionalBadges) {
                            for (const badgeName in config.hotelPromotionalBadges) {
                                if (Array.isArray(config.hotelPromotionalBadges[badgeName]) && config.hotelPromotionalBadges[badgeName].includes(hotel.hotelId)) {
                                    const propertyName = "show" + badgeName.charAt(0).toUpperCase() + badgeName.slice(1);
                                    roomRateItem[propertyName] = true;
                                }
                            }
                        }



                    }

                    room.limitOriginal = room.rate.rate.length;
                    nuevasHabitaciones.push(room);
                }
            }
            const otrasHabitaciones = hotel.rooms;

            let tieneHabitacionUnica = false;
            let mejorPorcentajeAhorro = 0;
            if (otrasHabitaciones.length > 0 && nuevasHabitaciones.length > 0) {
                const hayTarifasParaComparar = otrasHabitaciones.some(existingRoom => existingRoom.rate && existingRoom.rate.rate && existingRoom.rate.rate.length > 0 && !existingRoom.rate.disabled);
                if (!hayTarifasParaComparar) {
                    tieneHabitacionUnica = true;
                } else {
                    // Para cada habitación única, comparar con habitaciones existentes
                    for (const uniqueRoom of nuevasHabitaciones) {
                        if (uniqueRoom.rate && uniqueRoom.rate.rate && uniqueRoom.rate.rate.length > 0 && !uniqueRoom.rate.disabled) {
                            // Tomar el primer rate de la habitación única
                            const primerRateUnique = uniqueRoom.rate.rate[0];

                            if (primerRateUnique && primerRateUnique.taxes && typeof primerRateUnique.taxes.totalRoomRate === 'number') {
                                const paxFamUnique = primerRateUnique.paxFam;
                                const mealPlanUnique = primerRateUnique.mealPlanCode;

                                // Buscar rate de comparación en habitaciones existentes
                                let rateComparacion = null;

                                for (const existingRoom of otrasHabitaciones) {
                                    if (existingRoom.rate && existingRoom.rate.rate && existingRoom.rate.rate.length > 0 && !existingRoom.rate.disabled) {
                                        // Buscar primer rate con mismo paxFam y mealPlanCode
                                        const rateConMismasCaracteristicas = existingRoom.rate.rate.find(rate =>
                                            rate.paxFam === paxFamUnique &&
                                            rate.taxes && typeof rate.taxes.totalRoomRate === 'number'
                                        );

                                        if (rateConMismasCaracteristicas) {
                                            rateComparacion = rateConMismasCaracteristicas.taxes.totalRoomRate;
                                            break; // Usar el primer rate que coincida
                                        }
                                    }
                                }

                                // Si no se encontró rate con mismas características, buscar el más barato de cualquier habitación
                                if (rateComparacion === null) {
                                    for (const existingRoom of otrasHabitaciones) {
                                        if (existingRoom.rate && existingRoom.rate.rate && existingRoom.rate.rate.length > 0 && !existingRoom.rate.disabled) {
                                            const tarifasValidas = existingRoom.rate.rate.filter(rate =>
                                                rate.taxes && typeof rate.taxes.totalRoomRate === 'number'
                                            );

                                            for (const rate of tarifasValidas) {
                                                if (rateComparacion === null || rate.taxes.totalRoomRate < rateComparacion) {
                                                    rateComparacion = rate.taxes.totalRoomRate;
                                                }
                                            }
                                        }
                                    }
                                }

                                // Validar si el rate único es al menos 2% más barato
                                if (rateComparacion !== null) {
                                    const umbralMaximo = rateComparacion * 0.97; // 3% más barato

                                    if (primerRateUnique.taxes.totalRoomRate <= umbralMaximo) {
                                        // Calcular el porcentaje de ahorro
                                        const porcentajeAhorro = ((rateComparacion - primerRateUnique.taxes.totalRoomRate) / rateComparacion) * 100;

                                        // Guardar el mejor porcentaje de ahorro
                                        if (porcentajeAhorro > mejorPorcentajeAhorro) {
                                            mejorPorcentajeAhorro = porcentajeAhorro;
                                        }

                                        tieneHabitacionUnica = true;
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                tieneHabitacionUnica = true;
            }
            if (tieneHabitacionUnica && nuevasHabitaciones && nuevasHabitaciones.length > 0) {
                const habitacionesOrdenadas = [...nuevasHabitaciones, ...otrasHabitaciones];
                hotel.rooms = habitacionesOrdenadas;
                vm.rooms = [...habitacionesOrdenadas];
                vm.roomsAvailables += 1;
                vm.buildMealPlanClasifications();
                vm.setFilteredRooms(vm.rooms || []);
                vm.recomendationsListUnique.loading = false;
                // Pasar el porcentaje de ahorro al tracker
                const porcentajeRedondeado = Math.round(mejorPorcentajeAhorro);
                tracker.setHotelUniqueRooms(porcentajeRedondeado);
            } else if (nuevasHabitaciones && nuevasHabitaciones.length > 0) {
                vm.recomendationsListUnique = {
                    loading: false,
                    rooms: [],
                    checkoutHash: []
                }
                const porcentajeRedondeado = Math.round(mejorPorcentajeAhorro);
                tracker.setHotelNotUniqueRooms(porcentajeRedondeado);
            }
        }
        vm.loading = false;
        vm.recomendationsListUnique.loading = false;
        vm.loadingUnique = false;

    }
    function onSuccessRoomRatesTrivago({ data }) {
        vm.recomendationsTrivago = data.rooms || vm.recomendationsTrivago;
        const isTrivago = vm.isTrivagoRate || vm.source_origin.includes('trivago');
        const gallery = hotel.gallery.find(pic => pic && pic.cloudUri && pic.cloudUri.includes(".jpg")) || {};
        const roomsLength = hotel.rooms.length;
        const recomendationsTrivagoCopy = [];
        const processedRoomIds = new Set();
        for (let i = 0; i < roomsLength; i++) {
            const room = hotel.rooms[i];
            if (processedRoomIds.has(room.roomId)) {
                continue;
            }
            processedRoomIds.add(room.roomId);
            const roomRate = fn.findObject(vm.recomendationsTrivago, 'roomId', room.roomId);
            if (roomRate) {
                const copiedRoom = angular.copy(room);
                const roomImage = copiedRoom.pictures ? copiedRoom.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};
                copiedRoom.instructions = "";
                copiedRoom.capacityList = Array.from({ length: copiedRoom.capacity }, (_, index) => index);
                copiedRoom.picture = copiedRoom.picture || {};
                copiedRoom.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";
                for (const roomRateItem of roomRate.rate) {
                    roomRateItem.taxes.feesAmountTotal = 0;
                    roomRateItem.taxes.feesAmountTotal += config.feesIncludes
                        ? roomRateItem.taxes?.breakdown?.breakDowns
                            .filter(fee => config.breakDownExcludedList.includes(fee.title))
                            .reduce((acc, fee) => acc + fee.amount, 0)
                        : 0;

                    roomRateItem.taxes.feesAmountTotalForNight = config.feesIncludes
                        ? roomRateItem.taxes.feesAmountTotal / vm.getNights()
                        : 0;
                }
                copiedRoom.rate = roomRate;
                recomendationsTrivagoCopy.push(copiedRoom);
            }
        }
        vm.recomendationsTrivago = recomendationsTrivagoCopy;
        vm.recomendationsTrivago.loading = false;
        let trivagoUrl = _paramQuery.room_search || null;
        if (vm.recomendationsTrivago.length > 0 && trivagoUrl && vm.isTrivagoRate) {
            let rateObject = trivagoUrl.split('|').length < 2 ? trivagoUrl.split('%') : trivagoUrl.split('|');
            let indexRoom = vm.recomendationsTrivago.findIndex(x => x.roomId == rateObject[0]);
            if (indexRoom == -1) {
                vm.isTrivagoRate = false;
            } else {
                let indexRate = indexRoom != -1 ? vm.recomendationsTrivago[indexRoom].rate.rate.findIndex(x => x.rateId == rateObject[1]) : null;
                if (indexRate == -1 || indexRate == null) {
                    vm.isTrivagoRate = false;
                } else {
                    var tempRate = JSON.stringify(vm.recomendationsTrivago);
                    tempRate = JSON.parse(tempRate);
                    tempRate = tempRate[indexRoom];
                    tempRate.rate.rate = tempRate.rate.rate.filter(x => x.rateId == rateObject[1]);
                    tempRate.rate.rate.selectedRoomValue = 1;
                    vm.featuredRoom = tempRate;
                    setTimeout(function () {
                        vm.goSection('roomSection', 320)
                    }, 500);
                }
            }
        }else{
            vm.isTrivagoRate = false;
            vm.featuredRoom = {};
        }
    }
    //Get rates handler
    function onSuccessRoomRates({ data }) {
        vm.recomendationsList = data.recomendations || vm.recomendationsList;
        vm.closeSumary = false;
        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
        const gallery = hotel.gallery.find(pic =>
            pic && pic.cloudUri && imageExtensions.some(ext => pic.cloudUri.toLowerCase().endsWith(ext))
        ) || {};
        const roomsLength = hotel.rooms.length;
        const recomendationsListCopy = [];
        let totalRoomRateForNight = 0;
        const processedRoomIds = new Set();
        for (let i = 0; i < roomsLength; i++) {
            const room = hotel.rooms[i];
            if (processedRoomIds.has(room.roomId)) {
                continue;
            }
            processedRoomIds.add(room.roomId);
            const roomRate = fn.findObject(vm.recomendationsList.rooms, 'roomId', room.roomId);
            if (roomRate && vm.appicableExperiment) {
                const copiedRoom = angular.copy(room);
                const roomImage = room.pictures ? room.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};
                copiedRoom.instructions = "";
                copiedRoom.capacityList = Array.from({ length: copiedRoom.capacity }, (_, index) => index);
                copiedRoom.picture = room.picture || {};
                copiedRoom.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";
                roomRate.rate.taxes.feesAmountTotal = 0;
                roomRate.rate.taxes.feesAmountTotal += config.feesIncludes ? roomRate.rate.taxes?.breakdown?.breakDowns
                    .filter(fee => config.breakDownExcludedList.includes(fee.title))
                    .reduce((acc, fee) => acc + fee.amount, 0) : 0;
                roomRate.rate.taxes.feesAmountTotalForNight = config.feesIncludes ? roomRate.rate.taxes.feesAmountTotal / vm.getNights() : 0;
                copiedRoom.rate = roomRate;
                recomendationsListCopy.push(copiedRoom);

            }
            if (roomRate && !vm.appicableExperiment && !vm.ApplyFamilyRules) {
                const totalRooms = roomRate.totalRooms || 1;
                for (let i = 0; i < totalRooms; i++) {
                    const copiedRoom = angular.copy(room);

                    const roomImage = room.pictures ? room.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};

                    copiedRoom.instructions = "";
                    copiedRoom.capacityList = Array.from({ length: copiedRoom.capacity }, (_, index) => index);

                    copiedRoom.picture = room.picture || {};
                    copiedRoom.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";


                    const rateToAssign = roomRate.listOriginal[i];
                    rateToAssign.taxes.feesAmountTotal = 0;
                    rateToAssign.taxes.feesAmountTotal += config.feesIncludes
                        ? rateToAssign.taxes?.breakdown?.breakDowns
                            .filter(fee => config.breakDownExcludedList.includes(fee.title))
                            .reduce((acc, fee) => acc + fee.amount, 0)
                        : 0;

                    rateToAssign.taxes.feesAmountTotalForNight = config.feesIncludes
                        ? rateToAssign.taxes.feesAmountTotal / vm.getNights()
                        : 0;
                    copiedRoom.rate = rateToAssign;
                    recomendationsListCopy.push(copiedRoom);
                }
            }
        }
        // if(!vm.appicableExperiment){
        //     vm.recomendationsList.totalRoomRatePerNight = totalRoomRateForNight / vm.recomendationsList.totalRooms;
        // }

        vm.recomendationsList.rooms = recomendationsListCopy;
        vm.recomendationsList.feesAmountTotal = 0;
        if (vm.recomendationsList.rooms && vm.recomendationsList.rooms.length > 0) {
            vm.recomendationsList.feesAmountTotal = config.feesIncludes ? vm.recomendationsList.breakdown?.breakDowns
                .filter(fee => config.breakDownExcludedList.includes(fee.title))
                .reduce((acc, fee) => acc + fee.amount, 0) : 0;
        }
        const allConditionsMet = Object.values(vm.recomendationsList.rooms).every(room => {

            const rate = !vm.appicableExperiment && !vm.ApplyFamilyRules ? room.rate : room.rate.rate;
            if (rate && rate.bookNowPayLaterTimeLimit && rate.isBookNowPayLaterApplicable && !vm.isBlockRAPD && rate.collectType != 2) {
                return true; // La condición se cumple
            } else {
                return false; // La condición no se cumple
            }
        });


        vm.isRAPDRecomendation = allConditionsMet
        if (!settings.rb) {
            getAvailabilityReasons();
        }
        vm.loading = false;
        vm.recomendationsList.loading = false;
        vm.ratesResponse = data;
        vm.cheaperRoomRate = getCheaperRoomRate(vm.ratesResponse.rooms);
        vm.RateForRAPD = vm.cheaperRoomRate;
        vm.roomsForRAPD = vm.cheaperRoomRate;
        const roomsLenght = hotel.rooms.length;
        const mealPlanCodes = new Set();
        let notAvailableImg = false;
        const processedRoomIdsTable = new Set();
        const processedRoomIdsTableDuplicate = new Set();
        const roomGrouper = new RoomGrouper(hotel, vm.ratesResponse);

        for (let i = 0; i < roomsLenght; i++) {
            const room = hotel.rooms[i];
            if (processedRoomIdsTable.has(room.roomId)) {
                processedRoomIdsTableDuplicate.add(room.roomId);
                roomRate = {
                    rate: [],
                    disabled: true
                }
                room.isRateSelectedMobile = false;
                room.roomRateMobileSelected = {};
                continue;
            }
            processedRoomIdsTable.add(room.roomId);

            const roomImage = room.pictures ? room.pictures.find(pic => pic && pic.cloudUri && pic.cloudUri.length) || {} : {};


            let roomRate = roomGrouper.getRoomRateForRoom(room.roomId);
            room.capacityList = Array.from(Array(room.capacity).keys());

            if (!notAvailableImg) {
                notAvailableImg = !roomImage.cloudUri;
            }
            room.picture = room.picture || {};
            room.picture.cloudUri = roomImage.cloudUri || gallery.cloudUri || "";
            room.galleryPosition = 1;

            if (!roomRate) {
                roomRate = {
                    rate: [],
                    disabled: true
                }
                room.isRateSelectedMobile = false;
                room.roomRateMobileSelected = {};
            } else {
                room.recommended = roomRate.recommended;
                room.recommendedRate = roomRate.recommendedRate;
                room.recommendedRates = roomRate.recommendedRates;
                vm.roomsAvailables += 1;
                room.instructions = roomRate.rate[0].externalSalesAdvisory || "";
                roomRate.rate[0].selected = true;
                initPaymentNow(roomRate);
                let providerdot = setProviderIdentifier(roomRate.rate[0]);
                room.expedia = providerdot.expedia;
                room.derbysoft = providerdot.derbysoft;
                room.hotelbeds = providerdot.hotelbeds;
                room.synxis = providerdot.synxis;
                room.isRateSelectedMobile = true;
                room.limitRoom = vm.ratesLimit;
                room.mealplans = [];
                room.pax = [];
                room.paxOrder = [];
                roomRate.rate = roomRate.rate.sort((a, b) =>
                    (vm.getNumDistriMovil(a.paxFam, true) + vm.getNumDistriMovil(a.paxFam, false)) -
                    (vm.getNumDistriMovil(b.paxFam, true) + vm.getNumDistriMovil(b.paxFam, false))
                );
                for (const roomRates of roomRate.rate) {
                    roomRates.selectedRoomValue = 0;
                    roomRates.roomsSelectection = Array.from({ length: 11 }, (_, index) => ({
                        value: index,
                        selected: true,
                        title: index <= 1 ? lang.room : lang.rooms,
                        total: 0
                    }));
                    const exists = room.mealplans.some(mp => mp.mealPlanCode === roomRates.mealPlanCode && mp.nonRefundable === roomRates.isNonRefundable && mp.freeCancellationExpire === roomRates.cancellationPolicies.freeCancellationExpire != null);

                    if (!exists) {
                        room.mealplans.push({
                            mealPlanCode: roomRates.mealPlanCode,
                            nonRefundable: roomRates.isNonRefundable,
                            freeCancellationExpire: roomRates.cancellationPolicies.freeCancellationExpire != null
                        });
                    }

                    room.pax.push(roomRates.paxFam);
                    room.paxOrder.push(vm.getNumDistriMovil(roomRates.paxFam, true) + vm.getNumDistriMovil(roomRates.paxFam, false));
                }
                room.selectedMealplan = room.mealplans[0];
                room.selectedPax = room.pax[0];
                room.showMoreRate = false;
                room.roomRateMobileSelected = roomRate.rate[0]
                room.paxOrder = room.paxOrder.sort((a, b) => b - a);



            }
            room.selectedRateFam = roomRate.rate[0];
            roomRate.rate = roomRate.rate.sort((a, b) =>
                (vm.getNumDistriMovil(b.paxFam, true) + vm.getNumDistriMovil(b.paxFam, false)) -
                (vm.getNumDistriMovil(a.paxFam, true) + vm.getNumDistriMovil(a.paxFam, false))
            );


            room.rate = roomRate;
            for (const roomRateItem of roomRate.rate) {

                roomRateItem.taxes.feesAmountTotal = config.feesIncludes ? roomRateItem.taxes?.breakdown?.breakDowns
                    .filter(fee => config.breakDownExcludedList.includes(fee.title))
                    .reduce((acc, fee) => acc + fee.amount, 0) : 0;
                roomRateItem.taxes.feesAmountTotalForNight = config.feesIncludes ? roomRateItem.taxes.feesAmountTotal / vm.getNights() : 0;

                mealPlanCodes.add(roomRateItem.mealPlanCode);


            }
            room.limitOriginal = room.rate.rate.length;
        }

        vm.isMsiAvailable = !(data.isMsiAvailable && data.isMsiAvailableMonths.length > 0);
        vm.msiMonthsAllow = data.isMsiAvailableMonths;
        if (vm.isGoSection) {
            setTimeout(function () {
                vm.goSection('roomSection', 350)
            }, 500);
        }

        const tieneCoincidenciaPaxFam = (room) => {
            return room.rate?.rate?.some(r => r.paxFam == newPax.paxesFormat[0]);
        };

        // Obtener las habitaciones del hotel
        let habitacionesFiltradas = { ...hotel };

        // Separar habitaciones con coincidencia y sin coincidencia
        let habitacionesConCoincidencia = habitacionesFiltradas.rooms.filter(tieneCoincidenciaPaxFam);
        let habitacionesSinCoincidencia = habitacionesFiltradas.rooms.filter(room => !tieneCoincidenciaPaxFam(room));
        // Ordenar habitaciones con coincidencia por `lessRate`
        habitacionesConCoincidencia.sort(ordenarPorLessRate);
        // Ordenar habitaciones sin coincidencia por `lessRate`
        habitacionesSinCoincidencia.sort(ordenarPorLessRate);

        // Combinar habitaciones con y sin coincidencia, poniendo las coincidencias al inicio
        habitacionesFiltradas.rooms = [...habitacionesConCoincidencia, ...habitacionesSinCoincidencia];

        // Actualizar las habitaciones del hotel
        hotel.rooms = habitacionesFiltradas.rooms;
        vm.rooms = hotel.rooms;

        // Construir clasificaciones de planes de alimentación
        vm.buildMealPlanClasifications();
        // Inicializar habitaciones filtradas
        vm.setFilteredRooms(vm.rooms || []);


        vm.isBlockRAPD = data.isBlockRAPD;
        if (data.campaignToken && data.campaignToken.length) {
            $location.search('ctInternal', data.campaignToken);
        }
        vm.customLimit = _isBot ? 2 : vm.rooms.length;
        _campaignToken = data.campaignToken;
        if (!(vm.appicableExperiment || !vm.ApplyFamilyRules)) {
            let trivagoUrl = _paramQuery.room_search || null;
            if (vm.rooms.length > 0 && trivagoUrl && vm.isTrivagoRate) {
                let rateObject = trivagoUrl.split('|').length < 2 ? trivagoUrl.split('%') : trivagoUrl.split('|');
                let indexRoom = vm.rooms.findIndex(x => x.roomId == rateObject[0]);
                if (indexRoom == -1) {
                    vm.isTrivagoRate = false;
                } else {
                    let indexRate = indexRoom != -1 ? vm.rooms[indexRoom].rate.rate.findIndex(x => x.rateId == rateObject[1]) : null;
                    if (indexRate == -1 || indexRate == null) {
                        vm.isTrivagoRate = false;
                    } else {
                        var tempRate = JSON.stringify(vm.rooms);
                        tempRate = JSON.parse(tempRate);
                        tempRate = tempRate[indexRoom];
                        tempRate.rate.rate = tempRate.rate.rate.filter(x => x.rateId == rateObject[1]);
                        tempRate.rate.rate.selectedRoomValue = 1;
                        vm.featuredRoom = tempRate;

                        setTimeout(function () {
                            vm.goSection('highligth_rooms', 320)
                        }, 500);
                    }
                }
            }
        }

        tracker = new DetailTracker(newPax.paxes, vm.responseroomsAvailables, vm.rooms);
        tracker.initialLayers(vm.ratesResponse);
        tracker.unavailableHotel(errorMessagesStatus, newPax.paxesFormat);
        tracker.setNotCoordinates(vm.hotel);
        if (vm.rooms.length == 0) {
            vm.roomsAvailLoading = true;
            tracker.setHotelNotRooms();
        }
        if (vm.roomsAvailables > 0) {
            tracker.viewItemListTB([hotel]);
        }
        if (notAvailableImg) {
            //tracker.unavailableHotelImg(vm.roomsAvailables, hotel.hotelId);
        }
        if (processedRoomIdsTableDuplicate && processedRoomIdsTableDuplicate.size > 0) {
            tracker.roomDuplicate(processedRoomIdsTableDuplicate, hotel.hotelId);
        }
        removeElementsSkeleton('hotel_price');
        if (roomsLogin.length) {
            mergeNormalAndLoginRates();
        }
        vm.validPaxCompleted();

        if (!_isBot) {
            loadRoomRatesUnique(vm.ratesResponse);
            if (config.activeSimilarHotels) {
                loadSimilarHotels();
            }
        }
    }


    function setProviderIdentifier(rate) {

        const providers = {
            expedia: '',
            derbysoft: '',
            hotelbeds: '',
            synxis: '',
            unique: ''
        }

        if (rate.provider == 4) {
            providers.expedia = '.';
        } else if (rate.provider == 97) {
            providers.derbysoft = '.';
        } else if (rate.provider == 100) {
            providers.hotelbeds = '.';
        } else if (rate.provider == 130) {
            providers.synxis = '.';
        } else if (rate.provider == 109 || rate.provider == 161) {
            providers.unique = '.';
        }
        return providers;
    }

    let onSuccessSharedRequest = async (data, destino) => {
        sharedGlobalKey = data.data.key;
        sharedGlobalUrl = data.data.url;
        if (destino === "facebook") {
            window.open(config.uriFacebook + config.siteUrl + "/r?data=" + sharedGlobalKey);
        } else if (destino === "whatsapp") {
            window.open(config.uriwhatsapp + config.siteUrl + "/r?data=" + sharedGlobalKey);
        } else {
            const body = document.querySelector('body');
            const area = document.createElement('textarea');
            body.appendChild(area);
            area.value = config.siteUrl + "/r?data=" + sharedGlobalKey;
            area.select();
            document.execCommand('copy');
            body.removeChild(area);
            $(".copied-link").show("fast");
            await fn.sleep(1500);
            $(".copied-link").hide("fast");
        }

    }

    //Payment methods handler
    function onSuccessPaymentMethods(response) {
        const data = response.data || [];
        vm.monthInterestData = data.monthInterestFree;
        const monthInterestFree = data.monthInterestFree ? data.monthInterestFree.options : [];
        const groupedPayments = monthInterestFree.reduce((groups, item) => {
            const maxMonths = Math.max(...item.paymentPlans);
            if (!groups[maxMonths]) {
                groups[maxMonths] = [];
            }
            groups[maxMonths].push(item);
            return groups;
        }, {});
        const sortedEntries = Object.entries(groupedPayments).sort(([keyA], [keyB]) => Number(keyB) - Number(keyA));

        const depositBanks = getDepositBanks(data);
        const depositAccountName = getDepositAccountName(data);
        const depositContactEmail = getDepositContactEmail(data);

        const paymentMethods = {
            fixedPayments: data.fixedPayments
                .map(fixedPayments => fixedPayments.options)
                .reduce((prev, curr) => prev.concat(curr), []),
            monthInterestFree: sortedEntries,
            quotasPayments: data.quotasPayments ? data.quotasPayments.options : [],
            otherPayments: data.otherPayments ? data.otherPayments.options : [],
            depositBanks: depositBanks,
            depositAccountName: depositAccountName,
            depositContactEmail: depositContactEmail,
            loading: false,
            title: data.quotasPayments ? data.quotasPayments.title : "",
            maxmsi: data.monthInterestFree ? data.monthInterestFree.title : ""
        };
        vm.responsePayment = paymentMethods;
    }

    function onErrorShared(response, type = null) {
        vm.pageError.has = true;
        vm.pageError.type = type;
        vm.loading = false;
        vm.reviewsLoadingModal = false;

    }

    function onSuccessReviewsRequest(data, page = 1) {
        var datosReviews = data.data;

        if (datosReviews.verified != null) {
            var sortReviews = data.data.verified.recent.sort((a, b) => new Date(b.date_submitted).getTime() - new Date(a.date_submitted).getTime());
            var filterSinREviews = sortReviews.filter(x => x.text == "" && x.title == "");
            sortReviews = sortReviews.filter(x => x.text != "" || x.title != "");
            sortReviews = sortReviews.concat(filterSinREviews);

            if (page === 1) {

                vm.reviewsPagination.allReviews = sortReviews;
                datosReviews.verified.recent = sortReviews;

                const isFirstLoad = vm.topRecentShortOriginal.length === 0;
                getFirstReviews(datosReviews, isFirstLoad);

                vm.listReviews = datosReviews;
                vm.initReviewsCarousel();

                vm.originalReviewsList = null;
            } else {
                vm.reviewsPagination.allReviews = vm.reviewsPagination.allReviews.concat(sortReviews);
                vm.listReviews.verified.recent = vm.reviewsPagination.allReviews.filter(x => x.text != "" || x.negative_text != "");
            }

            vm.reviewsPagination.hasMore = sortReviews.length === vm.reviewsPagination.pageSize;
        }

        if (datosReviews.ratings != null && page === 1) {
            setTimeout(() => { printScoresReview(datosReviews) }, 300)
        }

        vm.reviewsLoadingModal = false;
        vm.reviewsPagination.loading = false;
    }
    //skillBase handler
    function onSuccessSkillBase(data) {
        let response = data.data;
        if (response.message == _successSkillBase) {
            skillBase = response.result;
            vm.phoneBase = skillBase.did;
            $('.skillbase_p')
                .closest('a')
                .attr('href', `tel:${vm.phoneBase}`);
            $('.skillbase_p').text($filter('tel')(vm.phoneBase));
            vm.isDefaultPhone = skillBase.description.includes('hotelid');
        }
    }

    function getFirstReviews(reviews, isFirstLoad = false) {
        const recent = (reviews?.verified?.recent) || [];

        const normalize = s => (s || '').replace(/\s+/g, ' ').trim();

        const processedReviews = recent
            .map(r => ({ ...r, text_norm: normalize(r.text) }))
            .filter(r => r.text_norm.length >= 100 && parseFloat(r.rating) >= 7)
            .sort((a, b) => new Date(b.date_submitted) - new Date(a.date_submitted))
            .slice(0, 3);

        if (isFirstLoad || vm.topRecentShortOriginal.length === 0) {
            vm.topRecentShort = processedReviews;
            vm.topRecentShortOriginal = angular.copy(processedReviews);
        }
    }

    //AvailabilityReasons handler
    function onSuccessAvailabilityReasons({ data }) {

        const list = data && data.length ? data : [];

        for (let i = 0; i < vm.rooms.length; i++) {
            const room = vm.rooms[i];
            const infoAvailability = fn.findObject(list, 'roomId', room.roomId);
            vm.rooms[i].unavailableStatus = setAvailabilityMessages(infoAvailability);
        }
        if (list.length)
            errorMessagesStatus = list[0].availabilityStatus
        vm.responseroomsAvailables = data;

        if (!vm.isRequote && vm.ratesResponse.rooms && !vm.ratesResponse.rooms.length && config.recommenderDatesActive) {
            getRecommendedDates(list);
        }
    }

    function getRecommendedDates(reasons) {

        let defaultReason = {
            roomID: vm.rooms[0].roomId,
            availabilityStatus: "None",
            availabilityValue: "",
            explanation: "No known problems"
        };

        let data = {
            checkIn: box.checkIn,
            checkOut: box.checkOut,
            availabilityReasons: reasons.length ? reasons : [defaultReason],
            idHotel: hotel.hotelId,
            channelId: config.channelFac,
            token: paramsRoomRates.CampaignToken ? paramsRoomRates.CampaignToken : "",
            adults: _paxes.adults,
            kids: _paxes.children,
            providerId: 1,
            placeIdDestination: place.placeId,
            kidsAge: getAgeKids()
        };

        $http.post(config.endPoints.recommenderDatesUrl, data).then(renderRecomendedDates, errorMessagesStatus);
    }

    function renderRecomendedDates(res) {
        if (res.data) {
            if (res.data.status === 'OK') {
                hotel.checkIn = box.checkIn;
                hotel.checkOut = box.checkOut;
                vm.recommendedDates = res.data.message;
            }
        }
    }

    /*** EN EL HTML ***/
    function transformDescription() {
        if (vm.hotel.description) {
            if (vm.hotel.description.length <= vm.sizeDescriptionString) {
                vm.hotel.shortDescription = vm.hotel.description;
                return;
            }

            vm.hotel.description = vm.hotel.description ? vm.hotel.description.split('\n').map(prf => (prf == "\r" ? '<p></p>' : prf)).join('') : vm.hotel.description;
            vm.hotel.shortDescription = vm.hotel.description.substring(0, vm.sizeDescriptionString) + ' ...';
        }
    }

    function printScoresReview(datosReviews) {
        $(".condition").css({ 'width': datosReviews.ratings?.guest?.condition * 10 + "%" });
        $(".cleanliness").css({ 'width': datosReviews.ratings?.guest?.cleanliness * 10 + "%" });
        $(".service").css({ 'width': datosReviews.ratings?.guest?.service * 10 + "%" });
        $(".comfort").css({ 'width': datosReviews.ratings?.guest?.comfort * 10 + "%" });
        $(".amenities").css({ 'width': datosReviews.ratings?.guest?.amenities * 10 + "%" });
        $(".neighborhood").css({ 'width': datosReviews.ratings?.guest?.neighborhood * 10 + "%" });
    }

    function initialCampaignToken() {
        let campaignTokenApi = _paramQuery.campaignTokenApi || _paramQuery.CampaignTokenApi || _paramQuery.campaigntokenapi || null;
        _campaignToken = _paramQuery.CampaignToken || _paramQuery.campaignToken || campaignTokenApi;
        _campaignId = _paramQuery.CampaignId || _paramQuery.campaignid || null;

        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        }
    }

    function onErrorCategories(response) {
        vm.filteredImages = buildGridGallery(vm.gallery);
        trackCategory.sendEventTracker(`Hotel Sin Categorias en Galeria`, `fotos: 0 | Error API`)
    }


    function onError(response, type = null) {
        vm.pageError.has = true;
        vm.pageError.type = type;
        vm.loadingUnique = false;
        vm.recomendationsList = {
            loading: true,
            rooms: []
        }
        vm.recomendationsListCopy = {
            rooms: []
        }
        vm.recomendationsList.loading = false;
        vm.loading = false;
        vm.cheaperRoomRate.loading = false;
        vm.rooms = vm.rooms.map(room => {
            room.rate = { disabled: true };
            return room;
        });
        removeElementsSkeleton('hotel_price');
    }
    function OnErrorTrivago() {
        vm.isTrivagoRate = false;
        vm.featuredRoom = {};
        vm.recomendationsList = {
            loading: true,
            rooms: []
        }
        vm.recomendationsListCopy = {
            rooms: []
        }
    }

    function onErrorAvailabilityReason(response) {
        console.log(response);
    }

    function caruosel() {

        let options = {
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: 0,
            centerMode: false,
            variableWidth: false,
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        variableWidth: true,

                    }
                },
                {
                    breakpoint: 432,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,

                    }
                }
            ]
        };
        slickOptionsFire(options, "#carousel-restaurants");
    }

    function slickOptionsFire(options, div) {
        if ($(div).length == 0) {
            return;
        }
        var triggerAtY = $(div).offset().top - $(window).outerHeight();
        if (triggerAtY < $(window).scrollTop()) {
            $(div).slick(options);
            $(div).removeClass("visibility-none")
            return;
        }
        $(window).scroll(function (event) {
            if (triggerAtY > $(window).scrollTop()) {
                return;
            }
            $(div).slick(options);
            $(div).removeClass("visibility-none")
            $(this).off(event);
        });
    }

    vm.getPathToList = () => {
        let uri = "";
        const queryString = { ...$location.search() };

        if (!queryString.checkout) queryString.checkout = box.checkOut;
        if (!queryString.checkin) queryString.checkin = box.checkIn;

        if (hotel.hotelId) {
            queryString.profileId = hotel.hotelId.toString();
        }

        if (placeContainer && placeContainer.uri) {
            uri = `${config.siteUrl}${config.pathHoteles}${placeContainer.uri}_d${placeContainer.id}?${$.param(queryString)}`;
        } else {
            const displayText = hotel.location.state
                ?.normalize('NFD')
                .replace(/[^a-zA-Z0-9 ]/g, '')
                .replace(/\s+/g, '-')
                .toLowerCase();

            uri = `${config.siteUrl}${config.pathHoteles}${displayText}_d0?${$.param(queryString)}`;
        }

        return uri;
    };

    function getPaxes() {
        let boxLength = box.pax && box.pax.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };
        for (let i = 0; box.pax && i < boxLength; i++) {
            const pax = box.pax[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}`;

            if (pax.children && pax.children.length) {
                paxFormat += '|';
                paxes.children += pax.children.length;
                paxFormat += `${pax.children.map(it => it.year).join(',')}`;
            }

            paxes.paxesFormat.push(paxFormat);
        }
        return paxes;
    }

    function getPaxesRates() {
        let boxLength = box.pax && box.pax.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };
        for (let i = 0; box.pax && i < boxLength; i++) {
            const pax = box.pax[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `|${pax.children.map(it => it.year).join(',')}`;
            }

            paxes.paxesFormat.push(paxFormat);
        }
        return paxes;
    }

    function orderByRate(room) {
        let value = null;

        if (room && room.rate && !room.rate.disabled) {
            value = room.rate.lessRate;
        }

        return value;
    }

    function initPaymentNow(roomRate) {
        const ratesLenght = roomRate.rate.length
        for (var i = 0; i < ratesLenght; i++) {
            const rate = roomRate.rate[i];
            rate.paymentNow = false;

            if (!vm.hasCancellationFree) {
                vm.hasCancellationFree = !rate.isNonRefundable;
            }

            if (!vm.hasPayLater && rate.isBookNowPayLaterApplicable) {
                vm.hasPayLater = rate.isBookNowPayLaterApplicable;
            }
        }
    }

    function getCheaperRoomRate(rooms) {
        if (!rooms || rooms.length <= 0) {
            return {
                messages: "",
                disabled: true,
                loading: false
            };
        }
        let rate = {
            messages: "",
            disabled: true,
            loading: false
        }
        let rateParamns = _paramQuery.room_search || null;
        if (rateParamns && vm.isTrivagoRate) {
            let rateObject = rateParamns.split('|').length < 2 ? rateParamns.split('%') : rateParamns.split('|');
            let preRate = rooms.filter(x => x.roomId == rateObject[0]);
            let rateObt = preRate && preRate.length > 0 ? preRate[0].rate.filter(x => x.rateId == rateObject[1]) : null;
            rate = rateObt && rateObt.length > 0 ? rateObt[0] : rooms[0].rate[0];
            rate.disabled = false;
            rate.loading = false;
        }
        else if (rooms && rooms.length && rooms[0].rate && rooms[0].rate.length) {
            rate = rooms[0].rate[0];
            rate.disabled = false;
            rate.loading = false;
        }

        return rate;
    }

    function getValuesDefaults() {
        return {
            CampaignToken: _campaignToken,
            CampaignId: _campaignId,
        }
    }

    function getRommsIds() {
        return hotel.rooms.map(room => room.roomId);
    }

    function setAvailabilityMessages(statusData) {

        const messagesObj = ln.availabilityMessages;
        try {


            if (!statusData) {
                return {
                    explanation: '',
                    availabilityValue: '',
                    availabilityStatus: 'None',
                    messages: messagesObj.none
                };
            }

            let status = statusData.availabilityStatus.toLocaleLowerCase();

            if (status == 'roomcapacity' && box && box.pax) {
                const roomCapacity = JSON.parse(statusData.availabilityValue);

                if (box.pax.some(room => room.adults + room.children.length > roomCapacity.Max)) {
                    status = "peoplemax";
                } else if (box.pax.some(room => room.adults > roomCapacity.A)) {
                    status = "adultsmax";
                } else if (box.pax.some(room => room.children.length > roomCapacity.K)) {
                    status = roomCapacity.K < 1 ? "kidszero" : "kidsmax";
                } else {
                    status = "peoplemax";
                }
            }

            const newStatus = {
                ...statusData,
                messages: messagesObj[`${status}`]
            }

            if (status != 'none') {
                newStatus.messages.title2 = newStatus.messages.title2.replace('{{days}}', +statusData.availabilityValue || messagesObj.defaults[status]);
            }
            newStatus.messages.needhelp = messagesObj.needhelp;
            return newStatus;

        } catch (error) {
            return {
                explanation: '',
                availabilityValue: '',
                availabilityStatus: 'None',
                messages: messagesObj.none
            };
        }

    }

    function getPaxToMessagesApi() {
        return newPax.paxesFormat.map(rm => {
            const parts = rm.split('|');
            const adults = parts[0];
            const children = parts.length > 1 ? parts[1].split(',').join('_') : '';
            return `${adults}${children ? '_' : ''}${children}`;
        });
    }

    function initStickySearchBox() {
        const el = document.querySelector('#searchbox');
        if (el) {
            const observer = new IntersectionObserver(
                ([e]) => e.target.classList.toggle('is-stuck', e.intersectionRatio < 1),
                { threshold: [1], rootMargin: '-1px 0px 0px 0px' }
            );
            observer.observe(el);
        }
    }

    function initScrollSpy() {
        const sections = ['amenities', 'rooms', 'roomSection', 'amenities3', 'reviews', 'ImportantInfo', 'location'];
        const sectionMapping = {
            'roomSection': 'rooms'
        };
        const observerOptions = {
            root: null,
            rootMargin: '-180px 0px -60% 0px',
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // When section enters the top area of the viewport
                if (entry.isIntersecting && !vm.isScrolling) {
                    $scope.$applyAsync(() => {
                        const activeId = sectionMapping[entry.target.id] || entry.target.id;
                        vm.activeDetailSection = activeId;
                        vm.scrollToActiveTab(activeId);
                        // Compatibility with headTabs
                        if (vm.headTabs[activeId]) {
                            vm.headTabs.current = '#' + activeId;
                        }
                    });
                }
            });
        }, observerOptions);

        // Track sections
        const observeElements = () => {
            sections.forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    observer.observe(el);
                }
            });
        };

        observeElements();

        // Retry after a short delay to catch elements that might have been delayed by angular rendering
        $timeout(observeElements, 2000);

        $scope.$on('$destroy', () => {
            observer.disconnect();
        });
    }

    vm.scrollToActiveTab = function (sectionId) {
        $timeout(() => {
            const activeBtn = document.getElementById(`nav-section-${sectionId}`);
            const list = document.querySelector('.detail-nav__list');
            if (activeBtn && list) {
                const listRect = list.getBoundingClientRect();
                const btnRect = activeBtn.getBoundingClientRect();
                const currentScroll = list.scrollLeft;
                const btnOffsetLeft = btnRect.left - listRect.left;
                const targetScrollLeft = currentScroll + btnOffsetLeft - (listRect.width / 2) + (btnRect.width / 2);

                list.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
            }
        }, 100);
    };

    function setRecentDestination(hotel) {
        SearchHistory.createOrUpdateHotel(hotel, place, box);
    }

    function removeElementsSkeleton(className) {
        let elements = $(`.${className}`);
        if (elements.length) {
            elements.remove();
        }
    }

    function smoothZoom(map, max, cnt) {
        if (cnt >= max) {
            return;
        }
        else {
            let listener = google.maps.event.addListener(map, 'zoom_changed', function (event) {
                google.maps.event.removeListener(listener);
                smoothZoom(map, max, cnt + 1);
            });
            setTimeout(function () { map.setZoom(cnt) }, 80);
        }
    }

    function getAgeKids() {
        return (box.pax[0].children.map(item => item.year)).join(',');
    }

    function filterServicesByCharge(services) {
        var servicesHasCharge = services && services.filter(item => item.hasExtraCharge === true);
        var servicesNotHasCharge = services && services.filter(item => item.hasExtraCharge === false);

        return {
            servicesHasCharge: servicesHasCharge,
            servicesNotHasCharge: servicesNotHasCharge
        };
    }
    function getRestMobile(overflow) {
        if (overflow) {
            document.body.classList.add("modal-open");
        } else {
            var anyModalOpen = document.querySelectorAll('.modal.show').length > 0;
            if (!anyModalOpen) {
                document.body.classList.remove("modal-open");
            }
        }
    }
    function formatString(template, ...args) {
        return template.replace(/{(\d+)}/g, (match, index) => args[index] || '');
    }
    vm.toggleServicesSection = function (sectionId) {
        vm.openServicesSections[sectionId] = !vm.openServicesSections[sectionId];
    };
    vm.isServicesSectionOpen = function (sectionId) {
        return !vm.openServicesSections[sectionId];
    };
    vm.selectNearbyPlacesCategory = function (index) {
        vm.nearbyPlacesCategory = index;
    };

    init();

    //CONTADOR DETALLE DE OFERTA
    vm.digits = {
        h1: { val: '0', prev: '0', anim: false, temp: false },
        h2: { val: '0', prev: '0', anim: false, temp: false },
        m1: { val: '0', prev: '0', anim: false, temp: false },
        m2: { val: '0', prev: '0', anim: false, temp: false },
        s1: { val: '0', prev: '0', anim: false, temp: false },
        s2: { val: '0', prev: '0', anim: false, temp: false }
    };

    function updateDigit(key, newValue, isFirstRun) {
        var d = vm.digits[key];
        if (isFirstRun) {
            d.val = newValue;
            d.prev = newValue;
            return;
        }

        if (d.val !== newValue) {
            d.temp = true;
            d.prev = d.val;
            d.val = newValue;

            d.anim = false;
            $timeout(function () {
                d.temp = false;
                d.anim = true;
            }, 50);
        }
    }

    function tick(isFirstRun) {
        var now = new Date();
        var targetDate = new Date();

        if (vm.campaignObj && vm.campaignObj.endDate) {
            var parsedEnd = new Date(vm.campaignObj.endDate);
            if (!isNaN(parsedEnd.getTime())) {
                targetDate = parsedEnd;
            }
        }

        var diff = targetDate - now;

        if (diff <= 0) {
            diff = 0;
        }

        var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((diff % (1000 * 60)) / 1000);
        var hStr = ("0" + h).slice(-2);
        var mStr = ("0" + m).slice(-2);
        var sStr = ("0" + s).slice(-2);

        updateDigit('h1', hStr[0], isFirstRun);
        updateDigit('h2', hStr[1], isFirstRun);
        updateDigit('m1', mStr[0], isFirstRun);
        updateDigit('m2', mStr[1], isFirstRun);
        updateDigit('s1', sStr[0], isFirstRun);
        updateDigit('s2', sStr[1], isFirstRun);
    }

    tick(true);

    var stopTime = $interval(function () {
        tick(false);
    }, 1000);
    $scope.$on('$destroy', function () {
        if (angular.isDefined(stopTime)) {
            $interval.cancel(stopTime);
        }
    });
}


const ordenarPorLessRate = (a, b) => {
    const lessRateA = a.rate?.lessRate;
    const lessRateB = b.rate?.lessRate;
    const tieneLessRateA = lessRateA !== undefined && !a.rate.disabled;
    const tieneLessRateB = lessRateB !== undefined && !b.rate.disabled;
    if (tieneLessRateA && !tieneLessRateB) {
        return -1;
    } else if (!tieneLessRateA && tieneLessRateB) {
        return 1;
    } else if (tieneLessRateA && tieneLessRateB) {
        return lessRateA - lessRateB;
    } else {
        return 0;
    }
};
